// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**========================= [[ 공통 ]] =========================**/
@keyframes transBGColor {
    0% {
        background: white;
        color: rgb(var(--color-slate-500) / var(--tw-text-opacity));
    }

    100% {
        background: #064e3b;
        color: white;
    }
}

input::placeholder {
    font-size: 12px;
}

.top-bar-boxed {
    display: none;
}

.content {
    min-height: calc(100dvh - 67px);
    /* min-height: auto; */
    /* margin-top: 4.5rem; */
    margin-top: 52px;
    /* border-radius: 1.25rem; */
}

.content:before {
    display: none;
}

.text-ovreflow {
    word-break: break-all;
    word-wrap: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

/* top */
.dropdown-user-info {
    z-index: 9999;
    /* inset: 0 auto auto 0; */
    /* visibility: hidden; */
    position: absolute;
    /* opacity: 0; */
    width: 170px;
    margin: 0;
    top: 42px;
    right: 0px;
    /* transform: translate(-192px, 53px); */
}

.dropdown-alarm {
    z-index: 9999;
    position: absolute;
    width: 170px;
    margin: 0;
    top: 42px;
    right: 85px;
    background: rgb(255, 255, 255);
    box-shadow: rgba(0, 0, 0, 0.04) 0px 0.25rem 0.5rem;
    border: 2px solid #dfdfdf;
    border-radius: 10px;
}

.notification .notification__icon {
    width: 1.5rem;
    height: 1.5rem;
}

.notification_list {
    z-index: 9999;
    inset: 0 auto auto 0;
    visibility: hidden;
    position: absolute;
    opacity: 1;
    width: 224px;
    margin: 0;
    transform: translate(-166px, 53px);
}

.notification_list .show>.dropdown-content {
    margin-top: .25rem;
}

.notification_list .dropdown-content {
    transition: margin-top .2s;
    box-shadow: 0 3px 10px #00000017;
    position: relative;
    width: 100%;
    border-radius: .375rem;
    padding: .5rem;
}

.dropdown-user-info .show>.dropdown-content {
    margin-top: .25rem;
}

.dropdown-user-info .dropdown-content {
    transition: margin-top .2s;
    box-shadow: 0 3px 10px #00000017;
    position: relative;
    width: 100%;
    border-radius: .375rem;
    padding: .5rem;
}

.dropdown-user-info .dropdown-content .dropdown-item {
    display: flex;
    align-items: center;
    border-radius: .375rem;
    padding: .5rem;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
    transition-duration: 300ms;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.notification_list .dropdown-content .dropdown-item {
    display: flex;
    align-items: center;
    border-radius: .375rem;
    padding: .5rem;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
    transition-duration: 300ms;
}

.dropdown-user-info.show {
    visibility: visible;
    opacity: 1;
}

.notification_list.show {
    visibility: visible;
    opacity: 1;
}


/*----------------------------------admin----------------------------------------*/

.calc-table>div {
    padding-bottom: 33px
}

.calc-wrap span {
    display: inline-block;
}

.calc-wrap .calc-cnt {
    vertical-align: super;
}

.calc-wrap .calc-item {
    vertical-align: top;
}

.calc-wrap .calc-title {
    width: 100px
}

.switch {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 20px;
}

.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: .4s;
}

.slider:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 17px;
    left: 2px;
    bottom: 1px;
    background-color: white;
    transition: .4s;
}

input:checked+.slider {
    background-color: #064E3B;
}

input:focus+.slider {
    box-shadow: 0 0 1px #2196F3;
}

input:checked+.slider:before {
    transform: translateX(20px);
}

.fa-regular {
    font-size: 1.125rem;
}

/* Rounded sliders */
.slider.round {
    border-radius: 34px;
}

.slider.round:before {
    border-radius: 50%;
}

.tabulator-paginator {
    margin-left: 40%;
}

.tabulator-row .tabulator-cell {
    /* height: 2.5rem !important; */
    line-height: 1rem !important;
}


/*----------------------------------franchise----------------------------------------*/
.switch {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 20px;
}

.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: .4s;
}

.slider:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 17px;
    left: 2px;
    bottom: 1px;
    background-color: white;
    transition: .4s;
}

input:checked+.slider {
    background-color: #064E3B;
}

input:focus+.slider {
    box-shadow: 0 0 1px #2196F3;
}

input:checked+.slider:before {
    transform: translateX(20px);
}

/* Rounded sliders */
.slider.round {
    border-radius: 34px;
}

.slider.round:before {
    border-radius: 50%;
}

.tabulator-paginator {
    margin-left: 40%;
}





/* 내부 콘텐츠 */
.invitation .btn-group {
    width: auto;
}

.invitation .btn-send-msg {
    text-align: center;
    z-index: 99999;
}

.invitation .merchant-send-list-box {
    cursor: pointer;
    width: auto;
    height: 2.375rem;
}

.invitation .dropdown-menu {
    position: absolute;
    display: block;
    border-radius: .375rem;
    border: solid 1px #e5e7eb;
    background: #fff;
    top: 2rem;
    left: -.8125rem;
    right: -2.0625rem;
    height: 40vh;
    padding-bottom: .75rem;
    overflow: scroll;
    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;
    /* Firefox */
}

.invitation .dropdown-menu::-webkit-scrollbar {
    display: none;
    /* Chrome, Safari, Opera*/
}

.invitation .dropdown-menu button {
    display: block;
    width: 100%;
    padding: .375rem .75rem;
}

.invitation .dropdown-menu .multiselect-filter {
    position: sticky;
    top: 0;
    margin-bottom: .75rem;
    border-bottom: .0625rem solid #e5e7eb;
}

.invitation .dropdown-menu .multiselect-filter input {
    padding: .625rem .875rem;
    border: none;
}

.invitation .dropdown-menu .multiselect-filter input:focus {
    box-shadow: none;
}

.invitation .form-check {
    padding: 0 !important;
    margin-right: 1rem;
    width: max-content;
}

.invitation .multiselect-container .multiselect-option.active:not(.multiselect-active-item-fallback),
.invitation .multiselect-container .multiselect-group.active:not(.multiselect-active-item-fallback),
.invitation .multiselect-container .multiselect-all.active:not(.multiselect-active-item-fallback),
.invitation .multiselect-container .multiselect-option:not(.multiselect-active-item-fallback):active,
.invitation .multiselect-container .multiselect-group:not(.multiselect-active-item-fallback):active,
.invitation .multiselect-container .multiselect-all:not(.multiselect-active-item-fallback):active {
    background-color: #fff !important;
}


/*스위치 슬라이더*/
.invitation .switch {
    position: relative;
    display: block;
    width: 40px;
    height: 20px;
    margin-top: 8px;
    text-align: center;
    margin: 0 auto;
}

.invitation .switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.invitation .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: .4s;
}

.invitation .slider:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 17px;
    left: 2px;
    bottom: 1px;
    background-color: white;
    transition: .4s;
}

.invitation input:checked+.slider {
    background-color: #064E3B;
}

.invitation input:focus+.slider {
    box-shadow: 0 0 1px #2196F3;
}

.invitation input:checked+.slider:before {
    transform: translateX(20px);
}

.invitation .slider.round {
    border-radius: 34px;
}

.invitation .slider.round:before {
    border-radius: 50%;
}

/*데이트 피커*/
.invitation .is-end-date {
    background-color: #064E3B !important;
}


/*----------------------------------admin----------------------------------------*/
/*타이틀*/
.admin-title {
    margin-top: 1.5rem;
    margin-left: 1.5rem;
}

.admin-title-header {
    font-weight: 800;
    font-size: 1.5rem;
    line-height: 1.75rem;
}

/*검색 영역*/
.admin-search-box {
    flex-wrap: wrap;
    padding-bottom: 3rem;
}

.merchant-list-search {
    height: 40px;
}

.multiple-select {
    width: 72%;
}


/*리스트 영역*/
.tabulator-paginator {
    margin-left: 40%;
}

.merchant-search-list-box {
    cursor: pointer;
    width: auto;
    height: 2.375rem;
}

.btn-group {
    width: 7rem;
    height: 17px;
    overflow: hidden;
}

.merchant-search-list-box .dropdown-menu {
    position: absolute;
    display: block;
    border-radius: .375rem;
    border: solid 1px #e5e7eb;
    background: #fff;
    top: 2rem;
    left: -.8125rem;
    right: -2.0625rem;
    height: 40vh;
    padding-bottom: .75rem;
    overflow: scroll;
    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;
    /* Firefox */
}

.merchant-search-list-box .dropdown-menu::-webkit-scrollbar {
    display: none;
    /* Chrome, Safari, Opera*/
}

.merchant-search-list-box .dropdown-menu button {
    display: block;
    width: 100%;
    padding: .375rem .75rem;
}

.merchant-search-list-box .dropdown-menu .multiselect-filter {
    position: sticky;
    top: 0;
    margin-bottom: .75rem;
    border-bottom: .0625rem solid #e5e7eb;
}

.merchant-search-list-box .dropdown-menu .multiselect-filter input {
    padding: .625rem .75rem;
    border: none;
}

.merchant-search-list-box .dropdown-menu .multiselect-filter input:focus {
    box-shadow: none;
}

.merchant-list-box .dropdown-menu {
    position: absolute;
    display: block;
    border-radius: .375rem;
    border: solid 1px #e5e7eb;
    background: #fff;
    top: 2rem;
    left: -.8125rem;
    right: -2.0625rem;
    height: 40vh;
    padding-bottom: .75rem;
    overflow: scroll;
    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;
    /* Firefox */
}

.merchant-list-box .dropdown-menu::-webkit-scrollbar {
    display: none;
    /* Chrome, Safari, Opera*/
}

.merchant-list-box .dropdown-menu button {
    display: block;
    width: 100%;
    padding: .375rem .75rem;
}

.merchant-list-box .dropdown-menu .multiselect-filter {
    position: sticky;
    top: 0;
    margin-bottom: .75rem;
    border-bottom: .0625rem solid #e5e7eb;
}

.merchant-list-box .dropdown-menu .multiselect-filter input {
    padding: .625rem .75rem;
    padding-left: 1.125rem;
    border: none;
}

.merchant-list-box .dropdown-menu .multiselect-filter input:focus {
    box-shadow: none;
}

.form-check {
    padding: 0 !important;
    margin-right: 1rem;
    width: max-content;
}



.multiselect-container .multiselect-option.active:not(.multiselect-active-item-fallback),
.multiselect-container .multiselect-group.active:not(.multiselect-active-item-fallback),
.multiselect-container .multiselect-all.active:not(.multiselect-active-item-fallback),
.multiselect-container .multiselect-option:not(.multiselect-active-item-fallback):active,
.multiselect-container .multiselect-group:not(.multiselect-active-item-fallback):active,
.multiselect-container .multiselect-all:not(.multiselect-active-item-fallback):active {
    background-color: #fff !important;
}

.admin-modal-sty {
    max-height: 80vh;
    overflow: auto;
}

/*--------------------------------receipt----------------------------------------*/
img,
fieldset,
iframe {
    border: 0 none;
    vertical-align: top;
}

#header {
    position: relative;
    border-bottom: 2px solid #696a6b;
    padding-bottom: 10px;
}

#header h1 {
    position: absolute;
    top: -3px;
    right: 0;
}

#header h2 {
    color: #696a6b;
    font-size: 18px;
    font-family: '돋움';
}

.selectBox {
    padding: 10px 0 24px 0;
}

.selectBox select {
    font-size: 14px;
    font-weight: bold;
    height: 29px;
    line-height: 29px;
    padding: 0 0 0 6px;
    border-radius: 3px;
}

.list-info-box h3 {
    color: #fff;
    font-size: 14px;
    background: #898a8c;
    border-radius: 5px 5px 0 0;
    padding: 0 15px;
    display: inline-block;
    height: 27px;
    line-height: 27px;
    position: relative;
    z-index: 2;
    font-weight: normal;
}

.list-info-box .tt {
    position: relative;
    z-index: 1;
}

.list-info-box .tt:after {
    content: '';
    display: block;
    clear: both;
    background: #696a6b;
    height: 1px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
}

.list-info-box .gap:after {
    content: '';
    display: block;
    clear: both;
}

.list-info-box .gap ul li {
    border-bottom: 1px solid #e1e1e1;
    display: flex;
    align-items: center;
}

.list-info-box .gap ul li .inner {
    width: 50%;
    display: flex;
    align-items: center;
}

@media (max-width: 640px) {
    .list-info-box .gap ul li.mobile {
        display: block;
        border-bottom: none;
    }

    .list-info-box .gap ul li.mobile .inner {
        width: 100%;
        border-bottom: 1px solid #e1e1e1;
    }
}

.list-info-box .gap ul li .inner:nth-child(3) {
    border-top: 1px solid #e1e1e1;
}

.list-info-box .gap ul li:after,
.list-info-box .gap ul li .inner:after {
    content: '';
    display: block;
    clear: both;
}

.list-info-box .gap ul li .left-text,
.list-info-box .gap ul li .right-text {
    /* float: left; */
    color: #2d2e2f;
    font-size: 14px;
    padding: 7px 0;
}

.list-info-box .gap ul li .left-text {
    width: 35%;
    background: #f9f9f9;
    padding: 5px 10px;
    /* font-size: .7rem; */
    font-size: 12px;
    display: flex;
    align-items: center;
}

.list-info-box .gap ul li .txt-s {
    font-size: 11px;
}

.list-info-box .gap ul li .right-text {
    word-break: break-word;
    width: 65%;
    padding: 5px 10px;
    /* font-size: .7rem; */
    font-size: 12px;
    color: #646464;
    display: flex;
    align-items: center;
}

.list-info-box .box-gap {
    margin-bottom: 16px;
    clear: both;
}

.list-info-box .box-gap:last-child {
    margin-bottom: 0;
}

.list-info-box .box-gap:after {
    content: '';
    display: block;
}

.list-info-box .box-gap.type-2 .gap {
    width: 50%;
    display: inline-block;
}

.list-info-box .box-gap.type-2 .gap:first-child {
    width: calc(50% - 13px);
}

.list-info-box .box-gap.type-2 .gap:last-child {
    width: calc(50% - 13px);
    float: right;
}

.list-info-box .box-gap.type-2 .gap ul li .inner {
    float: none;
    width: auto;
}



.box-sales #header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1.25rem;
    padding: 0;
    border: none;
}

.box-sales #header h2 {
    font-weight: bold;
    color: #2d2e2f;
}

.box-sales #header h1 {
    position: relative;
    top: auto;
}

.box-sales #header h1 img {
    height: 2rem;
}

.box-result {
    position: fixed;
    left: 60%;
    top: 50%;
    width: 100%;
    transform: translate(-50%, -50%);
    z-index: 1000;
    text-align: center;
}

.infoFooter {
    color: #2d2e2f;
    font-size: 11px;
    margin: 10px 0 0 0;
    letter-spacing: -0.02em;
}

.infoFooter span {
    color: #e40030;
}

.box-btn {
    text-align: center;
    margin: 22px 0 0 0;
}

.common-btn-1,
.common-btn-2 {
    display: inline-block;
    color: #fff;
    font-size: 18px;
    text-align: center;
    border: 2px solid #e1e1e1;
    height: 40px;
    line-height: 36px;
    border-radius: 3px;
    padding: 0 54px;
    font-family: 'NotoSansCJKkr-Regular';
}

.common-btn-1 {
    background: #04abc4;
}

.common-btn-2 {
    background: #6e7074;
}

#popupHeader {
    background: #e4e6e9;
    position: relative;
    padding: 13px 0 18px 26px;
}

#popupHeader h1 {}

#popupHeader a {
    position: absolute;
    top: 13px;
    right: 13px;
}

.eventContents {
    padding: 13px 36px 45px 27px;
}

.eventContents .txt-1 {
    text-align: right;
    color: #121212;
    position: relative;
    right: -32px;
}

.eventContents h2 {
    color: #121212;
    font-size: 16px;
    padding: 12px 0 18px 0;
}

.eventContents .box-table {
    padding: 0 0 0 21px;
    margin-bottom: 27px;
}

.common-table-1 {
    width: 100%;
    border-bottom: 1px solid #696a6b;
}

.common-table-1 thead th,
.common-table-1 tbody td {
    color: #2d2e2f;
    font-size: 14px;
    text-align: center;
}

.common-table-1 thead th {
    border-top: 1px solid #696a6b;
    background: #ebebeb;
    padding: 7px 0;
}

.common-table-1 tbody td {
    border-bottom: 1px solid #e1e1e1;
    padding: 9px 0;
}

.common-table-1 tbody tr:last-child td {
    border-bottom: none;
}

.list-type-1 {
    padding: 12px 0 0 21px;
}

.list-type-1 li {
    color: #2d2e2f;
}

.box-info-number {
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    align-items: center;
    padding: 55px 30px 0 27px;
}

.box-info-number .txt-1 {
    color: #121212;
    font-size: 16px;
    font-weight: bold;
}

.common-inputType-1 {
    border: 1px solid #b7b7b7;
    border-radius: 3px;
    height: 36px;
    line-height: 36px;
    padding-left: 10px;
    width: 100%;
    margin: 0 11px;
}

.box-info-number .btn-1 {
    height: 46px;
    line-height: 46px;
    display: inline-block;
    padding: 0 28px;
    color: #fff;
    font-family: 'NotoSansCJKkr-Medium';
    background: #4d7cfe;
    border: 0;
    font-size: 20px;
}

.box-info-number .common-inputType-1,
::placeholder {
    font-size: 14px;
    font-family: 'NotoSansCJKkr-DemiLight';
}

::placeholder {
    color: #a7aab4;
}




/*----------------------------------tree----------------------------------------*/
#detail-popup-wrap {
    opacity: 0;
    position: fixed;
    width: 0px;
    height: 100vw;
    right: 0;
    background-color: white;
    z-index: 60;
    transition: 0.3s;
    box-shadow: 0 1px 15px 0 rgb(87 87 87 / 15%);
}

#detail-popup-wrap .popup-header {
    border-radius: 10px;
    background-color: #064E3B;
    width: 100%;
    height: 200px;
    padding-top: 10px;
    position: relative;
    box-shadow: 0 1px 15px 0 rgb(87 87 87 / 15%);
}

#detail-popup-wrap .popup-header p {
    padding-top: 10px;
    text-align: center;
    position: relative;
    color: white;
    font-size: 19px;
}

#detail-popup-wrap .popup-header .popup-close-btn {
    top: 15px;
    width: 30px;
    position: absolute;
    right: 10px;
}

#detail-popup-wrap .popup-header .header-img-wrap {
    background-color: white;
    width: 100px;
    height: 100px;
    position: absolute;
    left: calc(50% - 50px);
    bottom: -50px;
    border-radius: 50px;
    box-shadow: 0 1px 15px 0 rgb(87 87 87 / 15%);
}

#detail-popup-wrap .popp-contents-wrap {
    padding: 80px 20px;
}

#detail-popup-wrap .popp-contents-wrap input {
    margin-bottom: 20px;
    border: 1px solid;
    border-radius: 0.375rem;
    border: 1px solid #e8e8e8;
}

#tree-content-wrap {
    margin-top: 20px
}

#tree-content-wrap .search-wrap {
    position: absolute;
    z-index: 4;
    top: 30px;
    left: 30px
}

#tree-content-wrap .btn-wrap {
    margin-top: 10px;
    border-bottom: 1px solid #E2E8F0;
    padding-bottom: 20px;
    margin-bottom: 20px
}

/* #tree-content-wrap #myDiagramDiv { overflow-styl#detail-popup-wrap .popup-header .popup-close-btne: unset; } */
::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background-color: transparent;
}
::-webkit-scrollbar-thumb {
    background: rgba(0,0,0,0.15);
    border-radius: 3px;
}
::-webkit-scrollbar-thumb:hover {
    background: rgba(0,0,0,0.3);
}
::-webkit-scrollbar-track {
    background: transparent;
}

/*reset.css*/
.cf {
    zoom: 1;
    /* ie 6,7 */
}

.cf::before,
.cf::after {
    content: "";
    clear: both;
    display: table;
}





/*-------------------- Header --------------------*/
.mobile-menu {
    top: 0;
    left: 0;
    margin: 0;
}

.mobile-menu:before {
    background: none;
    pointer-events: none;
}

.mobile-menu .main_logo {
    width: auto;
    overflow: hidden;
}

.mobile-menu .main_logo img {
    width: auto;
    max-width: none;
    /* height: 1.625rem; */
    height: 2rem;
}

.mobile-menu .header_gnb {
    display: flex;
    column-gap: 2vw;
    margin-right: 4vw;
    padding: 0;
}

.mobile-menu .header_gnb li {
    border: none;
}

.mobile-menu .header_gnb li a {
    display: block;
    position: relative;
    padding: 0 .5rem;
    font-size: .9375rem;
    font-weight: 500;
    line-height: 2.5rem;
    color: rgba(255, 255, 255, .7);
}

.mobile-menu .header_gnb li a::after {
    content: "";
    position: absolute;
    top: .25rem;
    right: 0;
    width: .3125rem;
    height: .3125rem;
    border-radius: 50%;
    background: #cce568;
    opacity: 0;
}

.mobile-menu .header_gnb li.active {}

.mobile-menu .header_gnb li.active a {
    font-weight: bold;
    color: #cce568;
}

.mobile-menu .header_gnb li.active a::after {
    opacity: 1;
}


.mobile-menu .mobile-menu-bar .mobile-menu-toggler {
    position: relative;
    width: 2.5rem;
    height: 2.5rem;
    z-index: 10;
}

.mobile-menu .mobile-menu-bar .mobile-menu-toggler:before,
.mobile-menu .mobile-menu-bar .mobile-menu-toggler:after {
    content: "";
    display: block;
    position: absolute;
    right: .5625rem;
    transition: .4s cubic-bezier(.5, .1, 0, 1.2);
    height: .125rem;
    margin-top: .625rem;
    background: #fff;
}

.mobile-menu .mobile-menu-bar .mobile-menu-toggler:before {
    top: 0;
    width: 1.125rem;
}

.mobile-menu .mobile-menu-bar .mobile-menu-toggler:after {
    top: 1.125rem;
    width: 1.375rem;
}

.mobile-menu .mobile-menu-bar .mobile-menu-toggler svg {
    position: absolute;
    top: 50%;
    right: .5625rem;
    transition: .4s cubic-bezier(.5, .1, 0, 1.2);
    transform: translateY(-50%);
    width: .875rem;
    height: .125rem;
    background: #acd560;
    overflow: hidden;
    opacity: 1;
    transform: translateY(-50%);
}

.mobile-menu .scrollable {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    top: 52px;
    transform: translateX(100%);
    width: 100%;
    height: calc(100% - 52px);
    margin: 0;
    background: #f1f5f9;
    overflow-y: auto;
}

.mobile-menu ul {
    padding: 0;
}

.mobile-menu ul li {
    -webkit-tap-highlight-color: transparent;
}

.mobile-menu ul li+li {
    border-top: .0625rem solid #d7d9da;
}

.mobile-menu .menu {
    height: 4rem;
    padding: 0;
    color: #1e293b;
}

.mobile-menu .menu .menu__title {
    display: flex;
    align-items: center;
    width: 100%;
    margin-left: .75rem;
    font-size: 1.0625rem;
    font-weight: bold;
}

.mobile-menu .menu .menu__icon {
    position: relative;
    top: -.0625rem;
}

.mobile-menu .scrollable .scrollable__content>li:nth-child(1) .menu__title .menu__sub-icon {
    /* display: none; */
}

.mobile-menu .menu .menu__title .menu__sub-icon {
    transform: none;
    position: relative;
    width: 1.625rem;
    height: 1.625rem;
}

.mobile-menu .menu .menu__title .menu__sub-icon::before,
.mobile-menu .menu .menu__title .menu__sub-icon::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #227862;
}

.mobile-menu .menu .menu__title .menu__sub-icon::before {
    width: 1rem;
    height: .125rem;
}

.mobile-menu .menu .menu__title .menu__sub-icon::after {
    width: .125rem;
    height: 1rem;
}

.mobile-menu .menu .menu__title .menu__sub-icon.rotate-180::after {
    display: none;
}


.mobile-menu ul li ul {
    margin: 0;
    padding: 0 0 1rem 1.5rem;
    background: none;
}

.mobile-menu ul li ul li {
    border: none;
}

.mobile-menu ul li ul .menu {
    height: 2.625rem;
    padding: 0;
}

.mobile-menu ul li ul .menu .menu__title {
    position: relative;
    font-size: .9375rem;
    letter-spacing: -.02rem;
}

.mobile-menu ul li ul .menu .menu__title::before {
    content: "";
    position: relative;
    top: -.25rem;
    width: .5rem;
    height: .5rem;
    margin-right: .625rem;
    border-left: .0625rem solid #a7a9aa;
    border-bottom: .0625rem solid #a7a9aa;
}

.mobile-menu .menu .menu__title .menu__sub-icon polyline {
    display: none;
}

.mobile-menu--active .mobile-menu-bar .mobile-menu-toggler:before {
    transform: translateX(.0625rem) translateY(.5625rem) rotate(-45deg);
    width: 1.5rem;
}

.mobile-menu--active .mobile-menu-bar .mobile-menu-toggler:after {
    transform: translateX(.0625rem) translateY(-.5625rem) rotate(45deg);
    width: 1.5rem;
}

.mobile-menu--active .mobile-menu-bar .mobile-menu-toggler svg {
    width: 0;
    opacity: 0;
}


.mobile-menu.mobile-menu--active .scrollable {
    transform: translateX(0);
}

.mobile-menu .logout-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: .0625rem solid #d7d9da;
    background: rgba(255, 255, 255, .5);
}

.mobile-menu .logout-btn a {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 2.75rem;
    padding: 0 1rem;
    color: #64748b;
}

.mobile-menu .logout-btn svg {
    position: relative;
    top: -.125rem;
    margin-right: .375rem;
    width: 1.125rem;
    height: 1.125rem;
}


.mobile-menu .menu_wrap {
    padding: 2rem 1.25rem 1.5rem;
}

.mobile-menu .user_info_wrap {
    margin-bottom: 1.75rem;
}

.mobile-menu .user_detail {
    display: flex;
    align-items: center;
    gap: .375rem;
    margin-bottom: .5rem;
}

.mobile-menu .user_detail span {
    display: inline-block;
    padding: .0625rem .5rem 0;
    border-radius: .125rem;
    background: #a6bacb;
    font-size: .75rem;
    line-height: 1.3125rem;
    letter-spacing: -.02rem;
    color: #fff;
}

.mobile-menu .user_detail .user_authority {
    background: #fc8f94;
}

.mobile-menu .user_detail .user_organization {
    background: #9da2f4;
}

.mobile-menu .user_greeting {
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
}

.mobile-menu .user_greeting p {
    font-size: 1.125rem;
    line-height: 1.75rem;
    letter-spacing: -.02rem;
    color: #1e203b;
}

.mobile-menu .user_greeting .user_name {
    font-size: 1.375rem;
    font-weight: bold;
}

.mobile-menu .login_session_wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 1.5rem;
    border-radius: .5rem;
    background: #dde4ed;
}

.mobile-menu .timer_wrap {
    display: flex;
    align-items: center;
    gap: .375rem;
}

.mobile-menu .timer_wrap svg {
    position: relative;
    width: 1.125rem;
    height: 1.125rem;
    color: #3c4756;
}

.mobile-menu .timer_wrap .timer {
    padding: 0;
    font-size: .9375rem;
    font-weight: 500;
    color: #3c4756;
}

.mobile-menu .login_session_wrap button {
    display: flex;
    align-items: center;
    gap: .375rem;
    margin: 0;
    padding: 0;
    border-radius: 0;
    background: none;
    font-weight: bold;
    color: #66758b;
}

.mobile-menu .login_session_wrap button svg {
    position: relative;
    top: -.0625rem;
    width: 1rem;
    height: 1rem;
    color: #66758b;
}

.mobile-menu .separation_line {
    height: .625rem;
    margin: 1.5rem -1.25rem 1rem;
    border-top: .0625rem solid #cdd4dd;
    background: #dde4ed;
}




/*-------------------- Modal --------------------*/
/* .scroll_lock { overflow:hidden; } */
.modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transition: visibility 0s ease 0.2s, opacity .2s 0s;
    width: auto;
    height: auto;
    margin: 0;
    background: rgb(0 0 0 / 65%);
    overflow-x: hidden;
    overflow-y: auto;
    visibility: visible;
    opacity: 1;
    z-index: 100000;
}


.modal .modal-dialog,
.modal#payment-modal .modal-dialog {
    position: relative;

    top: 50%;
    transform: translateY(-50%);
    /* transform: none; */
    transition: top .3s ease;

    width: 95%;
    max-width: 40rem;
    max-height: none;
    margin: auto;
    padding: .5rem 1.5rem;
    /* border-radius: 1rem; */
    border-radius: 10px;
    background: #fff;
    overflow: hidden;
}

.board_modal .modal-dialog {
    /* top: 6%; */
    top: 50%;
    max-width: 42rem;
}

.modal .modal-dialog .modal-content {
    margin: 0;
    max-height: none;
    box-shadow: none;
}

.modal .modal-dialog .modal-header {
    position: relative;
    width: auto;
    padding: 1rem 0;
}

.modal .modal-dialog .modal-header h2 {
    display: block;
    font-weight: bold;
}

.modal .modal-dialog .modal-header button {
    float: none;
    padding: 0;
}

.modal .modal-dialog .modal-header button span,
.modal .modal-dialog .modal-header button svg {
    width: 1.625rem;
    height: 1.625rem;
}

.modal .modal-dialog .modal-header .close_btn_sty svg {
    transform: rotate(.37turn);
}

.modal .modal-dialog .modal-body {
    overflow: auto;
    margin: 0;
    padding: 1.5rem 0;
}

.modal .modal-dialog .modal-body label {
    margin-bottom: .375rem;
    font-size: .8125rem;
    font-weight: bold;
}

.modal .modal-dialog .modal-body input:read-only,
.modal .modal-dialog .modal-body textarea:read-only {
    /* border: none; */
    border: 1px solid #cdcdcd;
    box-shadow: none;
    color: #8292a3;
}

.modal .modal-dialog .modal-footer {
    display: flex;
    justify-content: center;
    /* padding: 1.5rem 0; */
    padding: 1rem 0 0.5rem;
    text-align: center;
}

.modal .modal-dialog .modal-footer button {
    width: 50%;
    max-width: 8rem;
}

.modal .modal-dialog .modal-footer button+button {
    margin-left: .75rem;
}

.show_modal {
    visibility: visible;
    opacity: 1;
}

.show_modal .modal-dialog,
.show_modal#payment-modal .modal-dialog {
    top: 0;
}

.alert_modal {
    z-index: 100001 !important;
}

.alert_modal .modal-dialog {
    z-index: 100002 !important;
}

.alert_modal .modal-footer {
    border-top: 0;
}


/*------------------------ modal receipt style ------------------------*/

.modal .modal-dialog .type-receipt {}

.modal .modal-dialog .type-receipt .modal-header {
    z-index: 2;
}

.modal .modal-dialog .type-receipt .modal-header::after,
.modal .modal-dialog .type-receipt .modal-footer::after {
    content: "";
    position: absolute;
    left: -.4375rem;
    width: .875rem;
    height: .875rem;
    border-radius: 50%;
    box-shadow: 1rem 0 #fff, 2.5rem 0 #fff, 4rem 0 #fff, 5.5rem 0 #fff, 7rem 0 #fff, 8.5rem 0 #fff, 10rem 0 #fff, 11.5rem 0 #fff, 13rem 0 #fff, 14.5rem 0 #fff, 16rem 0 #fff, 17.5rem 0 #fff, 19rem 0 #fff, 20.5rem 0 #fff, 22rem 0 #fff, 23.5rem 0 #fff, 25rem 0 #fff, 26.5rem 0 #fff, 28rem 0 #fff, 29.5rem 0 #fff;
    background: transparent;
}

.modal .modal-dialog .type-receipt .modal-header::after {
    bottom: -.4375rem;
}

.modal .modal-dialog .type-receipt .modal-body {
    position: relative;
    padding: 0;
}

.modal .modal-dialog .type-receipt .modal-body::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    /* border-left: .0625rem solid rgba(0, 0, 0, .08); */
    /* border-right: .0625rem solid rgba(0, 0, 0, .08); */
    pointer-events: none;
}

.modal .modal-dialog .type-receipt .box-sales {
    max-height: calc(100dvh - 17.5rem);
    padding: 2rem 1rem;
    /* background: #eee; */
    overflow-y: auto;
}

.modal .modal-dialog .type-receipt .box-sales #header h1 {
    /* filter: brightness(.75) grayscale(1); */
}

.modal .modal-dialog .type-receipt .box-sales #header h2 {
    font-size: 1.0625rem;
    color: #424242;
}

.modal .modal-dialog .type-receipt .box-sales .list-info-box {}

.modal .modal-dialog .type-receipt .box-sales .box-gap {
    margin: 0;
}

.modal .modal-dialog .type-receipt .box-sales .box-gap+.box-gap {
    margin-top: 1rem;
}

.modal .modal-dialog .type-receipt .box-sales .gap {}

.modal .modal-dialog .type-receipt .box-sales .gap .tt {
    /* margin-bottom: .25rem; */
    /* background: #d7d7d7; */
}

.modal .modal-dialog .type-receipt .box-sales .gap .tt::after {
    /* position: absolute;
    top: 0;
    bottom: auto;
    height: 0;
    border-bottom: .0625rem dotted #424242;
    background: none; */
}

.modal .modal-dialog .type-receipt .box-sales .gap .tt h3 {
    /* display: block;
    height: auto;
    padding: 0 .75rem;
    border-radius: 0;
    background: none;
    font-weight: bold;
    line-height: 2rem;
    color: #424242; */
}

.modal .modal-dialog .type-receipt .box-sales .gap li {
    display: flex;
    flex-wrap: wrap;
    /* column-gap: .875rem; */
    border: none;
}

.modal .modal-dialog .type-receipt .box-sales .gap li+li {
    border-top: .0625rem solid #ddd;
}

.modal .modal-dialog .type-receipt .box-sales .gap li::after {
    display: none;
}

.modal .modal-dialog .type-receipt .box-sales .gap li .inner {
    float: initial;
    display: inline-flex;
    flex-wrap: wrap;
    flex-basis: calc(50% - .4375rem);
    flex-grow: 1;
    justify-content: space-between;
    width: auto;
    /* padding: .375rem 0; */
}

.modal .modal-dialog .type-receipt .box-sales .gap li .inner::after {
    display: none;
}

.modal .modal-dialog .type-receipt .box-sales .gap li .inner .left-text,
.modal .modal-dialog .type-receipt .box-sales .gap li .inner .right-text {
    float: initial;
    width: auto;
    padding: 0;
    font-size: .7rem;
    color: #424242;
}

.modal .modal-dialog .type-receipt .box-sales .gap li .inner .left-text {
    width: 32%;
    background: #f9f9f9;
    padding: 5px 12px;
    font-size: .7rem;
    display: flex;
    align-items: center;
    font-weight: bold;
}

.modal .modal-dialog .type-receipt .box-sales .gap li .inner .right-text {
    word-break: break-word;
    width: 68%;
    padding: 5px 12px;
    color: #646464;
    display: flex;
    align-items: center;
}

.modal .modal-dialog .type-receipt .box-sales .type-2 {
    display: flex;
    column-gap: 1.25rem;
}

.modal .modal-dialog .type-receipt .box-sales .type-2 .gap {
    width: auto;
    flex-basis: calc(50% - .625rem);
    flex-grow: 1;
    flex-shrink: 0;
}

.modal .modal-dialog .type-receipt .box-sales .list-info-box {}

.modal .modal-dialog .type-receipt .box-sales .infoFooter {
    margin: 1.25rem 0 0;
    font-size: .6875rem;
    line-height: 1.5;
    color: #424242;
}

.modal .modal-dialog .type-receipt .box-sales .box-btn {
    margin: 1.25rem 0 0;
}

.modal .modal-dialog .type-receipt .box-sales .box-btn button {
    height: 2.375rem;
    margin: 0 0 0 -.1875rem;
    border: none;
    background: #424242;
    font-family: inherit;
    font-size: .9375rem;
    font-weight: bold;
    line-height: 2.375rem;
}

.modal .modal-dialog .type-receipt .modal-footer {
    position: relative;
    z-index: 1;
}

.modal .modal-dialog .type-receipt .modal-footer::after {
    top: -.4375rem;
}







/*-------------------- Tabulator --------------------*/
.tabulator {
    /* height: 41.25rem; */
    /* height: calc(100dvh - 280px); */
    /* padding-bottom: 5px; */
}

.tabulator-row {}

.tabulator-cell {
    height: 49px;
}

.tabulator-page-size {
    padding-bottom: 0 !important;
    padding-top: 0 !important;
    margin-bottom: 10px !important;
}

.tabulator-paginator>label {
    margin-bottom: 10px;
}

.tabulator .tabulator-tableHolder {
    height: auto !important;
    min-height: auto !important;
    max-height: calc(100% - 3rem);
    overflow: scroll auto;
    -webkit-overflow-scrolling: touch;
}

.tabulator .tabulator-tableHolder .tabulator-table {
    /*height: 100%;*/
    /*padding-bottom: 0px !important;*/
    /*box-sizing: border-box;*/
}

.tabulator .tabulator-tableHolder::-webkit-scrollbar {
    -webkit-appearance: none;
}

.tabulator .tabulator-tableHolder::-webkit-scrollbar:vertical {
    display: block;
    width: 1.125rem;
}

.tabulator .tabulator-tableHolder::-webkit-scrollbar:horizontal {
    display: block;
    height: 1.125rem;
}

.tabulator .tabulator-tableHolder::-webkit-scrollbar-thumb {
    height: 15%;
    border: .375rem solid transparent;
    background-clip: content-box;
    background-color: rgba(0, 0, 0, .25);
    border-radius: 1.125rem;
}

.tabulator .tabulator-tableHolder::-webkit-scrollbar-track {
    background-color: rgba(0, 0, 0, 0);
}

.tabulator .tabulator-footer {
    /*margin-top:0rem;*/
}

.tabulator .tabulator-footer .tabulator-paginator {
    justify-content: center;
    margin: 0;
    text-align: center;
}

.tabulator .tabulator-footer .tabulator-paginator .tabulator-page {}

.tabulator .tabulator-footer .tabulator-paginator .tabulator-pages {}

.tabulator .tabulator-footer .tabulator-paginator .tabulator-pages .tabulator-page {
    /*display:none;*/
}

.tabulator .tabulator-footer .tabulator-paginator .tabulator-pages .tabulator-page.active {
    display: inline-flex;
}

.react_select_padding {
    padding: 0;
    height: 30px;
    display: flex;
    align-items: center;
}

.form_filter {
    margin-top: .5rem;
    /* padding: 1rem 1.25rem 1.25rem; */
    padding: 0.5rem 1rem;
    border-radius: .75rem;
    background: #fff;
    z-index: 10;
}

.form_filter::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: inherit;
    /* border: .125rem solid #064e3b; */
    border: 1px solid #064e3b;
    pointer-events: none;
}

.form_filter form {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: .25rem 1.25rem;
}

.form_filter .input_row {
    position: relative;
}

.form_filter .input_row+.input_row {
    margin-top: .5rem;
}

.form_filter .input_row label {
    display: block;
    margin-bottom: .125rem;
    font-size: .8125rem;
    font-weight: bold;
}

.form_filter .input_wrap {
    flex-grow: 1;
}

.form_filter .input_item {}

.form_filter .input_item input {
    margin: 0;
}

.form_filter .input_item select {
    cursor: pointer;
}

.form_filter .input_item .sorting {
    display: flex;
    margin-top: .375rem;
}

.form_filter .input_item .sorting.d_none {
    display: none;
}

.form_filter .input_item .sorting button {
    flex-grow: 1;
    height: 1.875rem;
    /* padding: 0; */
    padding: 0 9px;
    border-radius: 0;
    font-size: .7rem;
    letter-spacing: -.02rem;
    white-space: nowrap;
}

.form_filter .input_item .sorting button+button {
    margin-left: -.0625rem;
}

.form_filter .input_item .sorting button:first-child {
    border-top-left-radius: .375rem;
    border-bottom-left-radius: .375rem;
}

.form_filter .input_item .sorting button:last-child {
    border-top-right-radius: .375rem;
    border-bottom-right-radius: .375rem;
}

.form_filter .input_item .sorting button:focus {
    --tw-ring-shadow: inset var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
}

.form_filter .input_row.flex {
    align-items: flex-start;
    position: relative;
}

.form_filter .input_row.flex label {
    flex-basis: 30%;
    margin: 0;
    line-height: 2.375rem;
}

.form_filter .input_row.flex .input_wrap {}

.form_filter .input_item.flex {
    column-gap: .5rem;
}

.form_filter .input_item.flex select {
    flex-basis: 6.5rem;
    flex-shrink: 0;
}

.form_filter .input_item.flex input {}

.form_filter .input_item.flex input+button {
    flex-basis: 24%;
    flex-shrink: 0;
    white-space: nowrap;
}

.form_filter .button_wrap {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: .875rem;
    margin-top: 1rem;
}

.form_filter .button_wrap.separate {
    justify-content: flex-end;
}

.form_filter .button_wrap button {
    /* flex-grow: 1; */
    white-space: nowrap;
}

.form_filter .button_wrap button svg {
    width: 1.0625rem;
    height: 1.0625rem;
    /* margin-right: .375rem; */
}

.form_filter .button_wrap .btn-small {
    flex: 1 0;
}

.form_filter .merchant-search-list-box {
    height: auto;
}

.form_filter .multiselect__container {
    border: none;
    box-shadow: none;
    width: auto;
    min-height: auto;
    padding: 0;
    font-family: inherit;
}

.form_filter .multiselect__wrapper {
    font-size: inherit;
    color: inherit;
}

.form_filter .multiselect__input {
    flex-basis: auto;
    transition: .2s cubic-bezier(.4, 0, .2, 1);
    width: 100%;
    height: 2.375rem;
    padding: .5rem .75rem;
    border-radius: .375rem;
    border: .0625rem solid #e2e8f0;
    font-size: .875rem;
    line-height: 1.25rem;
}

.form_filter .multiselect__input:focus {
    border-color: rgba(6, 78, 59, .4);
    box-shadow: 0 0 0 .25rem rgba(6, 78, 59, .2);
}

.form_filter .multiselect__input::placeholder {
    color: #9eacbf;
}

.form_filter .multiselect__input:-ms-input-placeholder {
    color: #9eacbf;
}

.form_filter .multiselect__input::-ms-input-placeholder {
    color: #9eacbf;
}

.form_filter .more_wrap {
    position: relative;
    bottom: -1.25rem;
    transform: translateY(50%);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: -1.5rem;
    z-index: 1;
}

.form_filter .more_wrap button {
    display: flex;
    position: relative;
    justify-content: center;
    column-gap: .25rem;
    padding: .25rem 1rem;
    border-radius: 1.75rem;
    box-shadow: 0 .0625rem .25rem rgba(0, 0, 0, .2);
    background: #fff;
    outline: none;
    color: #074f3c;
}

.form_filter .more_wrap svg {
    position: relative;
    top: .1rem;
    width: 1rem;
    height: 1rem;
}

.form_filter .more_wrap span {
    font-size: .75rem;
    font-weight: 500;
}

.form_filter .more_wrap.short svg {
    transform: rotate(180deg);
}

.form_filter .d_none,
.on-pc {
    display: none;
}

.form_filter+.box {
    /* margin-top: 1.75rem; */
    margin-top: .5rem;
    height: calc(100% - 65px);
    overflow: scroll;
    /* height: auto; */
}

.tabulator_sorting_wrap {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    /* height: 36px; */
}

.tabulator_sorting_wrap .excel_download {
    display: flex;
    flex-wrap: wrap;
    gap: .375rem .625rem;
}

.tabulator_sorting_wrap .excel_download button {
    border: none;
    background: #434242;
    font-size: .8125rem;
    color: #fff;
}

.tabulator_sorting_wrap .excel_download button:hover {
    background: #434242;
}

.tabulator_sorting_wrap .excel_download button svg {
    width: 1.0625rem;
    height: 1.0625rem;
    margin-right: .375rem;
}

.tabulator_sorting_wrap .excel_download .btn-warning {
    background: #f59e0b;
}

.tabulator_sorting_wrap .excel_download .btn-warning:hover {
    background: #f58c0b;
}

.tabulator_sorting_wrap .rows_per_page {
    flex-shrink: 0;
}

.tabulator_sorting_wrap .rows_per_page select {
    height: 2.25rem;
    font-size: .8125rem;
    cursor: pointer;
}

.tabulator_summary_wrap {
    position: relative;
    margin: 1rem 0;
    /* height: 36px; */
    /*padding:.5rem;*/
    border-radius: .375rem;
    /*background:#f1f5f9;*/
}

.tabulator_summary_wrap .input_wrap {
    display: flex;
    background: #f1f5f9;
    align-items: center;
    padding: 0 .75rem;
    border-radius: .375rem;
}

.tabulator_summary_wrap .input_wrap+.input_wrap {
    margin-top: .375rem;
}

.tabulator_summary_wrap .input_wrap label {
    flex-shrink: 0;
    font-size: .8125rem;
}

.tabulator_summary_wrap .input_wrap input {
    padding: .5rem 0;
    border-radius: 0;
    border: none;
    background: none;
    box-shadow: none;
    font-weight: bold;
    text-align: right;
    cursor: text;
}

.tabulator_total_cnt_wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: .5rem 0;
}

.tabulator_total_cnt_wrap input {
    width: 100%;
    border-radius: .375rem;
    border: none;
    background: #dce6ef;
    font-size: .875rem;
    font-weight: bold;
    text-align: center;
}

.tabulator_total_cnt_wrap input:focus {
    box-shadow: none;
    border: none;
    outline: none;
}

.tabulator_sorting_wrap .excel_download .tabulator_total_cnt_wrap {
    justify-content: flex-start;
    position: relative;
    right: auto;
    margin: 0;
    padding: 0;
}

.tabulator_sorting_wrap .excel_download .tabulator_total_cnt_wrap input {
    width: auto;
    padding: 0;
    border-radius: 0;
    background: none;
    line-height: 2.25rem;
    text-align: left;
}

.tabulator_summary_wrap .btn_more {
    margin-left: .25rem;
    outline: none;
}

.tabulator_summary_wrap .btn_more svg {
    width: 1.25rem;
    height: 1.25rem;
    margin: .125rem;
}

.tabulator_summary_wrap .btn_more.active {}

.tabulator_summary_wrap .btn_more.active svg {
    transform: rotate(180deg);
}

.tabulator_summary_wrap .d_none {
    display: none;
}






/*-------------------- Dashboard page --------------------*/
.dashboard.inner-wrap {
    display: flex;
    flex-direction: column;
    /* justify-content: center; */
    align-items: center;
}

.dashboard .content-container {
    width: 100%;
    /* max-width: 38.75rem; */
    /* max-width: 100%; */
}

.dashboard .main-title-wrap {
    /*padding-top: .75rem;*/
    border-bottom: .0625rem solid #d1d5d9;
}

.dashboard .main-title-wrap .title {
    display: inline-block;
    position: relative;
    padding: 0 1rem;
    font-size: .9rem;
    font-weight: bold;
    line-height: 2.5rem;
}

.dashboard .main-title-wrap .title:before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: -.0625rem;
    height: .1875rem;
    background: #064e3b;
    border-top-left-radius: .1875rem;
    border-top-right-radius: .1875rem;
}

.dashboard .main-title-wrap .btn-wrap {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    padding-top: .75rem;
}

.dashboard .main-title-wrap .btn-wrap button {
    width: 2.25rem;
    height: 2.25rem;
}

.dashboard .main-title-wrap .btn-wrap button+button {
    margin-left: .25rem;
}

.dashboard .main-title-wrap .btn-wrap button svg {
    width: auto;
    height: 1.75rem;
    margin: 0 auto;
}

.dashboard .panel {
    margin: .5rem 0;
}

.dashboard .sales .panel {
    display: flex;
    flex-direction: column;
}

.dashboard .sales .panel ul {
    display: flex;
    flex-direction: column;
    width: 100%;
    background: rgb(255, 255, 255);
    box-shadow: rgba(0, 0, 0, 0.04) 0px 0.25rem 0.5rem;
    border-radius: 10px;
}

/* .dashboard .sales .panel ul + ul { margin-top:.875rem; } */
.dashboard .sales .panel ul li {
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    position: relative;
    /* padding: .75rem .75rem; */
    padding: 1rem;
    /* box-shadow: 0 .25rem .5rem rgba(0, 0, 0, .04); */
    background: #fff;
}

.dashboard .sales .panel ul li:first-child {
    border-top-left-radius: .5rem;
    border-top-right-radius: .5rem;
    border-bottom: .0625rem solid rgba(0, 0, 0, .08);
}

.dashboard .sales .panel ul li:last-child {
    border-bottom-left-radius: .5rem;
    border-bottom-right-radius: .5rem;
}

.dashboard .sales .panel ul li .calc-title {
    display: block;
    position: relative;
    margin-bottom: 0;
    color: #64748b;
}

.dashboard .sales .panel ul li .calc-item {
    text-align: right;
    white-space: nowrap;
}

.dashboard .sales .panel ul li .calc-item money {
    /* font-size: 1.375rem; */
    font-size: 1.1rem;
    font-weight: bold;
}

.dashboard .sales .panel ul li .cancelation {
    color: #d52424;
}

.dashboard .sales .panel .em li:first-child {
    background: linear-gradient(135deg, #434242, #000000);
}

.dashboard .sales .panel .em li:first-child .calc-title {
    color: #fff;
}

.dashboard .sales .panel .em li:first-child .calc-item money {
    color: #fff;
}

.dashboard .sales .panel .em li:first-child .calc-item span {
    color: rgba(255, 255, 255, .75);
}

.dashboard .sales .panel ul li+li {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}

.dashboard .sales .panel li+li .calc-title {
    margin: 0;
}

.dashboard .sales .panel li+li .calc-item money {
    font-size: 0.95rem;
    font-weight: 500;
}

.dashboard .sales .panel li+li .calc-item span {}

.dashboard .sales .panel li+li~li {
    margin-top: -1rem;
}

.dashboard .sales .panel {
    flex-direction: column;
    gap: 1rem;
    /* align-items: center; */
}

.dashboard .calc-table li {
    position: relative;
    padding: 1rem 1.25rem;
    border-radius: .5rem;
    box-shadow: 0 .25rem .5rem rgb(0 0 0 /4%);
    background: #fff;
    overflow: hidden;
}

.dashboard .calc-table li+li {
    margin-top: .875rem;
}

.dashboard .calc-table li:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: inherit;
    border: .0625rem solid rgb(0 0 0 / 8%);
    pointer-events: none;
}

.dashboard .calc-table li .calc-title {
    display: block;
    margin-bottom: .5rem;
    font-size: .8125rem;
    line-height: 2;
}

.dashboard .calc-table li:nth-child(1) .calc-title {
    color: #0d9488;
}

.dashboard .calc-table li:nth-child(2) .calc-title {
    color: #ff9f89;
}

.dashboard .calc-table li:nth-child(3) .calc-title {
    color: #064e3b;
}

.dashboard .calc-table li:nth-child(4) .calc-title {
    color: #0e9488;
}

.dashboard .calc-table li .calc-item {
    display: inline-block;
    font-size: 1.375rem;
    font-weight: bold;
}

.dashboard .calc-table li .calc-cnt {
    display: inline-block;
    margin-left: .25rem;
    font-size: .8125rem;
    font-weight: 500;
    color: #919599;
}

.dashboard .calc-table li progress {
    display: block;
    width: 100%;
    height: .3125rem;
    margin: .75rem 0 .5rem;
    border-radius: .3125rem;
    overflow: hidden;
}

.dashboard .dailyStatsChart,
.dashboard .monthlyStatsChart {
    height: 16rem;
    border-radius: .5rem;
    box-shadow: 0 .25rem .5rem rgb(0 0 0 / 4%);
    background: #fff;
    padding: 1rem 1rem;
}

.dashboard .dailyStatsChart canvas,
.dashboard .monthlyStatsChart canvas {
    width: 100% !important;
    height: 100% !important;
}

.dashboard .branchList {
    margin: 1.5rem 0;
}

.dashboard .branchList>div+div {
    margin-top: .875rem;
}

.dashboard .branchList .box {
    position: relative;
    min-height: 4.5rem;
    margin: 0;
    padding: 1rem 1.25rem;
    border-radius: .5rem;
    box-shadow: 0 .25rem .5rem rgb(0 0 0 / 4%);
    background: #fff;
    overflow: hidden;
}

.dashboard .branchList .box:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: inherit;
    border: .0625rem solid rgb(0 0 0 / 8%);
    pointer-events: none;
}

.dashboard .branchList .box>div:nth-child(1) {
    margin-left: 0;
    padding-right: .75rem;
}

.dashboard .branchList .box>div:nth-child(2) {
    flex-shrink: 0;
    padding: .3125rem .625rem;
    font-size: .8125rem;
}

.dashboard .branchList .box>div span {
    flex-shrink: 0;
    display: inline-block;
    position: relative;
    top: -.25rem;
    left: 0;
    width: 2.25rem;
    height: 2.25rem;
    margin-right: .625rem;
    border-radius: 50%;
    border-width: .25rem;
    border-style: solid;
    line-height: 1.8125rem;
    text-align: center;
    color: #fff;
}

.dashboard .branchList .box>div span:after {
    content: "";
    display: block;
    position: absolute;
    top: 1.5rem;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 1.125rem;
    border-width: .375rem .625rem;
    border-style: solid;
    border-color: #fc402d #fc402d transparent #fc402d;
    z-index: -1;
    pointer-events: none;
}

.dashboard .branchList .box>div:nth-child(1) div {
    display: flex;
    align-items: center;
    font-size: .875rem;
    font-weight: bold;
}

/* medal index color */
.dashboard .branchList>div:nth-child(1) .box>div:nth-child(1) span {
    border-color: #fadd40;
    box-shadow: inset 0 0 0 #b67d05, .125rem .125rem 0 rgb(0 0 0 / 8%);
    background: linear-gradient(to bottom right, #f9ad0e 50%, #e89f06 50%);
    text-shadow: 0 0 .25rem #9d6c04;
}

.dashboard .branchList>div:nth-child(2) .box>div:nth-child(1) span {
    border-color: #edeff1;
    box-shadow: inset 0 0 0 #a7b2b8, .125rem .125rem 0 rgb(0 0 0 / 8%);
    background: linear-gradient(to bottom right, #d1d7da 50%, #c3cbcf 50%);
    text-shadow: 0 0 .25rem #98a6ad;
}

.dashboard .branchList>div:nth-child(3) .box>div:nth-child(1) span {
    border-color: #f7bb23;
    box-shadow: inset 0 0 0 #955405, .125rem .125rem 0 rgb(0 0 0 / 8%);
    background: linear-gradient(to bottom right, #df7e08 50%, #c67007 50%);
    text-shadow: 0 0 .25rem #7d4604;
}

.dashboard .branchList>div:nth-child(n + 4) .box>div:nth-child(1) span {
    top: 0;
    box-shadow: none;
    border-color: #e0e1f3;
    background: linear-gradient(to bottom right, #c3c7d3 50%, #b3b6bd 50%);
    text-shadow: 0 0 .25rem #858ea1;
}

.dashboard .branchList>div:nth-child(n + 4) .box>div:nth-child(1) span:after {
    display: none;
}

.dashboard .notice-wrap>div {
    position: relative;
    min-height: 9.25rem;
    padding: 1.25rem;
    border-radius: .5rem;
    box-shadow: 0 .25rem .5rem rgb(0 0 0 / 4%);
    background: #fff;
    overflow: hidden;
}

.dashboard .notice-wrap>div:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: inherit;
    border: .0625rem solid rgb(0 0 0 / 8%);
    pointer-events: none;
}

.dashboard .notice-wrap>div+div {
    margin-top: .875rem;
}

.dashboard .notice-wrap .text-base {
    margin-bottom: .5rem;
    font-size: .9375rem;
    font-weight: bold;
}

.dashboard .notice-wrap .text-slate-400 {
    /*position: absolute;*/
    /*left: 1.25rem;*/
    /*bottom: 1.25rem;*/
    float: right;
    line-height: 1.4;
}

.dashboard .notice-wrap .text-slate-500 {
    margin: 0;
}

.dashboard .notice-wrap .text-slate-500+div,
.dashboard .notice-wrap .text-slate-500+div button {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 0;
    padding: 0;
    opacity: 0;
}





/*-------------------- Payment page --------------------*/
.payment {
    min-height: auto;
    padding: 0 0 1rem;
    border-radius: 1rem;
}

.payment .inner-wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.payment .tab-wrap {
    position: relative;
    width: 100%;
    max-width: 33.75rem;
    padding-top: .75rem;
    border-bottom: .0625rem solid #d1d5d9;
}

.payment .tab-wrap li {
    display: inline-block;
    position: relative;
}

.payment .tab-wrap li:before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: -.0625rem;
    height: .1875rem;
    background: #064e3b;
    border-top-left-radius: .1875rem;
    border-top-right-radius: .1875rem;
    opacity: 0;
}

.payment .tab-wrap li a {
    display: block;
    padding: 0 1rem;
    font-size: .875rem;
    font-weight: bold;
    line-height: 3.25rem;
    cursor: pointer;
}

.payment .tab-wrap li.current:before {
    opacity: 1;
}

.payment .content-wrap {
    width: 100%;
    max-width: 33.75rem;
    margin: 0 auto;
    padding: 2rem 0 1rem;
}

.payment .intro-y {
    display: flex;
    flex-wrap: wrap;
    width: calc(100% + 1rem);
    margin-left: -.5rem;
    background: #f0f4f8;
    box-shadow: none;
}

/* Payment - payForm */
.payment .content-wrap .payForm {
    display: none;
    margin: 0;
    padding: 0;
}

.payment .content-wrap .payForm.active {
    display: block;
}

.payment .payForm .form-label {
    margin-bottom: .375rem;
    font-size: .8125rem;
    font-weight: bold;
}

.payment .payForm .input {
    width: 100%;
    margin: 0 .5rem 1rem;
}

.payment .payForm .input input {}

.payment .payForm .input input::placeholder {
    font-size: .875rem;
}

.payment .payForm .input.w33 {
    width: calc(33.33% - 1rem);
}

.payment .payForm .input.w50 {
    width: calc(50% - 1rem);
}

.payment .payForm .input.w66 {
    width: calc(66.66% - 1rem);
}

.payment .payForm .input .multiple {
    display: flex;
    align-items: center;
}

.payment .payForm .input .multiple span {
    padding: 0 .375rem;
}

.payment .payForm .mt-2,
.payment .payForm .mt-3 {
    margin: 0;
}

.payment .payForm .pos_aps_r {
    margin: .25rem 0 -1.25rem;
}

.payment .payForm .payBt {
    width: 100%;
    margin: 1.5rem 0 1rem;
    text-align: center;
}

.payment .payForm .payBt .btn {
    width: 40%;
    max-width: 12.5rem;
}

.payment .payForm .payBt .btn+.btn {
    margin-left: .5rem;
}

/* Payment - cardInfo */
.payment .content-wrap .cardInfo {
    display: none;
    width: 100%;
    max-width: 33.75rem;
    margin: 0;
    padding: 0;
}

.payment .content-wrap .cardInfo.active {
    display: block;
}

.payment .cardInfo .tabulator {
    margin: 0;
    padding: 0;
}

.payment .cardInfo .tabulator-header {
    border-width: 0;
}

.payment .cardInfo .tabulator-headers {
    text-align: right;
}

.payment .cardInfo .tabulator-headers>div:nth-child(1) {
    display: none;
}

.payment .cardInfo .tabulator-tableHolder {
    margin-top: .5rem;
    overflow: hidden;
}

.payment .cardInfo .tabulator-tableHolder .tabulator-table {
    width: 100%;
    background: none;
}

.payment .cardInfo .tabulator-row,
.payment .cardInfo .tabulator-row.tabulator-row-even {
    margin-bottom: 1.25rem;
    background: #fff;
    border-radius: .75rem;
    border-bottom-width: 0;
}

.payment .cardInfo .tabulator-row .tabulator-cell {
    font-weight: bold;
}

.payment .cardInfo .tabulator-row .tabulator-responsive-collapse table {
    width: 100%;
}

.payment .cardInfo .tabulator-row .tabulator-responsive-collapse td {
    padding-top: .1875rem;
    padding-bottom: .1875rem;
    font-size: .8125rem;
}

.payment .cardInfo .tabulator-row .tabulator-responsive-collapse td:nth-child(2) {
    font-weight: bold;
    text-align: right;
}

.payment .cardInfo .tabulator-row .tabulator-responsive-collapse td strong {
    color: #a1a5a9;
}

.payment .cardInfo .tabulator-footer .tabulator-paginator {
    justify-content: center;
    margin: 0;
    text-align: center;
}

.payment .cardInfo .tabulator-footer .tabulator-page.active {
    background: #064e3b;
    color: #fff;
}

/* Payment - modal */
.payment .modal .modal-body .col-span-12 {
    grid-column: span 12 / span 12;
}

.payment .modal .modal-body .sm\\:col-span-6 {
    grid-column: span 6 / span 6;
}

/*-------------------- eastpayReq page --------------------*/
.east-pay {
    height: 97%;
}

.east-pay .content-wrap {
    max-width: 30rem;
    height: 100%;

}

.east-pay .inner-wrap {
    padding-top: 1.25rem;
}

.east-pay .payForm .input_container .input_list {
    display: flex;
    gap: 0 1.5rem;
}

.east-pay .payForm .input_container:nth-child(2) {
    padding-bottom: 2.5rem;
}

.east-pay .payForm .input_container:last-child {
    padding-top: 2.5rem;
    border-top: 0.0625rem solid #d7d9da;
}

.east-pay .content-wrap .payForm {
    display: none;
    margin: 0;
    padding: 0;
}

.east-pay .content-wrap .payForm.active {
    display: block;
}

.east-pay .payForm .form-label {
    margin-bottom: .375rem;
    font-size: .8125rem;
    font-weight: bold;
}

.east-pay .payForm .input {
    width: 100%;
    /* margin: 0 .5rem 1rem; */
    margin: 0 0 1rem;
}

.east-pay .payForm .input input {}

.east-pay .payForm .input input::placeholder {
    font-size: .875rem;
}

.east-pay .payForm .input.w33 {
    width: calc(33.33% - 1rem);
}

.east-pay .payForm .input.w50 {
    width: calc(50% - 1rem);
}

.east-pay .payForm .input.w66 {
    width: calc(66.66% - 1rem);
}

.east-pay .payForm .input .multiple {
    display: flex;
    align-items: center;
}

.east-pay .payForm .input .multiple span {
    padding: 0 .375rem;
}

.east-pay .payForm .mt-2,
.east-pay .payForm .mt-3 {
    margin: 0;
}

.east-pay .payForm .pos_aps_r {
    margin: .25rem 0 -1.25rem;
}

.east-pay .payForm .payBt {
    width: 100%;
    margin: 1.5rem 0 1rem;
    text-align: center;
}

.east-pay .payForm .payBt .btn {
    width: 40%;
    max-width: 12.5rem;
}

.east-pay .payForm .payBt .btn+.btn {
    margin-left: .5rem;
}

.east-pay .input textarea {
    height: 10rem;
    resize: none;
}

.east-pay .box {
    background: none;
    box-shadow: none;
}



.east-pay .main-title-wrap {
    width: 100%;
    max-width: 33.75rem;
    padding-top: 0.75rem;
    margin-bottom: 2rem;
    border-bottom: 0.0625rem solid #d1d5d9;
}

.east-pay .title {
    padding-bottom: 1rem;
    font-size: 1.0625rem;
    font-weight: bold;
    line-height: 3.25rem;
    ;
}

.east-pay .main-title-wrap .title:before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: -0.0625rem;
    height: 0.1875rem;
    background: #064e3b;
    border-top-left-radius: 0.1875rem;
    border-top-right-radius: 0.1875rem;
}

.east-pay .btn-wrap button {
    max-width: 18rem;
    flex-grow: 1;
}


@media (min-width: 1280px) {

    /* .east-pay .main-title-wrap {
        display: none;
        max-width: none;
        border: none;
    } */
    .east-pay .content-wrap {
        padding: 1.5rem 2rem 1rem;
        background-color: #fff;
    }

    .pay_status {
        width: 4rem;
    }

    .amt_range {
        width: 12rem;
    }

    .pg_gubun {
        width: 5rem;
    }
}

@media (max-width: 766px) {
    .east-pay .content-wrap {
        max-width: 33.75rem;
        margin: 0 auto;
    }

    .east-pay .inner-wrap {
        padding-top: 0;
    }

}

@media (max-width: 640px) {
    .east-pay .payForm .input_container .input_list {
        gap: 0 .75rem;
    }

    .east-pay .payForm .input.w50 {
        width: calc((100% - 0.75rem)/2);
    }

    .east-pay .payForm .input_container:nth-child(2) {
        padding-bottom: 1rem;
    }

    .east-pay .payForm .input_container:last-child {
        padding-top: 1.5rem;
    }

    .east-pay .btn-wrap button {
        max-width: 100%;
    }
}

/* Payment - cardInfo */
.east-pay .content-wrap .cardInfo {
    display: none;
    width: 100%;
    max-width: 33.75rem;
    margin: 0;
    padding: 0;
}

.east-pay .content-wrap .cardInfo.active {
    display: block;
}

/*-------------------- Calender page --------------------*/
.calendar {
    min-height: auto;
    padding: 0 0 1rem;
    border-radius: 1rem;
}

.calendar .inner-wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.calendar .main-title-wrap {
    width: 100%;
    max-width: 33.75rem;
    padding-top: .75rem;
    border-bottom: .0625rem solid #d1d5d9;
}

.calendar .main-title-wrap .title {
    display: inline-block;
    position: relative;
    padding: 0 1rem;
    font-size: .875rem;
    font-weight: bold;
    line-height: 3.25rem;
}

.calendar .main-title-wrap .title:before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: -.0625rem;
    height: .1875rem;
    background: #064e3b;
    border-top-left-radius: .1875rem;
    border-top-right-radius: .1875rem;
}

.calendar .content-wrap {
    display: flex;
    flex-direction: column;
}

.calendar .content-wrap .content-col {
    width: 100%;
    max-width: 33.75rem;
    margin: 0 auto;
    padding: 2rem 0 1rem;
}

.calendar .content-wrap .content-col.left {
    order: 2;
}

.calendar .content-wrap .content-col.right {
    order: 1;
}

.calendar .content-wrap .title-wrap .title {
    font-size: .9375rem;
    font-weight: bold;
}

/* calendar - chat box */
.calendar .chat__box {
    margin-top: 3rem;
}

.calendar .chat__box .cal-chat-wrap {
    position: relative;
    border-radius: .5rem;
    box-shadow: 0 .25rem .5rem rgb(0 0 0 / 4%);
    background: #fff;
    overflow: hidden;
}

.calendar .chat__box .cal-chat-wrap:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: inherit;
    border: .0625rem solid #ddd;
    z-index: 1;
    pointer-events: none;
}

.calendar .chat__box .title-wrap {
    display: flex;
    align-items: center;
    position: relative;
    padding: 1.25rem 1rem .75rem;
    border-bottom: .0625rem solid #ddd;
}

.calendar .chat__box .title-wrap .thumb {
    position: relative;
    width: 1.75rem;
    height: 1.75rem;
    border-radius: 50%;
    overflow: hidden;
}

.calendar .chat__box .title-wrap .thumb:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: inherit;
    border: .0625rem solid rgb(0 0 0 / 4%);
    z-index: 1;
    pointer-events: none;
}

.calendar .chat__box .title-wrap .thumb img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: auto;
    height: 100%;
}

.calendar .chat__box .title-wrap .name {
    margin-left: .375rem;
}

.calendar .chat__box .title-wrap .name h3 {
    font-weight: bold;
}

.calendar .chat__box .title-wrap .btn-notice {
    position: absolute;
    right: 1.25rem;
    text-align: right;
}

.calendar .chat__box .title-wrap .btn-notice button {
    height: 1.625rem;
    padding: 0 .75rem;
    border-radius: .25rem;
    background: #94a3b8;
    font-size: .75rem;
    font-weight: 500;
    line-height: 1.625rem;
    color: #fff;
}

.calendar .chat__box .notice-wrap {
    display: flex;
    align-items: center;
    min-height: 3rem;
    padding: .5rem 1rem;
    border-bottom: .0625rem solid #ddd;
    background: #fff;
}

.calendar .chat__box .notice-wrap.d-none {
    display: none;
}

.calendar .chat__box .chat-container {
    min-height: 14rem;
    max-height: calc(100dvh - 18.5rem);
    padding: 1rem 1rem 0;
    background: #afc0d7;
    overflow-y: auto;
}

.calendar .chat__box .chat-container::-webkit-scrollbar {
    display: block;
    width: 1.125rem;
}

.calendar .chat__box .chat-container::-webkit-scrollbar-thumb {
    height: 15%;
    border: .375rem solid transparent;
    background-clip: content-box;
    background-color: rgba(0, 0, 0, .25);
    border-radius: 1.125rem;
}

.calendar .chat__box .chat-container::-webkit-scrollbar-track {
    background-color: rgba(0, 0, 0, 0);
}

.calendar .chat__box .chat-container .chat-wrap {
    display: block;
    position: relative;
    margin: 0 0 1.25rem;
}

.calendar .chat__box .chat-container .chat-wrap div.d-none {
    display: none;
}

.calendar .chat__box .chat-container .chat-wrap div:nth-child(1) {
    display: block;
    height: auto;
    margin: 0 0 .5rem;
    font-size: .75rem;
    font-weight: bold;
    line-height: 1;
}

.calendar .chat__box .chat-container .chat-wrap div:nth-child(2) {
    display: flex;
    align-items: flex-end;
    position: relative;
    padding: 0;
    background: none;
}

.calendar .chat__box .chat-container .chat-wrap div:nth-child(2) span {
    display: inline-block;
    position: relative;
    margin: .25rem 0 0;
    padding: .375rem .75rem;
    border-radius: .5rem;
    background: #f1f5f9;
}

.calendar .chat__box .chat-container .chat-wrap div:nth-child(2) span:after {
    content: "";
    position: absolute;
    top: -.4375rem;
    left: .75rem;
    border-top: 0 solid transparent;
    border-left: .5rem solid transparent;
    border-right: .5rem solid transparent;
    border-bottom: .5rem solid #f1f5f9;
}

.calendar .chat__box .chat-container .chat-wrap div:nth-child(2) div {
    flex-shrink: 0;
    display: inline-block;
    margin: 0 0 0 .375rem;
    font-size: .7rem;
    font-weight: 500;
    letter-spacing: -.0125rem;
    white-space: nowrap;
}

.calendar .chat__box .chat-container .chat-wrap div:nth-child(3) {
    margin: .375rem 0 0;
}

.calendar .chat__box .chat-container .chat-wrap div:nth-child(3) button {
    font-weight: bold;
}

.calendar .chat__box .message-wrap {
    position: relative;
}

.calendar .chat__box .message-wrap input {
    width: calc(100% - 3.25rem);
    height: 3.25rem;
    padding-left: 1rem;
    padding-right: 1rem;
    border-radius: 0;
    box-shadow: none;
    font-size: .9375rem;
}

.calendar .chat__box .message-wrap input::placeholder {
    font-size: 1rem;
}

.calendar .chat__box .message-wrap a {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    width: 3.25rem;
    height: 3.25rem;
    margin: 0;
    border-radius: 0;
}

.calendar .chat__box .message-wrap a svg {
    width: 1.25rem;
    height: 1.25rem;
}

/* calendar - calendar */
.calendar .calendar-category-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: .75rem;
    margin-top: .75rem;
}

.calendar .calendar-category-wrap li {
    margin: 0 .625rem;
}

.calendar .calendar-category-wrap span {
    display: inline-block;
    width: .625rem;
    height: .625rem;
    border-radius: .1875rem;
}

.calendar .calendar-category-wrap p {
    display: inline-block;
    margin-left: .125rem;
    font-size: .75rem;
    font-weight: 500;
}

.calendar .full-calendar .fc-header-toolbar {
    position: relative;
    height: 2.25rem;
    margin-bottom: 1rem;
}

.calendar .full-calendar .fc-header-toolbar .fc-left {
    display: inline-block;
    position: relative;
    left: 2.25rem;
    width: 6.75rem;
    text-align: center;
    z-index: 1;
}

.calendar .full-calendar .fc-header-toolbar .fc-left h2 {
    float: none;
    font-size: 1rem;
    font-weight: bold;
    line-height: 2.25rem;
}

.calendar .full-calendar .fc-header-toolbar .fc-right {
    float: none;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
}

.calendar .full-calendar .fc-header-toolbar .fc-right .fc-today-button {
    position: absolute;
    top: .1875rem;
    right: 0;
    height: 1.875rem;
    padding: 0 .75rem;
    border: none;
    box-shadow: none;
    background: #94a3b8;
    font-weight: 500;
    line-height: 1.875rem;
    text-shadow: none;
    color: #fff;
    opacity: 1;
}

.calendar .full-calendar .fc-header-toolbar .fc-right .fc-today-button.fc-state-disabled {
    background: #e1e5e9;
    color: #1e293b;
    cursor: default;
}

.calendar .full-calendar .fc-header-toolbar .fc-right .fc-button-group {
    display: flex;
    justify-content: space-between;
    position: absolute;
    left: 0;
    width: 11.25rem;
    margin: 0;
}

.calendar .full-calendar .fc-header-toolbar .fc-right .fc-button-group button {
    float: none;
    width: 2.25rem;
    height: 2.25rem;
    margin: 0;
    border: none;
    box-shadow: none;
    background: none;
}

.calendar .full-calendar .fc-view-container .fc-view .fc-head-container {
    border: none;
}

.calendar .full-calendar .fc-view-container .fc-view .fc-head .fc-row {
    margin: 0 !important;
    border: none !important;
}

.calendar .full-calendar .fc-view-container .fc-view .fc-head .fc-row th {
    border: none;
}

.calendar .full-calendar .fc-view-container .fc-view .fc-head .fc-row th.fc-sun {
    color: #c90000;
}

.calendar .full-calendar .fc-view-container .fc-view .fc-head .fc-row th span {
    font-size: .75rem;
    line-height: 1.625rem;
}

.calendar .full-calendar .fc-view-container .fc-view .fc-body td {
    position: relative;
    border: none;
}

.calendar .full-calendar .fc-view-container .fc-view .fc-body .fc-day-grid-container {
    height: auto !important;
    overflow: hidden !important;
}

.calendar .full-calendar .fc-view-container .fc-view .fc-body .fc-day-grid {
    border-bottom: .0625rem solid #ddd;
}

.calendar .full-calendar .fc-view-container .fc-view .fc-body .fc-row {
    height: auto !important;
    min-height: 5.25rem;
    border-top: .0625rem solid #ddd;
}

.calendar .full-calendar .fc-view-container .fc-view .fc-body .fc-bg td.fc-today {
    border-radius: .25rem;
    background: none;
}

.calendar .full-calendar .fc-view-container .fc-view .fc-body .fc-bg td.fc-today:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: inherit;
    border: .125rem solid #94a3b8;
    box-sizing: border-box;
}

.calendar .full-calendar .fc-view-container .fc-view .fc-body .fc-content-skeleton thead td {
    text-align: center;
}

.calendar .full-calendar .fc-view-container .fc-view .fc-body .fc-content-skeleton thead td.fc-sun {
    color: #c90000;
}

.calendar .full-calendar .fc-view-container .fc-view .fc-body .fc-content-skeleton thead td span {
    float: none;
    font-size: .75rem;
    font-weight: bold;
}

.calendar .full-calendar .fc-view-container .fc-view .fc-body .fc-content-skeleton thead td.fc-other-month span {
    font-weight: normal;
}

.calendar .full-calendar .fc-view-container .fc-view .fc-body .fc-content-skeleton tbody td .fc-day-grid-event {
    padding: 0 .125rem;
    border-radius: .25rem;
    line-height: 1.2;
    cursor: pointer;
}

.calendar .full-calendar .fc-view-container .fc-view .fc-body .fc-content-skeleton tbody td .fc-day-grid-event .fc-content span {
    font-size: .7rem;
}

/* calendar - modal */
.scroll_lock {
    overflow: hidden;
}

.calendar .modal {
    right: 0;
    bottom: 0;
    width: auto;
    height: auto;
    margin: 0;
    overflow-x: hidden;
    overflow-y: auto;
    z-index: 100000;
}

.calendar .modal .modal-dialog {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    transition: .3s;
    width: 92%;
    max-width: 26.25rem;
    margin: 0 auto;
    padding: .5rem 1.5rem;
    border-radius: 1rem;
    background: #fff;
    overflow: hidden;
}

.calendar .modal .modal-dialog .modal-content {
    margin: 0;
    max-height: none;
    box-shadow: none;
    display: block;
    overflow-x: hidden;
}

.calendar .modal .modal-header {
    position: relative;
    width: auto;
    padding: 1rem 0.5rem;
}

.calendar .modal .modal-header h2 {
    font-weight: bold;
}

.calendar .modal .modal-header button {
    padding: 0;
}

.calendar .modal .modal-header button span,
.modal .modal-header button svg {
    width: 1.625rem;
    height: 1.625rem;
}

.calendar .modal .modal-header button svg {
    transform: rotate(45deg);
}

.calendar .modal .modal-body {
    margin: 0;
    padding: 1.5rem 0;
}

.calendar .modal .modal-body .tbl-grid {
    width: 100%;
}

.calendar .modal .modal-body .tbl-grid th {
    width: 45%;
    padding: .125rem 1rem;
    font-size: .8125rem;
    font-weight: 500;
    text-align: left;
    color: #919599;
}

.calendar .modal .modal-body .tbl-grid td {
    width: 55%;
    padding: .125rem 1rem;
    font-size: .875rem;
    font-weight: 500;
    text-align: right;
}

.calendar .modal .modal-body .tbl-grid tr.border-btm {
    border-bottom: .0625rem dashed #ddd;
}

.calendar .modal .modal-body .tbl-grid tr.border-btm th,
.calendar .modal .modal-body .tbl-grid tr.border-btm td {
    padding-bottom: .75rem;
}

.calendar .modal .modal-body .tbl-grid tr.border-btm td {
    font-weight: bold;
}

.calendar .modal .modal-body .tbl-grid tr.border-btm+tr th,
.calendar .modal .modal-body .tbl-grid tr.border-btm+tr td {
    padding-top: .75rem;
}

.calendar .modal .modal-body .tbl-grid tr:last-child th,
.calendar .modal .modal-body .tbl-grid tr:last-child td {
    font-size: .9375rem;
    font-weight: bold;
    color: #1e293b;
}

.calendar .modal .modal-footer {
    padding: 1.5rem 0;
    text-align: center;
}

.calendar .modal .modal-footer button {
    width: 60%;
    max-width: 10rem;
}

.calendar .show_modal {
    opacity: 1;
    visibility: visible;
}

.calendar .show_modal .modal-dialog {
    top: 0;
}





/*-------------------- Invitation page --------------------*/
/* invitation - reset */
.invitation .w-12 {
    width: auto;
}

.invitation .mr-2,
.invitation .mt-2,
.invitation .mt-3,
.invitation .mt-4,
.invitation .mt-5 {
    margin: 0;
}

.invitation .p-5 {
    padding: 0;
}

.invitation .items-center {
    align-items: stretch;
}

.invitation {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    min-height: auto;
    padding: 0 0 1rem;
    border-radius: 1rem;
}

.invitation .content:before {
    display: none;
}

.invitation .inner-wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.invitation .tab-wrap {
    position: relative;
    width: 100%;
    max-width: 33.75rem;
    padding-top: .75rem;
    border-bottom: .0625rem solid #d1d5d9;
}

.invitation .tab-wrap li {
    display: inline-block;
    position: relative;
}

.invitation .tab-wrap li:before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: -.0625rem;
    height: .1875rem;
    background: #064e3b;
    border-top-left-radius: .1875rem;
    border-top-right-radius: .1875rem;
    opacity: 0;
}

.invitation .tab-wrap li a {
    display: block;
    padding: 0 1rem;
    font-size: .875rem;
    font-weight: bold;
    line-height: 3.25rem;
    cursor: pointer;
}

.invitation .tab-wrap li.current:before {
    opacity: 1;
}

.invitation .content-wrap {
    width: 100%;
    max-width: 33.75rem;
    margin: 0 auto;
    padding: 2rem 0 1rem;
}

.invitation .intro-y {
    display: flex;
    flex-wrap: wrap;
    width: calc(100% + 1rem);
    margin-left: -.5rem;
    background: #f0f4f8;
    box-shadow: none;
}

.invitation .input {
    width: 100%;
    margin: 0 0 1rem;
}

.invitation .input>label {
    display: inline-block;
    margin-bottom: .375rem;
    font-size: .8125rem;
    font-weight: bold;
}

.invitation .input textarea {
    height: 11.25rem;
    resize: none;
}

.invitation .btn-wrap {
    margin: 1.5rem 0 1rem;
    text-align: center;
}

.invitation .btn-wrap button {
    width: 60%;
    max-width: 12.5rem;
}

/* invitation - invitationForm */
.invitation .content-wrap .invitationForm {
    display: none;
    margin: 0;
    padding: 0;
}

.invitation .content-wrap .invitationForm.active {
    display: block;
}

/* invitation - userInfo */
.invitation .content-wrap .userInfo {
    display: none;
    width: 100%;
    max-width: 33.75rem;
    margin: 0;
    padding: 0;
}

.invitation .content-wrap .userInfo.active {
    display: block;
}

.invitation .userInfo .admin-search-form {
    position: relative;
    padding: 1rem 1.25rem;
    border-radius: .5rem;
    box-shadow: 0 .25rem 1.25rem rgb(0 0 0 / 4%);
    background: #fff;
}

.invitation .userInfo .admin-search-form:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: inherit;
    border: .0625rem solid #064e3b;
    pointer-events: none;
}

.invitation .userInfo .search-wrap {
    padding: 0;
}

.invitation .userInfo .search-wrap .input:nth-child(2) {
    width: calc(100% - 6.25rem);
}

.invitation .userInfo .search-wrap .input:nth-child(2)+.btn-wrap {
    position: absolute;
    right: 1.25rem;
    bottom: 1rem;
    width: 5.5rem;
    white-space: nowrap;
}

.invitation .userInfo .search-wrap .input:nth-child(2)+.btn-wrap .btn {
    width: 100%;
}

.invitation .userInfo .merchant-send-list-box,
.userInfo .merchant-search-list-box {
    height: 2.375rem;
}

.invitation .userInfo .user-list {
    margin-top: 2.25rem;
}

.invitation .userInfo .tabulator .tabulator-header {
    border-width: 0;
}

.invitation .userInfo .tabulator .tabulator-tableHolder .tabulator-table {
    width: 100%;
    background: none;
}

.invitation .userInfo .tabulator .tabulator-row {
    margin-bottom: 1.25rem;
    border-radius: 0.75rem;
    border-bottom-width: 0;
    background: #fff;
}

.invitation .userInfo .tabulator .tabulator-row:hover {
    background: #e2e8f0;
}

.invitation .userInfo .tabulator .tabulator-row .tabulator-cell {
    height: auto;
    font-weight: bold;
}

.invitation .userInfo .tabulator .tabulator-row .tabulator-responsive-collapse table {
    width: 100%;
}

.invitation .userInfo .tabulator .tabulator-row .tabulator-responsive-collapse table tr td {
    padding-top: .1875rem;
    padding-bottom: .1875rem;
    font-size: .8125rem;
}

.invitation .userInfo .tabulator .tabulator-row .tabulator-responsive-collapse table tr td:nth-child(1) {
    font-weight: 500;
    color: #a1a5a9;
}

.invitation .userInfo .tabulator .tabulator-row .tabulator-responsive-collapse table tr td:nth-child(2) {
    font-weight: bold;
    text-align: right;
}

.invitation .userInfo .tabulator .tabulator-footer .tabulator-paginator {
    justify-content: center;
    margin: 0;
    text-align: center;
}

.invitation .userInfo .tabulator .tabulator-footer .tabulator-page.active {
    background: #064e3b;
    color: #fff;
}





/*-------------------- Admin page --------------------*/
/* Admin - modal */
#admin-modal #merchant-list-wrap {}

#admin-modal #merchant-list-wrap label {
    margin-bottom: 0;
}

#admin-modal #merchant-list-wrap .merchant-list-box {
    width: auto;
    height: 2.375rem;
    cursor: pointer
}

#admin-modal #merchant-list-wrap .merchant-list-box #merchant-list {
    height: 100%;
}

#admin-modal #merchant-list-wrap .btn-group>button {
    height: auto;
    line-height: 1.375rem;
}

/*-------------------- MultiSelect Custom 2022.11.29--------------------*/

.multiselect__wrapper {}

.multiselect__wrapper>span {
    display: inline-flex;
    -webkit-box-align: center;
    -webkit-box-pack: center;
    align-items: center;
    justify-content: center;
    column-gap: .25rem;
    position: relative;
    height: 1.875rem;
    margin: .3125rem .3125rem 0 0;
    padding: 0 .625rem;
    border-radius: 1.875rem;
    font-size: .8125rem;
    letter-spacing: -.02rem;
}

.multiselect__wrapper>span::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: inherit;
    border: .0625rem solid transparent;
    pointer-events: none;
}

.multiselect__wrapper .multiselect__input {}

.multiselect__wrapper .multiselect__clear-btn {
    border-radius: .375rem;
    background: #e7e7e7;
    color: #424242;
}

.multiselect__wrapper .multiselect__clear-btn::before {
    content: "전체삭제";
}

.multiselect__wrapper .multiselect__clear-btn svg {
    width: 1rem;
    height: 1rem;
    color: #1b293b;
}

.multiselect__wrapper .multiselect__selected {
    background: rgba(7, 79, 60, .08);
    color: #074f3c;
}

.multiselect__wrapper .multiselect__selected::after {
    border-color: rgba(7, 79, 60, .7);
}

.multiselect__wrapper .multiselect__remove-btn {
    align-items: center;
    justify-content: center;
    width: 1.125rem;
    height: 1.125rem;
    margin: 0 -.125rem 0 0;
    border-radius: 50%;
    background: rgba(7, 79, 60, .4);
}

.multiselect__wrapper .multiselect__remove-btn svg {
    width: .75rem;
    height: .75rem;
    color: #fff;
}


/*-------------------- Login alert box --------------------*/
.login_alert_box {
    display: none;
    position: fixed;
    left: 50%;
    bottom: 3.125rem;
    transform: translateX(-50%);
    width: 80%;
    max-width: 20rem;
    margin: 0;
    padding: 0 1.75rem;
    border-radius: 3.25rem;
    background: rgba(0, 0, 0, .8);
    z-index: 9999;
    cursor: pointer;
    animation: scrolldown 0.7s ease-in infinite alternate;
}

.login_alert_box span {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 3.25rem;
    font-size: .9375rem;
    font-weight: 500;
    line-height: 3.25rem;
    color: #fff;
}

.login_alert_box span::after {
    content: "연장";
    font-weight: bold;
    color: #cce568;
}

.login_alert_box.after span::after {
    content: "확인";
}

@keyframes scrolldown {
    0% {
        margin: 0;
    }

    100% {
        margin: 0 0 .1875rem;
    }
}

.agent_panel {
    display: block;
}

.agent_panel-1 {
    width: 100%;
}

.agent_panel-2 {
    width: 100%;
    flex-direction: row !important;
}




/**========================= [[ 640px 이상 ]] =========================**/
@media(min-width:640px) {

    .top-bar-boxed {
        display: block;
    }

    .content {
        margin-top: 0rem;
    }

    /*리스트 영역*/
    .merchant-search-list-box .dropdown-menu {
        width: 24rem;
    }


    /*-------------------- Header --------------------*/
    .mobile-menu .main_logo {
        width: auto;
    }

    .header_wrap {
        justify-content: space-between;
    }

    .header_wrap .header_left,
    .header_wrap .header_right {
        display: flex;
        align-items: center;
    }

    .header_wrap .header_left {}

    .header_wrap .header_right {
        gap: 1.25rem;
    }

    .header_wrap .logo {
        width: 2.5rem;
        left: .75rem;
        margin-right: .125rem;
        overflow: hidden;
    }

    .header_wrap .logo img {
        width: auto;
        max-width: none;
        height: 1.625rem;
    }

    .header_wrap .user_info_wrap {
        display: flex;
        flex-direction: column;
    }

    .header_wrap .user_name {
        display: flex;
        align-items: center;
        gap: .375rem;
        margin-bottom: -.0625rem;
    }

    .header_wrap .user_name p {
        font-weight: 500;
        color: #fff;
    }

    .header_wrap .user_name p::after {
        content: "님";
        opacity: rgba(255, 255, 255, .8);
    }

    .header_wrap .user_name span {
        position: relative;
        top: -.0625rem;
        padding: .125rem .375rem 0 .375rem;
        border-radius: 1.125rem;
        background: #434242;
        font-size: .6875rem;
        line-height: 1.125rem;
        color: #fff;
    }

    .header_wrap .user_organization {
        font-size: .75rem;
        color: rgba(255, 255, 255, .8);
    }

    .header_wrap .login_session_box {
        display: flex;
        align-items: center;
        gap: .75rem;
    }

    .header_wrap .login_session_box .timer_wrap {
        display: flex;
        align-items: center;
        gap: .375rem;
    }

    .header_wrap .login_session_box .timer_wrap i {}

    .header_wrap .login_session_box .timer_wrap svg {
        position: relative;
        top: -.0625rem;
        width: 1rem;
        height: 1rem;
        color: #fff;
    }

    .header_wrap .login_session_box .timer_wrap .timer {
        color: #fff;
    }

    .header_wrap .login_session_box .button_wrap {
        display: flex;
        border-radius: .25rem;
        border: .0625rem solid rgba(255, 255, 255, .6);
    }

    .header_wrap .login_session_box .button_wrap button {
        margin: 0;
        padding: 0 .625rem;
        border-radius: 0;
        background: rgba(255, 255, 255, .2);
        font-size: .75rem;
        line-height: 1.625rem;
        color: #fff;
    }

    .header_wrap .login_session_box .button_wrap button+button {
        border-left: .0625rem solid rgba(255, 255, 255, .6);
        background: none;
    }

    .top-bar-boxed[data-light-tenant-header="true"] {
        background: #d9dee3 !important;
        border-bottom: 1px solid #c3cbd3 !important;
    }

    .top-bar-boxed[data-light-tenant-header="true"] .header_wrap .logo {
        width: 5.25rem;
        height: 100%;
        left: 0;
        overflow: visible;
        display: flex;
        align-items: center;
    }

    .top-bar-boxed[data-light-tenant-header="true"] .header_wrap .logo img {
        width: auto;
        max-width: 5.25rem;
        height: 2.25rem;
        object-fit: contain;
    }

    .top-bar-boxed[data-light-tenant-header="true"] .header_wrap .user_name p {
        color: #334155;
    }

    .top-bar-boxed[data-light-tenant-header="true"] .header_wrap .user_name span {
        background: #dbe1e8;
        color: #334155;
    }

    .top-bar-boxed[data-light-tenant-header="true"] .header_wrap .login_session_box .button_wrap {
        border-color: #cbd5e1;
    }

    .top-bar-boxed[data-light-tenant-header="true"] .header_wrap .login_session_box .button_wrap button {
        background: #fff;
        color: #475569;
    }

    .top-bar-boxed[data-light-tenant-header="true"] .header_wrap .login_session_box .button_wrap button+button {
        border-left-color: #cbd5e1;
        background: #f8fafc;
    }




    /*-------------------- Dashboard page --------------------*/

    .dashboard .sales .panel ul {
        flex-grow: 1;
        flex-basis: 50%;
    }

    .dashboard .sales .panel ul+ul {
        margin: 0;
    }

    .dashboard .sales .panel li+li .calc-title {
        /* padding-left: .5rem; */
    }

    .dashboard .sales .panel li+li .calc-title::before {
        /* content: "";
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        width: .1875rem;
        height: .1875rem;
        border-radius: 50%;
        background: #64748b; */
    }





    /*-------------------- Payment page --------------------*/
    .payment {
        padding: 0 1rem;
    }





    /*-------------------- Calendar page --------------------*/
    .calendar {
        padding: 1rem;
    }

    .calendar .main-title-wrap .title {
        font-size: 1rem;
    }

    .calendar .content-wrap .content-col {
        padding: 2rem 0;
    }

    .calendar .content-wrap .title-wrap .title {
        font-size: 1rem;
    }

    /* calendar - chat box */
    .calendar .chat__box .title-wrap {
        padding: 1.25rem 1.75rem 1rem;
    }

    .calendar .chat__box .title-wrap .thumb {
        width: 2rem;
        height: 2rem;
    }

    .calendar .chat__box .title-wrap .name {
        margin-left: .625rem;
    }

    .calendar .chat__box .title-wrap .name h3 {
        font-size: .9375rem;
    }

    .calendar .chat__box .title-wrap .btn-notice {
        right: 1.75rem;
    }

    .calendar .chat__box .title-wrap .btn-notice button {
        height: 2rem;
        padding: 0 .875rem;
    }

    .calendar .chat__box .notice-wrap {
        padding: .75rem 1.75rem;
    }

    .calendar .chat__box .notice-wrap span {
        font-size: .9375rem;
    }

    .calendar .chat__box .chat-container {
        max-height: 37.5rem;
        padding: 1.25rem 1.75rem 0;
    }

    .calendar .chat__box .message-wrap input {
        height: 3.5rem;
        padding-left: 1.75rem;
        padding-right: 1.75rem;
    }

    .calendar .chat__box .message-wrap a {
        width: 3.5rem;
        height: 3.5rem;
    }

    .calendar .chat__box .message-wrap a svg {
        width: 1.375rem;
        height: 1.375rem;
        margin-left: -.125rem;
    }

    /* calendar - calendar */
    .calendar .calendar-category-wrap {
        position: absolute;
        top: 27px;
        right: 1.5rem;
        margin: 0;
        z-index: 1;
    }

    .calendar .calendar-category-wrap span {
        width: .75rem;
        height: .75rem;
        vertical-align: -.0625rem;
    }

    .calendar .calendar-category-wrap p {
        margin-left: .25rem;
        font-size: .8125rem;
    }

    .calendar .full-calendar .fc-header-toolbar {
        margin-bottom: 1.75rem;
    }

    .calendar .full-calendar .fc-header-toolbar .fc-left {
        width: 8rem;
    }

    .calendar .full-calendar .fc-header-toolbar .fc-left h2 {
        font-size: 1.0625rem;
    }

    .calendar .full-calendar .fc-header-toolbar .fc-right .fc-today-button {
        height: 2rem;
        padding: 0 1rem;
        line-height: 2rem;
    }

    .calendar .full-calendar .fc-header-toolbar .fc-right .fc-button-group {
        width: 12.5rem;
    }

    .calendar .full-calendar .fc-header-toolbar .fc-right .fc-button-group button span {
        font-size: 1rem;
    }

    .calendar .full-calendar .fc-view-container .fc-view .fc-body .fc-content-skeleton thead td.fc-today span {
        padding: .125rem .375rem;
        border-bottom-left-radius: .25rem;
        border-bottom-right-radius: .25rem;
        background: #94a3b8;
        color: #fff;
    }





    /*-------------------- Invitation page --------------------*/
    /* invitation - reset */
    .invitation .input {
        flex-direction: column;
    }

    /* invitation - userInfo */
    .invitation .userInfo .search-wrap {
        width: calc(100% + 1rem);
        margin-left: -.5rem;
    }

    .invitation .userInfo .search-wrap .input {
        margin: 0 .5rem 1rem;
    }

    .invitation .userInfo .search-wrap .input:nth-child(2),
    .userInfo .search-wrap .input:nth-child(2) input {
        width: 100%;
    }

    .invitation .userInfo .search-wrap .input:nth-child(2)+.btn-wrap {
        position: relative;
        right: auto;
        bottom: auto;
        margin: 0 .5rem 1rem;
    }

    .invitation .userInfo .search-wrap .input:nth-child(2)+.btn-wrap .btn {
        padding-left: 1.25rem;
        padding-right: 1.25rem;
    }




    /*-------------------- Tabulator --------------------*/
    .tabulator-row .tabulator-cell {
        /* height: 2.75rem !important; */
    }

    .form_filter {
        /* padding: 1.25rem 1.5rem 1.5rem; */
        padding: 0.5rem 1rem;
    }

    .form_filter::after {}

    .form_filter form {
        display: flex;
        align-items: flex-start;
        flex-wrap: wrap;
        gap: 1rem 1.25rem;
    }

    .form_filter .input_row {
        /* flex-grow: 1; */
    }

    .form_filter .input_row+.input_row {
        margin: 0;
    }

    .form_filter .input_row label {
        margin-bottom: .25rem;
    }

    .form_filter .input_wrap {}

    .form_filter .input_item {}

    .form_filter .input_item input {}

    .form_filter .input_item select {}

    .form_filter .input_item .sorting {
        position: absolute;
        top: 0;
        right: 0;
        margin-top: -.25rem;
    }

    .form_filter .input_item .sorting.d_none {
        display: flex;
    }

    .form_filter .input_item .sorting button {
        height: 1.5rem;
        padding: 0 .625rem;
        font-size: .75rem;
    }

    .form_filter .input_item .sorting button+button {}

    .form_filter .input_item .sorting button:first-child {}

    .form_filter .input_item .sorting button:last-child {}

    .form_filter .input_item .sorting button:focus {}

    .form_filter .input_item .datepicker {
        width: 100%;
        min-width: 12.5rem;
    }

    .form_filter .input_row.flex {
        display: block;
    }

    .form_filter .input_row.flex label {
        margin-bottom: .25rem;
        line-height: inherit;
    }

    .form_filter .input_row.flex .input_wrap {}

    .form_filter .input_item.flex {}

    .form_filter .input_item.flex select {}

    .form_filter .input_item.flex input {}

    .form_filter .button_wrap {
        flex-grow: 1;
        margin-top: 1.5rem;
        margin-left: auto;
        margin-right: auto;
    }

    .form_filter .button_wrap button {
        max-width: 15rem;
    }

    .form_filter .more_wrap {
        display: none;
    }

    .form_filter .more_wrap button {}

    .form_filter .more_wrap svg {}

    .form_filter .more_wrap span {}

    .form_filter .more_wrap.short svg {}

    .form_filter .d_none {
        display: block;
    }

    .tabulator_summary_wrap {
        display: flex;
        flex-wrap: wrap;
        column-gap: .875rem;
    }

    .tabulator_summary_wrap .input_wrap {
        /* flex-direction: column; */
        flex-basis: 30%;
        flex-grow: 1;
        padding: .5rem;
        /* padding: .5rem 0; */
    }

    .tabulator_summary_wrap .input_wrap+.input_wrap {
        margin: 0;
    }

    .tabulator_summary_wrap .input_wrap input {
        padding: .125rem 0 0;
        font-size: .9375rem;
        text-align: center;
    }

    .tabulator_summary_wrap .input_wrap.d_none {
        display: flex;
    }

    .tabulator_summary_wrap .btn_more {
        display: none;
    }

    .tabulator_summary_wrap .btn_more svg {}

    .tabulator_summary_wrap .btn_more.active {}

    .tabulator_summary_wrap .btn_more.active svg {}

    .tabulator_summary_wrap .tabulator_total_cnt_wrap {
        width: 100%;
    }

    .tabulator_summary_wrap .d_none {}

}







/**========================= [[ 768px 이상 ]] =========================**/
@media(min-width:768px) {

    .content {
        height: 100dvh;
        margin-top: 0;
        padding-top: 3.625rem !important;
        padding-bottom: 40px;
        overflow-y: auto;
    }


    /*-------------------- Header --------------------*/
    .top-bar-boxed {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        height: auto;
        padding: .375rem 1.25rem;
        /* padding: .375rem 1.375rem; */
        background: #000000;
    }

    .top-bar-boxed::before,
    .top-bar-boxed::after {
        display: none;
    }

    .top-bar-boxed .logo {
        width: 61px;
        /* width: auto; */
        /* height: 30px; */
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        /* width: 2.5rem; */
        /* left: .75rem; */
        /* margin-right: .125rem; */
        overflow: hidden;
    }

    .top-bar-boxed .logo img {
        width: auto;
        max-width: none;
        height: 2rem;
    }



    /*-------------------- Login alert box --------------------*/
    .login_alert_box {
        left: auto;
        right: 1.375rem;
        transform: none;
    }



    /*-------------------- Side nav --------------------*/
    .side-nav {
        width: 13rem;
        height: 100dvh;
        padding: 5rem .75rem 4rem;
        overflow-y: auto;
    }

    .side-nav .side-menu .side-menu__title {
        display: flex;
        justify-content: space-between;
        position: relative;
        transform: none;
        left: 0;
        width: 100%;
        padding-left: .5rem;
        box-shadow: none;
        border-radius: 0;
        background: none;
        opacity: 1;
        visibility: visible;
    }

    .side-nav .side-menu .side-menu__title::before {
        display: none;
    }

    .side-nav .side-menu .side-menu__icon svg {
        width: 1.25rem;
        height: 1.25rem;
    }

    .side-nav>ul>li>.side-menu {
        padding-left: 0.75rem;
    }

    .side-nav ul li .depth-2 {
        margin-left: 0;
        margin-bottom: .25rem;
        padding: .125rem 0;
    }

    .side-nav ul li .depth-2 li+li {
        margin-top: .125rem;
    }

    .side-nav ul li .depth-2 li a {
        height: 2.5rem;
        margin: 0;
        padding-left: 0.75rem;
    }

    .side-nav ul li .depth-2 .side-menu__icon svg {
        width: 1.125rem;
        height: 1.125rem;
    }

    .side-nav ul li .depth-2 .side-menu__title {
        min-width: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .side-nav ul li .depth-2 .side-menu__title>span {
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .side-nav ul li .depth-2 .side-menu__title::before {
        content: "";
    }

    .side-nav ul li .depth-2 li.depth-2-divider {
        height: 1px;
        margin: 0.5rem 0.75rem;
        background-color: rgba(0, 0, 0, 0.1);
        border: none;
        list-style: none;
        padding: 0;
    }


    /*-------------------- Modal --------------------*/
    .modal .modal-dialog {
        transform: translateY(-50%);
        margin: auto;
        padding: 1rem 2rem;
    }

    .show_modal .modal-dialog {
        top: 50%;
    }





    /*-------------------- Payment page --------------------*/
    .payment {
        padding-top: 1.5rem;
    }

    .payment .tab-wrap {
        padding-top: 1.5rem;
    }

    .payment .tab-wrap li a {
        font-size: .9375rem;
    }





    /*-------------------- Calendar page --------------------*/
    .calendar {
        padding-top: 1.5rem;
    }

    /* calendar - calendar */
    .calendar .full-calendar .fc-view-container .fc-view .fc-body .fc-row {
        min-height: 6rem;
    }

    .calendar .full-calendar .fc-view-container .fc-view .fc-head .fc-row th span {
        font-size: .8125rem;
        line-height: 2rem;
    }

    .calendar .full-calendar .fc-view-container .fc-view .fc-body .fc-content-skeleton thead td span {
        display: inline-block;
        font-size: .8125rem;
    }

    .calendar .full-calendar .fc-view-container .fc-view .fc-body .fc-content-skeleton tbody td .fc-day-grid-event {
        margin-top: .1875rem;
    }

    .calendar .full-calendar .fc-view-container .fc-view .fc-body .fc-content-skeleton tbody td .fc-day-grid-event .fc-content span {
        font-size: .75rem;
    }

    /* calendar - modal */
    .calendar .modal .modal-dialog {
        transform: translateY(-50%);
        margin: auto;
        padding: 1rem 2rem;
    }

    .calendar .show_modal .modal-dialog {
        top: 50%;
    }

    /* calendar - calendar */
    .calendar .calendar-category-wrap {
        top: 25px;
    }



    /*-------------------- Invitation page --------------------*/
    /* invitation - reset */
    .invitation {
        padding-top: 1.5rem;
    }

    .invitation .tab-wrap {
        /*padding-top: 1.5rem;*/
    }

    .invitation .tab-wrap li a {
        font-size: .9375rem;
    }





    /*-------------------- Dashboard page --------------------*/
    .dashboard.inner-wrap {
        /* padding-top: 1rem; */
    }

    .dashboard .main-title-wrap .title,
    .dashboard .branchList .box>div:nth-child(1) div {
        font-size: .9375rem;
    }

    .dashboard .panel {
        margin: 1rem 0;
        flex-direction: row !important;
    }

    .dashboard .calc-table {
        display: flex;
        flex-wrap: wrap;
        width: calc(100% + 1rem);
        margin-left: -.5rem;
    }

    .dashboard .calc-table li {
        width: calc(50% - 1rem);
        margin: 0 .5rem 1rem;
        padding: 1.25rem 1.5rem;
    }

    .dashboard .calc-table li+li {
        margin-top: 0;
    }

    .dashboard .calc-table li .calc-title,
    .dashboard .calc-table li .calc-cnt {
        font-size: .875rem;
    }

    .dashboard .calc-table li progress {
        margin-bottom: 0;
    }

    .dashboard .dailyStatsChart,
    .dashboard .monthlyStatsChart {
        position: relative;
        height: 22rem;
        padding: 1rem 1rem;
        border-radius: .5rem;
        box-shadow: 0 .25rem .5rem rgb(0 0 0 / 4%);
        background: #fff;
        overflow: hidden;
    }

    .dashboard .dailyStatsChart:before,
    .dashboard .monthlyStatsChart:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border-radius: inherit;
        border: .0625rem solid rgb(0 0 0 / 8%);
        pointer-events: none;
    }

    .dashboard .branchList>div+div,
    .dashboard .notice-wrap>div+div {
        margin-top: 1rem;
    }

    .dashboard .branchList .box {
        min-height: 5rem;
        padding: 1.25rem 1.5rem;
    }

    .dashboard .branchList .box>div:nth-child(2) {
        padding: .5rem 1rem;
        font-size: .875rem;
    }

    .dashboard .branchList .box>div span {
        margin-right: .875rem;
    }

    .dashboard .notice-wrap>div {
        padding: 1.5rem;
    }

    .dashboard .notice-wrap .text-base {
        margin-bottom: .75rem;
    }

    .dashboard .notice-wrap .text-slate-500 {
        line-height: 1.6;
    }




    /*-------------------- Tabulator --------------------*/
    .form_filter {}

    .form_filter::after {}

    .form_filter form {}

    .form_filter .input_row {}

    .form_filter .input_row+.input_row {}

    .form_filter .input_row label {}

    .form_filter .input_wrap {}

    .form_filter .input_item {}

    .form_filter .input_item input {}

    .form_filter .input_item select {}

    .form_filter .input_item .datepicker {}

    .form_filter .input_row.flex {}

    .form_filter .input_row.flex label {}

    .form_filter .input_row.flex .input_wrap {}

    .form_filter .input_item.flex {}

    .form_filter .input_item.flex select {}

    .form_filter .input_item.flex input {}

    .form_filter .button_wrap {}

    .form_filter .button_wrap button {}

    .tabulator_sorting_wrap {}

    .tabulator_sorting_wrap .excel_download {}

    .tabulator_sorting_wrap .excel_download button {}

    .tabulator_sorting_wrap .excel_download button:hover {}

    .tabulator_sorting_wrap .excel_download button svg {}

    .tabulator_sorting_wrap .rows_per_page {}

    .tabulator_sorting_wrap .rows_per_page select {}

    .tabulator_summary_wrap {}

    .tabulator_summary_wrap .input_wrap {}

    .tabulator_summary_wrap .input_wrap label {}

    .tabulator_summary_wrap .input_wrap input {
        padding-top: .25rem;
        font-size: 1rem;
        text-align: center;
    }

    .tabulator_total_cnt_wrap {
        margin: .1875rem 0 0;
        padding-left: 2rem;
    }

    .tabulator_total_cnt_wrap input {
        font-size: .9375rem
    }

    .tabulator_total_cnt_wrap input:focus {}

    .tabulator_summary_wrap .tabulator_total_cnt_wrap {
        margin-top: .5rem;
        padding: 0;
    }

    .form_filter.outer {
        padding: 1rem 0 0;
        background: none;
    }

    .form_filter.outer .input_row {
        max-width: 21.875rem;
    }

    .form_filter.outer .input_row label {
        display: none;
    }

    .form_filter.outer .button_wrap {
        margin-top: 0;
    }

    .form_filter.outer::after {
        display: none;
    }

    .form_filter+.box {
        /* margin-top: 1.25rem; */
        margin-top: .5rem;
    }

    .dashboard .sales .panel ul li {
        display: flex;
        /* flex-direction: column; */
        position: relative;
        padding: 1rem .75rem;
        /* box-shadow: 0 .25rem .5rem rgba(0, 0, 0, .04); */
        background: #fff;
        align-items: stretch;
        justify-content: space-between;
    }

    .dashboard .sales .panel ul li .calc-title {
        display: block;
        position: relative;
        /* margin-bottom: .375rem; */
        color: #64748b;
        /* width: 100%; */
    }

    .agent_panel {
        display: flex;
        gap: 1rem;
    }

    .agent_panel-1 {
        width: 50%;
    }

    .agent_panel-2 {
        width: 50%;
    }
}










/**========================= [[ 1280px 이상 ]] =========================**/
@media(min-width:1280px) {
    body {
        /* overflow-y: hidden; */
    }



    /*-------------------- Header --------------------*/
    .top-bar-boxed {
        padding: .375rem 0.75rem;
    }

    .top-bar-boxed .logo {
        left: 0;
        width: 165px;
        display: flex;
        align-items: center;
        justify-content: center;
        /* width: auto; */
        /* margin-right: .375rem; */
    }

    .top-bar-boxed .logo img {
        height: 2.5rem;
    }

    .header_wrap {}

    .header_wrap .header_left,
    .header_wrap .header_right {}

    .header_wrap .header_left {}

    .header_wrap .header_right {}

    .header_wrap .logo {}

    .header_wrap .logo img {}

    .header_wrap .user_info_wrap {
        flex-direction: row;
        gap: 1rem;
    }

    .header_wrap .user_info_wrap::after {
        content: "";
        margin-left: .5rem;
        border-left: .0625rem solid rgba(255, 255, 255, .4);
    }

    .header_wrap .user_name {
        margin: 0;
    }

    .header_wrap .user_name p {}

    .header_wrap .user_name p::after {}

    .header_wrap .user_name span {}

    .header_wrap .user_organization {
        font-size: .8125rem;
    }

    .header_wrap .login_session_box {}

    .header_wrap .login_session_box .timer_wrap {}

    .header_wrap .login_session_box .timer_wrap i {}

    .header_wrap .login_session_box .timer_wrap svg {}

    .header_wrap .login_session_box .timer_wrap .timer {}

    .header_wrap .login_session_box .button_wrap {}

    .header_wrap .login_session_box .button_wrap button {}

    .header_wrap .login_session_box .button_wrap button+button {}


    /*-------------------- Dashboard page --------------------*/
    .dashboard .sales {}

    .dashboard .sales .content-wrap {
        flex-direction: column;
    }

    .dashboard .sales .content-item {
        width: auto !important;
    }

    .dashboard .sales .content-item+.content-item {
        margin-top: 1rem;
        /* margin-top: 1.375rem; */
    }

    .dashboard .sales .panel {
        height: auto !important;
        min-height: auto !important;
        column-gap: 1rem;
    }

    .dashboard .sales .panel ul {}

    .dashboard .sales .panel ul+ul {}

    .dashboard .sales .panel ul li {
        /* padding: 1.25rem 1.5rem; */
        padding: 1rem 1rem;
    }

    .dashboard .sales .panel ul li:first-child {}

    .dashboard .sales .panel ul li:last-child {}

    .dashboard .sales .panel ul li .calc-title {
        font-size: 1rem;
    }

    .dashboard .sales .panel ul li .calc-item {}

    .dashboard .sales .panel ul li .calc-item money {
        font-size: 1rem;
        /* font-size: 1.3rem; */
    }

    .dashboard .sales .panel ul li .cancelation {}

    .dashboard .sales .panel .em li:first-child {}

    .dashboard .sales .panel .em li:first-child .calc-title {}

    .dashboard .sales .panel .em li:first-child .calc-item money {}

    .dashboard .sales .panel .em li:first-child .calc-item span {}

    .dashboard .sales .panel ul li+li {}

    .dashboard .sales .panel li+li .calc-title {
        font-size: .8rem;
        /* font-size: .875rem; */
    }

    .dashboard .sales .panel li+li .calc-item money {
        font-size: .95rem;
        /* font-size: 1rem; */
        /* font-size: 1.25rem; */
    }

    .dashboard .sales .panel li+li .calc-item span {}

    .dashboard .sales .panel li+li~li {}




    /*-------------------- Tabulator --------------------*/
    .tabulator {
        /* height: calc(100dvh - 11rem); */
        /* height: calc(100dvh - 14rem); */
        /* height: 580px; */
    }

    .tabulator-row .tabulator-cell {
        /* height: 2rem !important; */
        line-height: 1.2rem !important;
        padding-top: .59375rem;
        padding-bottom: .59375rem;
    }



    .tabulator .tabulator-footer {}

    .form_filter {}

    .form_filter::after {}

    .form_filter form {
        column-gap: 1.75rem
    }

    .form_filter .input_row {}

    .form_filter .input_row+.input_row {}

    .form_filter .input_row label {}

    .form_filter .input_wrap {}

    .form_filter .input_item {}

    .form_filter .input_item input {}

    .form_filter .input_item select {}

    .form_filter .input_item .datepicker {}

    .form_filter .input_row.flex {}

    .form_filter .input_row.flex label {}

    .form_filter .input_row.flex .input_wrap {}

    .form_filter .input_item.flex {}

    .form_filter .input_item.flex select {}

    .form_filter .input_item.flex input {}

    .form_filter .button_wrap {}

    .form_filter .button_wrap button {}

    .form_filter .button_wrap.separate {
        /* margin-left: 30%; */
    }

    .form_filter .button_wrap button.on-pc {
        display: inline-flex;
    }

    .tabulator_sorting_wrap {}

    .tabulator_sorting_wrap .excel_download {}

    .tabulator_sorting_wrap .excel_download button {}

    .tabulator_sorting_wrap .excel_download button:hover {}

    .tabulator_sorting_wrap .excel_download button svg {}

    .tabulator_sorting_wrap .rows_per_page {}

    .tabulator_sorting_wrap .rows_per_page select {}

    .tabulator_sorting_wrap {}

    .tabulator_sorting_wrap .excel_download {}

    .tabulator_sorting_wrap .excel_download button {}

    .tabulator_sorting_wrap .excel_download button:hover {}

    .tabulator_sorting_wrap .excel_download button svg {}

    .tabulator_sorting_wrap .rows_per_page {}

    .tabulator_sorting_wrap .rows_per_page select {}

    .tabulator_sorting_wrap .rows_per_page.on-pc {
        display: block;
    }

    .tabulator_summary_wrap {
        margin-bottom: .5rem;
        height: 36px;
    }

    .tabulator_summary_wrap .input_wrap {
        flex-direction: row;
        flex-basis: 13.75rem;
        flex-grow: 0;
        column-gap: 0.5rem;
        padding: .5rem 1rem;
    }

    .tabulator_summary_wrap .input_wrap label {}

    .tabulator_summary_wrap .input_wrap input {
        padding: 0;
        text-align: right;
    }

    .tabulator_total_cnt_wrap {
        position: absolute;
        right: 1.5rem;
        margin: 0;
        padding: 0;
    }

    .tabulator_total_cnt_wrap input {
        padding: 0;
        border-radius: 0;
        background: none;
        font-size: 1rem;
        text-align: right;
    }

    .tabulator_total_cnt_wrap input:focus {}

    .tabulator_summary_wrap .tabulator_total_cnt_wrap {
        right: 0;
        width: auto;
    }

    .tabulator_sorting_wrap .excel_download .tabulator_total_cnt_wrap {}

    .tabulator_sorting_wrap .excel_download .tabulator_total_cnt_wrap input {}




    /*-------------------- Admin page --------------------*/

    /*-------------------- MultiSelect Custom 2022.11.29--------------------*/

    .admin-wrap .form_filter #merchant-search-list-wrap {
        max-width: 25rem;
    }

    .admin-wrap .form_filter #merchant-search-list-wrap+.input_row {}

    .admin-wrap .form_filter .button_wrap {
        max-width: 12rem;
    }

    .admin-wrap .form_filter .button_wrap+.button_wrap {
        max-width: 20rem;
    }

    .multiselect__wrapper {}

    .multiselect__wrapper>span {}

    .multiselect__wrapper>span::after {}

    .multiselect__wrapper .multiselect__input {}

    .multiselect__wrapper .multiselect__clear-btn {}

    .multiselect__wrapper .multiselect__clear-btn::before {}

    .multiselect__wrapper .multiselect__clear-btn svg {}

    .multiselect__wrapper .multiselect__selected {}

    .multiselect__wrapper .multiselect__selected::after {}

    .multiselect__wrapper .multiselect__remove-btn {}

    .multiselect__wrapper .multiselect__remove-btn svg {}





    /*-------------------- Payment page --------------------*/
    .payment .inner-wrap {
        display: block;
    }

    .payment .tab-wrap {
        max-width: none;
        border: none;
    }

    .payment .tab-wrap li:nth-child(1) {
        width: 33rem;
    }

    .payment .tab-wrap li a {
        padding: 0;
        font-size: 1.0625rem;
        cursor: auto;
    }

    .payment .tab-wrap li.current:before {
        opacity: 0;
    }

    .payment .content-wrap {
        display: flex;
        max-width: none;
        padding: .5rem 0 0 !important;
    }

    .payment .intro-y {
        width: 100%;
        height: calc(100dvh - 14rem);
        margin-left: 0;
        padding: 2rem 1rem 1rem;
        background: #fff;
        overflow-y: auto;
    }

    /* Payment - payForm */
    .payment .content-wrap .payForm {
        display: block;
        width: 30rem;
        flex-shrink: 0;
        box-shadow: 0 .25rem 1.25rem rgba(0, 0, 0, .04);
        overflow-y: hidden;
    }

    .payment .intro-y {
        display: flex;
        flex-wrap: wrap;
        top: 0;
    }

    .payment .payForm .input {
        margin: 0 .75rem 1.375rem;
    }

    .payment .payForm .input:nth-child(1) {
        width: calc(60% - 1.5rem);
    }

    .payment .payForm .input:nth-child(2) {
        width: calc(40% - 1.5rem);
    }

    .payment .payForm .input:nth-child(3) {
        width: calc(60% - 1.5rem);
    }

    .payment .payForm .input:nth-child(4) {
        width: calc(40% - 1.5rem);
    }

    .payment .payForm .input:nth-child(5) {
        width: calc(60% - 1.5rem);
    }

    .payment .payForm .input:nth-child(6) {
        width: calc(40% - 1.5rem);
    }

    .payment .payForm .input:nth-child(7) {
        width: calc(50% - 1.5rem);
    }

    .payment .payForm .input:nth-child(8) {
        width: calc(50% - 1.5rem);
    }

    .payment .payForm .input:nth-child(9) {
        width: calc(70% - 1.5rem);
    }

    .payment .payForm .input:nth-child(10) {
        width: calc(30% - 1.5rem);
    }

    .payment .payForm .input:nth-child(11) {
        width: calc(40% - 1.5rem);
    }

    .payment .payForm .input:nth-child(12) {
        width: calc(30% - 1.5rem);
    }

    .payment .payForm .input:nth-child(13) {
        width: calc(30% - 1.5rem);
    }

    /* Payment - cardInfo */
    .payment .content-wrap .cardInfo {
        display: block;
        width: calc(100% - 33rem);
        max-width: none;
        margin-left: 3rem;
        padding: 2rem 1.75rem 1rem;
        box-shadow: 0 .25rem 1.25rem rgba(0, 0, 0, .04);
    }

    .payment .cardInfo .tabulator-header {
        border-top-width: .0625rem;
        border-bottom-width: .0625rem;
    }

    .payment .cardInfo .tabulator-headers>div:nth-child(1) {
        display: inline-block;
    }

    .payment .cardInfo .tabulator-headers>div:nth-child(2) .tabulator-col-content {
        margin: 0;
        text-align: left;
    }

    .payment .cardInfo .tabulator-headers>div:nth-child(2) .tabulator-col-sorter {
        margin: 0;
    }

    .payment .cardInfo .tabulator-headers>div:nth-child(2) .tabulator-col-title {
        font-size: .875rem;
        font-weight: normal;
    }

    .payment .cardInfo .tabulator-tableHolder {
        margin: 0;
    }

    .payment .cardInfo .tabulator-tableHolder .tabulator-table {
        width: auto;
        background: #fff;
    }

    .payment .cardInfo .tabulator-row,
    .payment .cardInfo .tabulator-row.tabulator-row-even {
        margin: 0;
        background: none;
        border-radius: 0;
        border-bottom-width: .0625rem;
    }

    .payment .cardInfo .tabulator-row:nth-child(even) {
        background: #f1f5f9;
    }

    .payment .cardInfo .tabulator-row .tabulator-cell {
        height: 3.125rem !important;
        font-weight: normal;
    }





    /*-------------------- Calendar page --------------------*/
    .calendar {
        padding: 1.5rem 2rem 1rem;
    }

    .calendar .main-title-wrap {
        max-width: none;
        border: none;
    }

    .calendar .main-title-wrap .title {
        padding: 0;
        font-size: 1.0625rem;
    }

    .calendar .main-title-wrap .title:before {
        opacity: 0;
    }

    .calendar .content-wrap {
        flex-direction: row;
        padding: .5rem 0 2rem;
    }

    .calendar .content-wrap .content-col {
        max-width: none;
    }

    .calendar .content-wrap .content-col.left {
        width: 26rem;
        padding: 0;
        order: 1;
    }

    .calendar .content-wrap .content-col.right {
        margin-left: 0px;
        width: calc(100% - 29rem);
        height: calc(100dvh - 14rem);
        padding: 1.5rem 2rem 2rem;
        border-radius: .375rem;
        box-shadow: 0 .25rem 1.25rem rgb(0 0 0 / 4%);
        background: #fff;
        overflow-y: auto;
    }

    .calendar .content-wrap .content-col.right::-webkit-scrollbar {
        display: block;
        width: 1.125rem;
    }

    .calendar .content-wrap .content-col.right::-webkit-scrollbar-thumb {
        height: 15%;
        border: .375rem solid transparent;
        background-clip: content-box;
        background-color: rgba(0, 0, 0, .25);
        border-radius: 1.125rem;
    }

    .calendar .content-wrap .content-col.right::-webkit-scrollbar-track {
        background-color: rgba(0, 0, 0, 0);
    }

    .calendar .content-wrap .content-item {
        margin: 0;
    }

    /* calendar - chat box */
    .calendar .chat__box {
        margin-top: 1.5rem;
    }

    .calendar .chat__box .cal-chat-wrap:before {
        display: none;
    }

    .calendar .chat__box .title-wrap {
        border: none;
        box-shadow: 0 .25rem .5rem rgb(0 0 0 / 12%);
    }

    .calendar .chat__box .title-wrap .btn-notice button {
        font-size: .875rem;
    }

    .calendar .chat__box .notice-wrap {
        position: absolute;
        top: 4.25rem;
        left: 0;
        right: 0;
        border-top: .0625rem solid #ddd;
        border-bottom: 0;
        box-shadow: 0 .25rem .5rem rgb(0 0 0 / 12%);
        z-index: 1;
    }

    .calendar .chat__box .chat-container {
        height: calc(100dvh - 21.8125rem);
        max-height: none;
        min-height: auto;
    }

    /* calendar - calendar */
    .calendar .calendar-category-wrap {
        right: 2rem;
    }

    .calendar .calendar-category-wrap li {
        margin: 0 .875rem;
    }

    .calendar .full-calendar .fc-header-toolbar .fc-left {
        width: 10rem;
    }

    .calendar .full-calendar .fc-header-toolbar .fc-left h2 {
        font-size: 1.125rem;
    }

    .calendar .full-calendar .fc-header-toolbar .fc-right .fc-button-group {
        width: 14.5rem;
    }

    .calendar .full-calendar .fc-view-container .fc-view .fc-body .fc-row {
        min-height: 7rem;
    }

    .calendar .full-calendar .fc-view-container .fc-view .fc-body .fc-content-skeleton tbody td .fc-day-grid-event {
        padding: .0625rem .375rem;
    }

    .calendar .full-calendar .fc-view-container .fc-view .fc-body .fc-content-skeleton tbody td .fc-day-grid-event .fc-content span {
        font-size: .8125rem;
    }





    /*-------------------- Invitation page --------------------*/
    /* invitation - reset */
    .invitation {
        /*height: calc(100dvh - 9rem);*/
        padding: 1.5rem 1rem 0;
    }

    .invitation .inner-wrap {
        display: block;
    }

    .invitation .tab-wrap {
        max-width: none;
        border: none;
    }

    .invitation .tab-wrap li:nth-child(1) {
        width: 23rem;
    }

    .invitation .tab-wrap li a {
        padding: 0;
        font-size: 1.0625rem;
        cursor: auto;
    }

    .invitation .tab-wrap li.current:before {
        opacity: 0;
    }

    .invitation .content-wrap {
        display: flex;
        max-width: none;
        padding: .5rem 0 2rem;
    }

    /* invitation - invitationForm */
    .invitation .content-wrap .invitationForm {
        display: block;
        flex-shrink: 0;
        position: relative;
        width: 20rem;
        padding: 1.2rem 1.2rem 3.5rem;
        border-radius: 1.625rem;
        background: #454545;
    }

    .invitation .content-wrap .invitationForm:before,
    .content-wrap .invitationForm:after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        box-sizing: border-box;
        border-radius: inherit;
        pointer-events: none;
    }

    .invitation .content-wrap .invitationForm:before {
        box-shadow: inset 0 0 .6rem rgba(0, 0, 0, .5);
        z-index: 1;
    }

    .invitation .content-wrap .invitationForm:after {
        border: 1.2rem solid #454545;
        border-bottom-width: 3.5rem;
    }

    .invitation .content-wrap .mobile-button-shape1:before,
    .content-wrap .mobile-button-shape1:after,
    .content-wrap .mobile-button-shape2:before,
    .content-wrap .mobile-button-shape2:after {
        content: "";
        position: absolute;
        box-sizing: border-box;
        pointer-events: none;
    }

    .invitation .content-wrap .mobile-button-shape1:before,
    .content-wrap .mobile-button-shape2:before,
    .content-wrap .mobile-button-shape2:after {
        width: .375rem;
        height: 3rem;
        top: 30%;
        left: -.1875rem;
        background: #454545;
        border-radius: .1875rem;
    }

    .invitation .content-wrap .mobile-button-shape1:after {
        left: 50%;
        bottom: .6875rem;
        transform: translateX(-50%);
        width: 2.125rem;
        height: 2.125rem;
        border-radius: 50%;
        background: #767676;
        z-index: 1;
    }

    .invitation .content-wrap .mobile-button-shape2:before {
        height: 2.25rem;
        margin-top: -4rem;
    }

    .invitation .content-wrap .mobile-button-shape2:after {
        height: 2.25rem;
        margin-top: -7rem;
    }

    .invitation .content-wrap .invitation-search-form {
        height: 100%;
        min-height: 32.5rem;
        padding: 1rem;
        border-radius: .5rem;
        background: #fff;
        overflow: hidden;
    }

    /* invitation - userInfo */
    .invitation .content-wrap .userInfo {
        display: block;
        width: calc(100% - 23rem);
        max-width: none;
        margin-left: 3rem;
        padding: 2rem;
        box-shadow: 0 .25rem 1.25rem rgb(0 0 0 / 4%);
        background: #fff;
        overflow-y: auto;
    }

    .invitation .userInfo .admin-search-form {
        padding: 0;
        border-radius: 0;
        box-shadow: none;
        background: none;
    }

    .invitation .userInfo .admin-search-form:after {
        display: none;
    }

    .invitation .userInfo .search-wrap .input {
        flex-direction: row;
        align-items: center;
        width: auto;
    }

    .invitation .userInfo .search-wrap .input>label {
        margin: 0 .75rem 0 0;
        text-align: right;
        white-space: nowrap;
    }

    .invitation .userInfo .search-wrap .input:nth-child(2),
    .userInfo .search-wrap .input:nth-child(2) input {
        width: auto;
    }

    .invitation .userInfo .merchant-send-list-box,
    .userInfo .merchant-search-list-box {
        width: auto;
    }

    .invitation .userInfo .user-list {
        margin-top: 1rem;
    }

    .invitation .userInfo .tabulator .tabulator-header {
        border-top-width: .0625rem;
        border-bottom-width: .0625rem;
    }

    .invitation .userInfo .tabulator .tabulator-tableHolder .tabulator-table {
        background: #fff;
    }

    .invitation .userInfo .tabulator .tabulator-row {
        margin: 0;
        border-radius: 0;
        border-bottom-width: .0625rem;
        background: none;
    }

    .invitation .userInfo .tabulator .tabulator-row:nth-child(even) {
        background: #f1f5f9;
    }

    .invitation .userInfo .tabulator .tabulator-row:hover {
        background-color: rgb(var(--color-slate-200) / var(--tw-bg-opacity));
    }

    .invitation .userInfo .tabulator .tabulator-row .tabulator-cell {
        font-weight: normal;
    }





    /*-------------------- Dashboard page --------------------*/
    .dashboard.inner-wrap {
        flex-direction: row;
        align-items: flex-start;
        padding-top: .5rem;
    }

    .dashboard .content-container {
        max-width: none;
        height: calc(100dvh - 9rem);
        padding: .5rem 0 0;
    }

    .dashboard .content-container.c-left {
        width: 100%;
        max-width: 1400px;
        /* padding-right: 2rem; */
    }

    .dashboard .content-wrap {
        display: flex;
    }

    .dashboard .content-wrap .content-item {
        width: 100%;
    }

    .dashboard .content-container.c-left .content-wrap:nth-child(1) {
        margin-bottom: 1rem;
    }

    .dashboard .content-container.c-left+.content-container {
        width: 30%;
    }

    .dashboard .content-container.c-left .content-wrap:nth-child(1) .content-item {
        width: 50%;
        /* margin-right: 2rem; */
    }

    .dashboard .content-container.c-left .content-wrap:nth-child(2) .content-item:nth-child(1) {
        width: 60%;
        margin-right: 2rem;
    }

    .dashboard .content-container.c-left .content-wrap:nth-child(2) .content-item:nth-child(2) {
        width: 40%;
        margin-right: 2rem;
    }

    .dashboard .main-title-wrap {
        border: none;
    }

    .dashboard .main-title-wrap .title {
        padding: 0;
        font-size: 1.0625rem;
    }

    .dashboard .main-title-wrap .title:before {
        opacity: 0;
    }

    .dashboard .panel {
        margin: .25rem 0 0;
    }

    .dashboard .content-container.c-left .content-wrap:nth-child(1) .panel {
        height: calc(50vh - 13rem);
        min-height: 12rem;
    }

    .dashboard .content-container.c-left .content-wrap:nth-child(2) .panel {
        height: calc(50vh - 6rem);
        min-height: 19rem;
    }

    .dashboard .calc-table {
        height: 100%;
    }

    .dashboard .calc-table li {
        /*height: calc(50% - .5rem);*/
        margin: 0 .5rem;
        padding: 1rem 1.25rem;
    }

    .dashboard .calc-table li:nth-child(n + 3) {
        margin-top: 1rem;
    }

    .dashboard .calc-table li .calc-title {
        font-size: .8125rem;
    }

    .dashboard .dailyStatsChart {
        /*height: 100%*/
    }

    .dashboard .monthlyStatsChart {
        height: 100%;
        padding: 2rem 2rem 1.5rem 1.5rem;
    }

    .dashboard .branchList {
        height: calc(50vh - 6rem);
        min-height: 19rem;
        margin: .25rem 0 0;
    }

    .dashboard .branchList>div {
        height: 20%;
    }

    .dashboard .branchList>div+div {
        margin-top: .125rem;
    }

    .dashboard .branchList .box {
        height: calc(100% - .5rem);
        min-height: auto;
        padding: 0 1.375rem;
    }

    .dashboard .branchList .box>div span {
        top: -.1875rem;
        width: 2rem;
        height: 2rem;
        margin-right: .75rem;
        line-height: 1.5625rem;
    }

    .dashboard .branchList .box>div span:after {
        top: 1.25rem;
    }

    .dashboard .content-container.c-left+.content-container .content-wrap .panel {
        height: calc(100dvh - 13.75rem);
        min-height: 36.25rem;
    }

    .dashboard .notice-wrap {
        height: 100%;
    }

    .dashboard .notice-wrap>div {
        height: 62.5rem;
        /* height: calc(50% - .75rem); */
        min-height: auto;
        padding: 1.25rem;
    }

    .dashboard .notice-wrap .text-slate-500 {
        line-height: 1.4;
    }
}

@media (max-width: 640px) {
    .dashboard .sales .panel {
        gap: 0.5rem;
    }

    .dashboard .sales .panel ul {
        width: 100%;
        /* width: calc((100% - 1rem) / 2); */
    }

    .dashboard .sales .panel ul li+li {
        /* flex-direction: column; */
        align-items: unset;
    }
}

@media (max-width: 450px) {
    .dashboard .sales .panel ul li .calc-item money {
        font-size: 1rem;
    }

    .dashboard .sales .panel li+li .calc-item money {
        font-size: 1rem;
    }

    .list-info-box .gap ul li .left-text {
        padding: 6px 0px 6px 6px !important;
        font-weight: bold;
    }

    .list-info-box .gap ul li .right-text {
        padding: 6px 0px 6px 6px !important;
    }

    .infoFooter {
        font-size: 10px !important;
    }

    .font9 {
        font-size: 9.5px !important;
    }
}

.tabulator-tableHolder {
    /* height: auto !important; */
}

/* loading 시작 */
.pay_loading_wrap {
    /* display: none; */
    width: 100%;
    height: 100%;
    min-width: 100vw;
    min-height: 100dvh;

    background: rgb(0 0 0 / 65%);

    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 60;
}

.pay_loading_wrap .pay_loading {
    /* border-radius: 110px; */
    overflow: hidden;

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

/* loading 끝 */

/* alert modal, confirm modal START */
.modal .modal-footer .btn_ok {
    color: #fff;
    background-color: #434242;
}

/* alert modal, confirm modal END */

.backgroud_trans_form {
    animation: transBGColor 0.7s ease-in infinite alternate;
}

.BG_trans_white {
    background: white;
    color: rgb(var(--color-slate-500) / var(--tw-text-opacity));
}

.BG_trans_green {
    background: #434242;
    color: white;
}

.BG_trans_green:hover {
    background: #222222 !important;
    color: white !important;
}

/* 지갑잔액현황 헤더 필터 placeholder */
.wallet-header-filter::placeholder {
    color: rgba(255, 255, 255, 0.7);
    opacity: 1;
}

/* PG 헤더 툴팁 */
.pg-header-wrap .pg-help-icon:hover + .pg-tooltip,
.pg-header-wrap .pg-tooltip:hover {
    display: block !important;
}

/* Header-only visual scaling compensates for transparent padding in tenant logos. */
.top-bar-boxed[data-tenant-brand="베리타스온"] .header_wrap .logo,
.top-bar-boxed[data-tenant-brand="제이엠솔루션"] .header_wrap .logo,
.top-bar-boxed[data-tenant-brand="바로몰"] .header_wrap .logo,
.mobile-menu[data-tenant-brand="베리타스온"] .main_logo,
.mobile-menu[data-tenant-brand="제이엠솔루션"] .main_logo,
.mobile-menu[data-tenant-brand="바로몰"] .main_logo {
    overflow: visible;
}

.top-bar-boxed[data-tenant-brand="베리타스온"] .header_wrap .logo img,
.top-bar-boxed[data-tenant-brand="제이엠솔루션"] .header_wrap .logo img,
.top-bar-boxed[data-tenant-brand="바로몰"] .header_wrap .logo img,
.mobile-menu[data-tenant-brand="베리타스온"] .main_logo img,
.mobile-menu[data-tenant-brand="제이엠솔루션"] .main_logo img,
.mobile-menu[data-tenant-brand="바로몰"] .main_logo img {
    position: static;
    transform-origin: center;
    pointer-events: none;
}

.top-bar-boxed[data-tenant-brand="베리타스온"] .header_wrap .logo img {
    transform: scale(1.65);
}

.top-bar-boxed[data-tenant-brand="제이엠솔루션"] .header_wrap .logo img {
    transform: scale(2.6);
}

.top-bar-boxed[data-tenant-brand="바로몰"] .header_wrap .logo img {
    transform: scale(3.7);
}

.mobile-menu[data-tenant-brand="베리타스온"] .main_logo img {
    transform: scale(2.3);
}

.mobile-menu[data-tenant-brand="제이엠솔루션"] .main_logo img {
    transform: scale(3.7);
}

.mobile-menu[data-tenant-brand="바로몰"] .main_logo img {
    transform: scale(5.3);
}
`, "",{"version":3,"sources":["webpack://./src/Pages/css/common.css"],"names":[],"mappings":"AAAA,iEAAiE;AACjE;IACI;QACI,iBAAiB;QACjB,2DAA2D;IAC/D;;IAEA;QACI,mBAAmB;QACnB,YAAY;IAChB;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,+BAA+B;IAC/B,sBAAsB;IACtB,wBAAwB;IACxB,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;AAChC;;AAEA,QAAQ;AACR;IACI,aAAa;IACb,0BAA0B;IAC1B,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,SAAS;IACT,SAAS;IACT,UAAU;IACV,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,SAAS;IACT,WAAW;IACX,8BAA8B;IAC9B,kDAAkD;IAClD,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,SAAS;IACT,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,gCAAgC;IAChC,kBAAkB;IAClB,WAAW;IACX,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,gCAAgC;IAChC,kBAAkB;IAClB,WAAW;IACX,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IAEd,gKAAwJ;IAAxJ,wJAAwJ;IACxJ,iLAAgN;IAChN,0BAA0B;IAC1B,wDAAwD;AAC5D;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IAEd,gKAAwJ;IAAxJ,wJAAwJ;IACxJ,iLAAgN;IAChN,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;;AAGA,kFAAkF;;AAElF;IACI;AACJ;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sBAAsB;IAEtB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,SAAS;IACT,WAAW;IACX,uBAAuB;IAEvB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IAGI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA,oBAAoB;AACpB;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,4BAA4B;AAChC;;;AAGA,sFAAsF;AACtF;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sBAAsB;IAEtB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,SAAS;IACT,WAAW;IACX,uBAAuB;IAEvB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IAGI,2BAA2B;AAC/B;;AAEA,oBAAoB;AACpB;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;;;;;AAMA,WAAW;AACX;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;IAChB,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;IAChB,wBAAwB;IACxB,gBAAgB;IAChB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,qBAAqB;IACrB,qCAAqC;AACzC;;AAEA;IACI,wBAAwB;IACxB,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;;;;;;IAMI,iCAAiC;AACrC;;;AAGA,WAAW;AACX;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sBAAsB;IAEtB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,SAAS;IACT,WAAW;IACX,uBAAuB;IAEvB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IAGI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,SAAS;AACT;IACI,oCAAoC;AACxC;;;AAGA,kFAAkF;AAClF,MAAM;AACN;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA,QAAQ;AACR;IACI,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;;AAGA,SAAS;AACT;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;IAChB,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;IAChB,wBAAwB;IACxB,gBAAgB;IAChB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,qBAAqB;IACrB,qCAAqC;AACzC;;AAEA;IACI,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;IAChB,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;IAChB,wBAAwB;IACxB,gBAAgB;IAChB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,qBAAqB;IACrB,qCAAqC;AACzC;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;AACtB;;;;AAIA;;;;;;IAMI,iCAAiC;AACrC;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA,kFAAkF;AAClF;;;IAGI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,0BAA0B;IAC1B,eAAe;IACf,qBAAqB;IACrB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,cAAc;IACd,WAAW;AACf;;AAEA;IACI,gCAAgC;IAChC,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,gCAAgC;IACpC;AACJ;;AAEA;IACI,6BAA6B;AACjC;;AAEA;;IAEI,WAAW;IACX,cAAc;IACd,WAAW;AACf;;AAEA;;IAEI,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,iBAAiB;IACjB,sBAAsB;IACtB,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,UAAU;IACV,iBAAiB;IACjB,sBAAsB;IACtB,eAAe;IACf,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;;;AAIA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB;IACtB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,QAAQ;IACR,WAAW;IACX,gCAAgC;IAChC,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;;IAEI,qBAAqB;IACrB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,oCAAoC;AACxC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA,iBAAiB;;AAEjB;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gCAAgC;AACpC;;AAEA;;IAEI,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;IACrB,eAAe;IACf,WAAW;IACX,mCAAmC;IACnC,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;;IAEI,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,cAAc;AAClB;;;;;AAKA,iFAAiF;AACjF;IACI,UAAU;IACV,eAAe;IACf,UAAU;IACV,aAAa;IACb,QAAQ;IACR,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,4CAA4C;AAChD;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,4CAA4C;AAChD;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT;AACJ;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;IAChC,oBAAoB;IACpB;AACJ;;AAEA,iHAAiH;AACjH;IACI,UAAU;IACV,WAAW;IACX,6BAA6B;AACjC;AACA;IACI,4BAA4B;IAC5B,kBAAkB;AACtB;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,uBAAuB;AAC3B;;AAEA,YAAY;AACZ;IACI,OAAO;IACP,WAAW;AACf;;AAEA;;IAEI,WAAW;IACX,WAAW;IACX,cAAc;AAClB;;;;;;AAMA,mDAAmD;AACnD;IACI,MAAM;IACN,OAAO;IACP,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;AACd;;AAEA,oCAAoC;;AAEpC;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;;AAGA;IACI,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,WAAW;AACf;;AAEA;;IAEI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,4CAA4C;IAC5C,eAAe;IACf,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,MAAM;IACN,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,eAAe;IACf,4CAA4C;IAC5C,2BAA2B;IAC3B,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;IACV,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,yBAAyB;IACzB,SAAS;IACT,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI,SAAS;IACT,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,mCAAmC;IACnC,qCAAqC;AACzC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mEAAmE;IACnE,aAAa;AACjB;;AAEA;IACI,mEAAmE;IACnE,aAAa;AACjB;;AAEA;IACI,QAAQ;IACR,UAAU;AACd;;;AAGA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kCAAkC;IAClC,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,qBAAqB;IACrB,eAAe;IACf,gBAAgB;AACpB;;;AAGA;IACI,4BAA4B;AAChC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,oBAAoB;IACpB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,kCAAkC;IAClC,mBAAmB;AACvB;;;;;AAKA,kDAAkD;AAClD,sCAAsC;AACtC;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,mDAAmD;IACnD,WAAW;IACX,YAAY;IACZ,SAAS;IACT,4BAA4B;IAC5B,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;IACV,eAAe;AACnB;;;AAGA;;IAEI,kBAAkB;;IAElB,QAAQ;IACR,2BAA2B;IAC3B,qBAAqB;IACrB,wBAAwB;;IAExB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;;IAEI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;;IAEI,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA;;IAEI,MAAM;AACV;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;AACjB;;;AAGA,wEAAwE;;AAExE,oCAAoC;;AAEpC;IACI,UAAU;AACd;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gTAAgT;IAChT,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oDAAoD;IACpD,qDAAqD;IACrD,oBAAoB;AACxB;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,oBAAoB;IACpB,cAAc;AAClB;;AAEA,8DAA8D;;AAE9D;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA,oDAAoD;;AAEpD;IACI,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI;;;;;uBAKmB;AACvB;;AAEA;IACI;;;;;;;qBAOiB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,gCAAgC;IAChC,YAAY;IACZ,8BAA8B;IAC9B,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,cAAc;IACd,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,UAAU;IACV,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,+BAA+B;IAC/B,YAAY;IACZ,cAAc;AAClB;;AAEA,8DAA8D;;AAE9D;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;;;;;;;AAQA,sDAAsD;AACtD;IACI,sBAAsB;IACtB,kCAAkC;IAClC,yBAAyB;AAC7B;;AAEA,gBAAgB;;AAEhB;IACI,YAAY;AAChB;;AAEA;IACI,4BAA4B;IAC5B,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;IAC3B,6BAA6B;IAC7B,qBAAqB;IACrB,iCAAiC;AACrC;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;IAClC,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iCAAiC;IACjC,4BAA4B;IAC5B,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,SAAS;IACT,kBAAkB;AACtB;;AAEA,mEAAmE;;AAEnE,oEAAoE;;AAEpE;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mCAAmC;IACnC,oBAAoB;IACpB,qBAAqB;IACrB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sBAAsB;IACtB,mCAAmC;IACnC,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA,0BAA0B;;AAE1B;IACI,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,+BAA+B;IAC/B,kCAAkC;AACtC;;AAEA;IACI,gCAAgC;IAChC,mCAAmC;AACvC;;AAEA;IACI,+GAA+G;AACnH;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,qBAAqB;AACzB;;AAEA,0CAA0C;;AAE1C;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA,qCAAqC;;AAErC;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,SAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,0CAA0C;IAC1C,WAAW;IACX,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;IACtB,8BAA8B;IAC9B,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,iCAAiC;IACjC,4CAA4C;AAChD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,oBAAoB;IACpB,sBAAsB;IACtB,+CAA+C;IAC/C,gBAAgB;IAChB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,UAAU;AACd;;AAEA;IACI,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;AACnB;;AAEA,0CAA0C;;AAE1C;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;;;;;;AAOA,2DAA2D;AAC3D;IACI,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,qCAAqC;AACzC;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;IAChC,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,8BAA8B;IAC9B,kDAAkD;IAClD,mBAAmB;AACvB;;AAEA,6DAA6D;AAC7D;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,4BAA4B;IAC5B,aAAa;IACb,mDAAmD;IACnD,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,8BAA8B;IAC9B,gDAAgD;AACpD;;AAEA;IACI,gCAAgC;IAChC,iCAAiC;AACrC;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,gDAAgD;;AAEhD;IACI,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,oBAAoB;IACpB,yCAAyC;IACzC,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sBAAsB;IACtB,sCAAsC;IACtC,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;IACb,oBAAoB;IACpB,0CAA0C;IAC1C,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;IAEI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,qBAAqB;IACrB,oBAAoB;IACpB,0CAA0C;IAC1C,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sBAAsB;IACtB,sCAAsC;IACtC,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,2BAA2B;IAC3B,QAAQ;IACR,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;IACnB,iDAAiD;IACjD,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA,sBAAsB;AACtB;IACI,qBAAqB;IACrB,kEAAkE;IAClE,sEAAsE;IACtE,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;IACrB,kEAAkE;IAClE,sEAAsE;IACtE,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;IACrB,kEAAkE;IAClE,sEAAsE;IACtE,+BAA+B;AACnC;;AAEA;IACI,MAAM;IACN,gBAAgB;IAChB,qBAAqB;IACrB,sEAAsE;IACtE,+BAA+B;AACnC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,0CAA0C;IAC1C,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sBAAsB;IACtB,sCAAsC;IACtC,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;;IAEI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,SAAS;IACT,UAAU;IACV,UAAU;AACd;;;;;;AAMA,yDAAyD;AACzD;IACI,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,qCAAqC;AACzC;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;IAChC,iCAAiC;IACjC,UAAU;AACd;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,wBAAwB;IACxB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,SAAS;IACT,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,oBAAoB;AACxB;;AAEA,gCAAgC;;AAEhC;IACI,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,SAAS;AACb;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;;IAEI,sBAAsB;IACtB,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA,oBAAoB;AACpB;IACI,8BAA8B;AAClC;;AAEA;IACI,4BAA4B;AAChC;;AAEA,4DAA4D;AAC5D;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;;AAEhB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA,iCAAiC;;AAEjC;IACI,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,SAAS;AACb;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;;;AAIA;IACI,WAAW;IACX,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,sCAAsC;AAC1C;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,iBAAiB;IACjB,oBAAoB;;AAExB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,iCAAiC;IACjC,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;;AAGA;;IAEI;;;;OAIG;IACH;QACI,yBAAyB;QACzB,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;AAEJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA,0DAA0D;AAC1D;IACI,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,qCAAqC;AACzC;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;IAChC,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA,wBAAwB;AACxB;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,0CAA0C;IAC1C,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sBAAsB;IACtB,2BAA2B;IAC3B,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,4BAA4B;IAC5B,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sBAAsB;IACtB,sCAAsC;IACtC,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,kCAAkC;IAClC,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,iCAAiC;IACjC,4BAA4B;IAC5B,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,+BAA+B;IAC/B,oCAAoC;IACpC,qCAAqC;IACrC,kCAAkC;AACtC;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,2BAA2B;IAC3B,cAAc;IACd,eAAe;IACf,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,QAAQ;IACR,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;IACrB,iBAAiB;IACjB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,OAAO;IACP,eAAe;IACf,SAAS;AACb;;AAEA;IACI,WAAW;IACX,cAAc;IACd,eAAe;IACf,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sBAAsB;IACtB,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,qBAAqB;AACrB;IACI,gBAAgB;AACpB;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,eAAe;IACf,UAAU;IACV,mBAAmB;IACnB,cAAc;IACd,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;;IAEI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;IACV,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,MAAM;AACV;;;;;;AAMA,4DAA4D;AAC5D,uBAAuB;AACvB;IACI,WAAW;AACf;;AAEA;;;;;IAKI,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,qCAAqC;AACzC;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;IAChC,iCAAiC;IACjC,UAAU;AACd;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,wBAAwB;IACxB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA,gCAAgC;AAChC;IACI,aAAa;IACb,SAAS;IACT,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,oBAAoB;IACpB,4CAA4C;IAC5C,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sBAAsB;IACtB,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;;;;;AAMA,uDAAuD;AACvD,kBAAkB;AAClB,kCAAkC;;AAElC;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,qBAAqB;AACzB;;AAEA,yEAAyE;;AAEzE,uBAAuB;;AAEvB;IACI,oBAAoB;IACpB,yBAAyB;IACzB,wBAAwB;IACxB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;IAC7B,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sBAAsB;IACtB,kCAAkC;IAClC,oBAAoB;AACxB;;AAEA,2CAA2C;;AAE3C;IACI,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,cAAc;IACd,WAAW;AACf;;;AAGA,4DAA4D;AAC5D;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,2BAA2B;IAC3B,UAAU;IACV,gBAAgB;IAChB,SAAS;IACT,kBAAkB;IAClB,sBAAsB;IACtB,6BAA6B;IAC7B,aAAa;IACb,eAAe;IACf,qDAAqD;AACzD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,SAAS;IACb;;IAEA;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,8BAA8B;AAClC;;;;;AAKA,uEAAuE;AACvE;;IAEI;QACI,cAAc;IAClB;;IAEA;QACI,gBAAgB;IACpB;;IAEA,SAAS;IACT;QACI,YAAY;IAChB;;;IAGA,mDAAmD;IACnD;QACI,WAAW;IACf;;IAEA;QACI,8BAA8B;IAClC;;IAEA;;QAEI,aAAa;QACb,mBAAmB;IACvB;;IAEA,2BAA2B;;IAE3B;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,qBAAqB;QACrB,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,YAAY;QACZ,wBAAwB;IAC5B;;IAEA;QACI,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,gCAAgC;IACpC;;IAEA;QACI,kBAAkB;QAClB,cAAc;QACd,kCAAkC;QAClC,uBAAuB;QACvB,mBAAmB;QACnB,mBAAmB;QACnB,qBAAqB;QACrB,WAAW;IACf;;IAEA;QACI,iBAAiB;QACjB,8BAA8B;IAClC;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,WAAW;IACf;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,YAAY;IAChB;;IAEA,+CAA+C;;IAE/C;QACI,kBAAkB;QAClB,cAAc;QACd,WAAW;QACX,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;QACb,qBAAqB;QACrB,8CAA8C;IAClD;;IAEA;QACI,SAAS;QACT,kBAAkB;QAClB,gBAAgB;QAChB,mCAAmC;QACnC,iBAAiB;QACjB,qBAAqB;QACrB,WAAW;IACf;;IAEA;QACI,mDAAmD;QACnD,gBAAgB;IACpB;;IAEA;QACI,8BAA8B;QAC9B,2CAA2C;IAC/C;;IAEA;QACI,cAAc;QACd,YAAY;QACZ,OAAO;QACP,iBAAiB;QACjB,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,0BAA0B;QAC1B,mBAAmB;IACvB;;;;;IAKA,2DAA2D;;IAE3D;QACI,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI;;;;;;;;8BAQsB;IAC1B;;;;;;IAMA,yDAAyD;IACzD;QACI,eAAe;IACnB;;;;;;IAMA,0DAA0D;IAC1D;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA,wBAAwB;IACxB;QACI,6BAA6B;IACjC;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,0BAA0B;IAC9B;;IAEA;QACI,cAAc;QACd,qBAAqB;QACrB,sBAAsB;IAC1B;;IAEA;QACI,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,qBAAqB;IACzB;;IAEA,wBAAwB;IACxB;QACI,kBAAkB;QAClB,SAAS;QACT,aAAa;QACb,SAAS;QACT,UAAU;IACd;;IAEA;QACI,aAAa;QACb,cAAc;QACd,yBAAyB;IAC7B;;IAEA;QACI,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,YAAY;QACZ,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,wBAAwB;QACxB,iCAAiC;QACjC,kCAAkC;QAClC,mBAAmB;QACnB,WAAW;IACf;;;;;;IAMA,4DAA4D;IAC5D,uBAAuB;IACvB;QACI,sBAAsB;IAC1B;;IAEA,0BAA0B;IAC1B;QACI,wBAAwB;QACxB,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,oBAAoB;IACxB;;IAEA;QACI,qBAAqB;QACrB,sBAAsB;IAC1B;;;;;IAKA,sDAAsD;IACtD;QACI,gCAAgC;IACpC;;IAEA;QACI,oCAAoC;QACpC,oBAAoB;IACxB;;IAEA,qBAAqB;;IAErB;QACI,aAAa;QACb,uBAAuB;QACvB,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,qBAAqB;IACzB;;IAEA,0BAA0B;;IAE1B,0BAA0B;;IAE1B,gCAAgC;;IAEhC,iCAAiC;;IAEjC;QACI,kBAAkB;QAClB,MAAM;QACN,QAAQ;QACR,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA,iDAAiD;;IAEjD,sDAAsD;;IAEtD,qDAAqD;;IAErD,gDAAgD;;IAEhD;QACI,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,qBAAqB;QACrB,oBAAoB;IACxB;;IAEA,0CAA0C;;IAE1C,+BAA+B;;IAE/B,sCAAsC;;IAEtC,qCAAqC;;IAErC;QACI,YAAY;QACZ,kBAAkB;QAClB,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA,gCAAgC;;IAEhC,6BAA6B;;IAE7B,8BAA8B;;IAE9B,mCAAmC;;IAEnC;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,4BAA4B;QAC5B,eAAe;QACf,YAAY;QACZ,cAAc;QACd,sBAAsB;IAC1B;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,oBAAoB;QACpB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA,uCAAuC;;IAEvC,0CAA0C;;IAE1C,8CAA8C;;IAE9C;QACI,WAAW;IACf;;IAEA,iCAAiC;;AAErC;;;;;;;;AAQA,uEAAuE;AACvE;;IAEI;QACI,cAAc;QACd,aAAa;QACb,gCAAgC;QAChC,oBAAoB;QACpB,gBAAgB;IACpB;;;IAGA,mDAAmD;IACnD;QACI,eAAe;QACf,MAAM;QACN,OAAO;QACP,QAAQ;QACR,YAAY;QACZ,wBAAwB;QACxB,+BAA+B;QAC/B,mBAAmB;IACvB;;IAEA;;QAEI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,iBAAiB;QACjB,kBAAkB;QAClB,OAAO;QACP,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,mBAAmB;QACnB,kBAAkB;QAClB,2BAA2B;QAC3B,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,YAAY;IAChB;;;;IAIA,4DAA4D;IAC5D;QACI,UAAU;QACV,eAAe;QACf,eAAe;IACnB;;;;IAIA,qDAAqD;IACrD;QACI,YAAY;QACZ,cAAc;QACd,yBAAyB;QACzB,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,kBAAkB;QAClB,eAAe;QACf,OAAO;QACP,WAAW;QACX,mBAAmB;QACnB,gBAAgB;QAChB,gBAAgB;QAChB,gBAAgB;QAChB,UAAU;QACV,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,cAAc;QACd,qBAAqB;QACrB,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,SAAS;QACT,qBAAqB;IACzB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,mBAAmB;QACnB,gBAAgB;QAChB,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;QAChB,uBAAuB;IAC3B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,sBAAsB;QACtB,oCAAoC;QACpC,YAAY;QACZ,gBAAgB;QAChB,UAAU;IACd;;;IAGA,kDAAkD;IAClD;QACI,2BAA2B;QAC3B,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,QAAQ;IACZ;;;;;;IAMA,yDAAyD;IACzD;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;;;;;IAMA,0DAA0D;IAC1D;QACI,mBAAmB;IACvB;;IAEA,wBAAwB;IACxB;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,iBAAiB;IACrB;;IAEA;QACI,qBAAqB;QACrB,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,iBAAiB;IACrB;;IAEA,qBAAqB;IACrB;QACI,2BAA2B;QAC3B,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,QAAQ;IACZ;;IAEA,wBAAwB;IACxB;QACI,SAAS;IACb;;;;IAIA,4DAA4D;IAC5D,uBAAuB;IACvB;QACI,mBAAmB;IACvB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,mBAAmB;IACvB;;;;;;IAMA,2DAA2D;IAC3D;QACI,uBAAuB;IAC3B;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,8BAA8B;IAClC;;IAEA;QACI,aAAa;QACb,eAAe;QACf,wBAAwB;QACxB,mBAAmB;IACvB;;IAEA;QACI,uBAAuB;QACvB,oBAAoB;QACpB,uBAAuB;IAC3B;;IAEA;QACI,aAAa;IACjB;;IAEA;;QAEI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;;QAEI,kBAAkB;QAClB,aAAa;QACb,kBAAkB;QAClB,oBAAoB;QACpB,0CAA0C;QAC1C,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;;QAEI,WAAW;QACX,kBAAkB;QAClB,MAAM;QACN,OAAO;QACP,QAAQ;QACR,SAAS;QACT,sBAAsB;QACtB,sCAAsC;QACtC,oBAAoB;IACxB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,uBAAuB;IAC3B;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,gBAAgB;IACpB;;;;;IAKA,sDAAsD;IACtD,cAAc;;IAEd,qBAAqB;;IAErB,mBAAmB;;IAEnB,yBAAyB;;IAEzB,oCAAoC;;IAEpC,+BAA+B;;IAE/B,0BAA0B;;IAE1B,0BAA0B;;IAE1B,gCAAgC;;IAEhC,iCAAiC;;IAEjC,sCAAsC;;IAEtC,8BAA8B;;IAE9B,oCAAoC;;IAEpC,0CAA0C;;IAE1C,+BAA+B;;IAE/B,sCAAsC;;IAEtC,qCAAqC;;IAErC,2BAA2B;;IAE3B,kCAAkC;;IAElC,yBAAyB;;IAEzB,yCAAyC;;IAEzC,gDAAgD;;IAEhD,sDAAsD;;IAEtD,oDAAoD;;IAEpD,wCAAwC;;IAExC,+CAA+C;;IAE/C,yBAAyB;;IAEzB,qCAAqC;;IAErC,2CAA2C;;IAE3C;QACI,mBAAmB;QACnB,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,oBAAoB;QACpB,kBAAkB;IACtB;;IAEA;QACI;IACJ;;IAEA,uCAAuC;;IAEvC;QACI,iBAAiB;QACjB,UAAU;IACd;;IAEA;QACI,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,yBAAyB;QACzB,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,4BAA4B;QAC5B,kBAAkB;QAClB,oBAAoB;QACpB,mDAAmD;QACnD,gBAAgB;QAChB,oBAAoB;QACpB,8BAA8B;IAClC;;IAEA;QACI,cAAc;QACd,kBAAkB;QAClB,4BAA4B;QAC5B,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,SAAS;IACb;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;;;;;;;;;;AAWA,wEAAwE;AACxE;IACI;QACI,wBAAwB;IAC5B;;;;IAIA,mDAAmD;IACnD;QACI,wBAAwB;IAC5B;;IAEA;QACI,OAAO;QACP,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,iBAAiB;QACjB,2BAA2B;IAC/B;;IAEA;QACI,cAAc;IAClB;;IAEA,cAAc;;IAEd;gCAC4B;;IAE5B,2BAA2B;;IAE3B,4BAA4B;;IAE5B,oBAAoB;;IAEpB,wBAAwB;;IAExB;QACI,mBAAmB;QACnB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,mDAAmD;IACvD;;IAEA;QACI,SAAS;IACb;;IAEA,2BAA2B;;IAE3B,kCAAkC;;IAElC,8BAA8B;;IAE9B;QACI,mBAAmB;IACvB;;IAEA,iCAAiC;;IAEjC,6CAA6C;;IAE7C,+CAA+C;;IAE/C,iDAAiD;;IAEjD,oDAAoD;;IAEpD,8CAA8C;;IAE9C,qDAAqD;;IAErD,4DAA4D;;;IAG5D,2DAA2D;IAC3D,mBAAmB;;IAEnB;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;QAChB,0BAA0B;IAC9B;;IAEA;QACI,uBAAuB;QACvB,2BAA2B;QAC3B,gBAAgB;IACpB;;IAEA,6BAA6B;;IAE7B,gCAAgC;;IAEhC;QACI,6BAA6B;QAC7B,kBAAkB;IACtB;;IAEA,4CAA4C;;IAE5C,2CAA2C;;IAE3C;QACI,eAAe;IACnB;;IAEA,2CAA2C;;IAE3C;QACI,eAAe;QACf,uBAAuB;IAC3B;;IAEA,6CAA6C;;IAE7C,6CAA6C;;IAE7C,yDAAyD;;IAEzD,8DAA8D;;IAE9D,6DAA6D;;IAE7D,mCAAmC;;IAEnC;QACI,gBAAgB;QAChB,wBAAwB;IAC5B;;IAEA;QACI,iBAAiB;QACjB,qBAAqB;QACrB,wBAAwB;IAC5B;;IAEA,gDAAgD;;IAEhD,mCAAmC;;;;;IAKnC,sDAAsD;IACtD;QACI,kCAAkC;QAClC,kCAAkC;QAClC,mBAAmB;IACvB;;IAEA;QACI,6BAA6B;QAC7B,8BAA8B;QAC9B,sBAAsB;QACtB,yBAAyB;IAC7B;;;;IAIA,8BAA8B;;IAE9B,cAAc;;IAEd,qBAAqB;;IAErB;QACI;IACJ;;IAEA,yBAAyB;;IAEzB,oCAAoC;;IAEpC,+BAA+B;;IAE/B,0BAA0B;;IAE1B,0BAA0B;;IAE1B,gCAAgC;;IAEhC,iCAAiC;;IAEjC,sCAAsC;;IAEtC,8BAA8B;;IAE9B,oCAAoC;;IAEpC,0CAA0C;;IAE1C,+BAA+B;;IAE/B,sCAAsC;;IAEtC,qCAAqC;;IAErC,2BAA2B;;IAE3B,kCAAkC;;IAElC;QACI,sBAAsB;IAC1B;;IAEA;QACI,oBAAoB;IACxB;;IAEA,yBAAyB;;IAEzB,yCAAyC;;IAEzC,gDAAgD;;IAEhD,sDAAsD;;IAEtD,oDAAoD;;IAEpD,wCAAwC;;IAExC,+CAA+C;;IAE/C,yBAAyB;;IAEzB,yCAAyC;;IAEzC,gDAAgD;;IAEhD,sDAAsD;;IAEtD,oDAAoD;;IAEpD,wCAAwC;;IAExC,+CAA+C;;IAE/C;QACI,cAAc;IAClB;;IAEA;QACI,oBAAoB;QACpB,YAAY;IAChB;;IAEA;QACI,mBAAmB;QACnB,oBAAoB;QACpB,YAAY;QACZ,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA,2CAA2C;;IAE3C;QACI,UAAU;QACV,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,aAAa;QACb,SAAS;QACT,UAAU;IACd;;IAEA;QACI,UAAU;QACV,gBAAgB;QAChB,gBAAgB;QAChB,eAAe;QACf,iBAAiB;IACrB;;IAEA,uCAAuC;;IAEvC;QACI,QAAQ;QACR,WAAW;IACf;;IAEA,mEAAmE;;IAEnE,yEAAyE;;;;;IAKzE,uDAAuD;;IAEvD,yEAAyE;;IAEzE;QACI,gBAAgB;IACpB;;IAEA,gEAAgE;;IAEhE;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA,uBAAuB;;IAEvB,4BAA4B;;IAE5B,mCAAmC;;IAEnC,2CAA2C;;IAE3C,+CAA+C;;IAE/C,uDAAuD;;IAEvD,mDAAmD;;IAEnD,8CAA8C;;IAE9C,qDAAqD;;IAErD,gDAAgD;;IAEhD,oDAAoD;;;;;;IAMpD,yDAAyD;IACzD;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,oBAAoB;QACpB,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,aAAa;QACb,eAAe;QACf,6BAA6B;IACjC;;IAEA;QACI,WAAW;QACX,4BAA4B;QAC5B,cAAc;QACd,uBAAuB;QACvB,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA,sBAAsB;IACtB;QACI,cAAc;QACd,YAAY;QACZ,cAAc;QACd,+CAA+C;QAC/C,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,eAAe;QACf,MAAM;IACV;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA,uBAAuB;IACvB;QACI,cAAc;QACd,yBAAyB;QACzB,eAAe;QACf,iBAAiB;QACjB,0BAA0B;QAC1B,+CAA+C;IACnD;;IAEA;QACI,0BAA0B;QAC1B,6BAA6B;IACjC;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,SAAS;QACT,gBAAgB;IACpB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;;QAEI,SAAS;QACT,gBAAgB;QAChB,gBAAgB;QAChB,6BAA6B;IACjC;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,2BAA2B;QAC3B,mBAAmB;IACvB;;;;;;IAMA,0DAA0D;IAC1D;QACI,yBAAyB;IAC7B;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,oBAAoB;IACxB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,mBAAmB;QACnB,qBAAqB;IACzB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,UAAU;QACV,QAAQ;IACZ;;IAEA;QACI,gBAAgB;QAChB,yBAAyB;QACzB,4BAA4B;QAC5B,yBAAyB;QACzB,sBAAsB;QACtB,4CAA4C;QAC5C,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,iCAAiC;QACjC,4BAA4B;QAC5B,oCAAoC;QACpC,uBAAuB;IAC3B;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,SAAS;IACb;;IAEA,wBAAwB;IACxB;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,2CAA2C;IAC/C;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,OAAO;QACP,QAAQ;QACR,+BAA+B;QAC/B,gBAAgB;QAChB,2CAA2C;QAC3C,UAAU;IACd;;IAEA;QACI,iCAAiC;QACjC,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA,wBAAwB;IACxB;QACI,WAAW;IACf;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,mBAAmB;IACvB;;;;;;IAMA,4DAA4D;IAC5D,uBAAuB;IACvB;QACI,+BAA+B;QAC/B,sBAAsB;IAC1B;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,oBAAoB;QACpB,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,aAAa;QACb,eAAe;QACf,qBAAqB;IACzB;;IAEA,gCAAgC;IAChC;QACI,cAAc;QACd,cAAc;QACd,kBAAkB;QAClB,YAAY;QACZ,6BAA6B;QAC7B,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;;QAEI,WAAW;QACX,kBAAkB;QAClB,MAAM;QACN,OAAO;QACP,QAAQ;QACR,SAAS;QACT,sBAAsB;QACtB,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,6CAA6C;QAC7C,UAAU;IACd;;IAEA;QACI,4BAA4B;QAC5B,2BAA2B;IAC/B;;IAEA;;;;QAII,WAAW;QACX,kBAAkB;QAClB,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;;;QAGI,cAAc;QACd,YAAY;QACZ,QAAQ;QACR,eAAe;QACf,mBAAmB;QACnB,uBAAuB;IAC3B;;IAEA;QACI,SAAS;QACT,gBAAgB;QAChB,2BAA2B;QAC3B,eAAe;QACf,gBAAgB;QAChB,kBAAkB;QAClB,mBAAmB;QACnB,UAAU;IACd;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,mBAAmB;QACnB,aAAa;QACb,oBAAoB;QACpB,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA,0BAA0B;IAC1B;QACI,cAAc;QACd,yBAAyB;QACzB,eAAe;QACf,iBAAiB;QACjB,aAAa;QACb,4CAA4C;QAC5C,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,UAAU;QACV,gBAAgB;QAChB,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,mBAAmB;QACnB,mBAAmB;QACnB,WAAW;IACf;;IAEA;QACI,oBAAoB;QACpB,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;;QAEI,WAAW;IACf;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,0BAA0B;QAC1B,6BAA6B;IACjC;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,SAAS;QACT,gBAAgB;QAChB,6BAA6B;QAC7B,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,oEAAoE;IACxE;;IAEA;QACI,mBAAmB;IACvB;;;;;;IAMA,2DAA2D;IAC3D;QACI,mBAAmB;QACnB,uBAAuB;QACvB,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,2BAA2B;QAC3B,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,iBAAiB;QACjB,yBAAyB;IAC7B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;;IAEA;QACI,UAAU;QACV,kBAAkB;IACtB;;IAEA;QACI,UAAU;QACV,kBAAkB;IACtB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,oBAAoB;IACxB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,0BAA0B;QAC1B,iBAAiB;IACrB;;IAEA;QACI,yBAAyB;QACzB,iBAAiB;IACrB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,6BAA6B;QAC7B,eAAe;QACf,qBAAqB;IACzB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,gCAAgC;IACpC;;IAEA;QACI,yBAAyB;QACzB,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,0BAA0B;QAC1B,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,WAAW;QACX,YAAY;QACZ,oBAAoB;QACpB,sBAAsB;IAC1B;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,+BAA+B;QAC/B,oBAAoB;IACxB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,gCAAgC;QAChC,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,oCAAoC;IACxC;;IAEA;QACI,4BAA4B;QAC5B,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mCAAmC;QACnC,iBAAiB;IACrB;;IAEA;QACI,mCAAmC;IACvC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI,6BAA6B;AACjC;;AAEA,eAAe;AACf;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;;IAElB,4BAA4B;;IAE5B,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;;IAEhB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA,cAAc;;AAEd,qCAAqC;AACrC;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA,mCAAmC;;AAEnC;IACI,uDAAuD;AAC3D;;AAEA;IACI,iBAAiB;IACjB,2DAA2D;AAC/D;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA,6BAA6B;AAC7B;IACI,+BAA+B;IAC/B,UAAU;AACd;;AAEA,aAAa;AACb;;IAEI,yBAAyB;AAC7B;;AAEA,oFAAoF;AACpF;;;;;;IAMI,iBAAiB;AACrB;;AAEA;;;;;;IAMI,gBAAgB;IAChB,wBAAwB;IACxB,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":["/**========================= [[ 공통 ]] =========================**/\r\n@keyframes transBGColor {\r\n    0% {\r\n        background: white;\r\n        color: rgb(var(--color-slate-500) / var(--tw-text-opacity));\r\n    }\r\n\r\n    100% {\r\n        background: #064e3b;\r\n        color: white;\r\n    }\r\n}\r\n\r\ninput::placeholder {\r\n    font-size: 12px;\r\n}\r\n\r\n.top-bar-boxed {\r\n    display: none;\r\n}\r\n\r\n.content {\r\n    min-height: calc(100dvh - 67px);\r\n    /* min-height: auto; */\r\n    /* margin-top: 4.5rem; */\r\n    margin-top: 52px;\r\n    /* border-radius: 1.25rem; */\r\n}\r\n\r\n.content:before {\r\n    display: none;\r\n}\r\n\r\n.text-ovreflow {\r\n    word-break: break-all;\r\n    word-wrap: break-word;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    display: -webkit-box;\r\n    -webkit-line-clamp: 2;\r\n    -webkit-box-orient: vertical;\r\n}\r\n\r\n/* top */\r\n.dropdown-user-info {\r\n    z-index: 9999;\r\n    /* inset: 0 auto auto 0; */\r\n    /* visibility: hidden; */\r\n    position: absolute;\r\n    /* opacity: 0; */\r\n    width: 170px;\r\n    margin: 0;\r\n    top: 42px;\r\n    right: 0px;\r\n    /* transform: translate(-192px, 53px); */\r\n}\r\n\r\n.dropdown-alarm {\r\n    z-index: 9999;\r\n    position: absolute;\r\n    width: 170px;\r\n    margin: 0;\r\n    top: 42px;\r\n    right: 85px;\r\n    background: rgb(255, 255, 255);\r\n    box-shadow: rgba(0, 0, 0, 0.04) 0px 0.25rem 0.5rem;\r\n    border: 2px solid #dfdfdf;\r\n    border-radius: 10px;\r\n}\r\n\r\n.notification .notification__icon {\r\n    width: 1.5rem;\r\n    height: 1.5rem;\r\n}\r\n\r\n.notification_list {\r\n    z-index: 9999;\r\n    inset: 0 auto auto 0;\r\n    visibility: hidden;\r\n    position: absolute;\r\n    opacity: 1;\r\n    width: 224px;\r\n    margin: 0;\r\n    transform: translate(-166px, 53px);\r\n}\r\n\r\n.notification_list .show>.dropdown-content {\r\n    margin-top: .25rem;\r\n}\r\n\r\n.notification_list .dropdown-content {\r\n    transition: margin-top .2s;\r\n    box-shadow: 0 3px 10px #00000017;\r\n    position: relative;\r\n    width: 100%;\r\n    border-radius: .375rem;\r\n    padding: .5rem;\r\n}\r\n\r\n.dropdown-user-info .show>.dropdown-content {\r\n    margin-top: .25rem;\r\n}\r\n\r\n.dropdown-user-info .dropdown-content {\r\n    transition: margin-top .2s;\r\n    box-shadow: 0 3px 10px #00000017;\r\n    position: relative;\r\n    width: 100%;\r\n    border-radius: .375rem;\r\n    padding: .5rem;\r\n}\r\n\r\n.dropdown-user-info .dropdown-content .dropdown-item {\r\n    display: flex;\r\n    align-items: center;\r\n    border-radius: .375rem;\r\n    padding: .5rem;\r\n    transition-property: color, background-color, border-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-text-decoration-color, -webkit-backdrop-filter;\r\n    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;\r\n    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-text-decoration-color, -webkit-backdrop-filter;\r\n    transition-duration: 300ms;\r\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n\r\n.notification_list .dropdown-content .dropdown-item {\r\n    display: flex;\r\n    align-items: center;\r\n    border-radius: .375rem;\r\n    padding: .5rem;\r\n    transition-property: color, background-color, border-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-text-decoration-color, -webkit-backdrop-filter;\r\n    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;\r\n    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-text-decoration-color, -webkit-backdrop-filter;\r\n    transition-duration: 300ms;\r\n}\r\n\r\n.dropdown-user-info.show {\r\n    visibility: visible;\r\n    opacity: 1;\r\n}\r\n\r\n.notification_list.show {\r\n    visibility: visible;\r\n    opacity: 1;\r\n}\r\n\r\n\r\n/*----------------------------------admin----------------------------------------*/\r\n\r\n.calc-table>div {\r\n    padding-bottom: 33px\r\n}\r\n\r\n.calc-wrap span {\r\n    display: inline-block;\r\n}\r\n\r\n.calc-wrap .calc-cnt {\r\n    vertical-align: super;\r\n}\r\n\r\n.calc-wrap .calc-item {\r\n    vertical-align: top;\r\n}\r\n\r\n.calc-wrap .calc-title {\r\n    width: 100px\r\n}\r\n\r\n.switch {\r\n    position: relative;\r\n    display: inline-block;\r\n    width: 40px;\r\n    height: 20px;\r\n}\r\n\r\n.switch input {\r\n    opacity: 0;\r\n    width: 0;\r\n    height: 0;\r\n}\r\n\r\n.slider {\r\n    position: absolute;\r\n    cursor: pointer;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: #ccc;\r\n    -webkit-transition: .4s;\r\n    transition: .4s;\r\n}\r\n\r\n.slider:before {\r\n    position: absolute;\r\n    content: \"\";\r\n    height: 18px;\r\n    width: 17px;\r\n    left: 2px;\r\n    bottom: 1px;\r\n    background-color: white;\r\n    -webkit-transition: .4s;\r\n    transition: .4s;\r\n}\r\n\r\ninput:checked+.slider {\r\n    background-color: #064E3B;\r\n}\r\n\r\ninput:focus+.slider {\r\n    box-shadow: 0 0 1px #2196F3;\r\n}\r\n\r\ninput:checked+.slider:before {\r\n    -webkit-transform: translateX(20px);\r\n    -ms-transform: translateX(20px);\r\n    transform: translateX(20px);\r\n}\r\n\r\n.fa-regular {\r\n    font-size: 1.125rem;\r\n}\r\n\r\n/* Rounded sliders */\r\n.slider.round {\r\n    border-radius: 34px;\r\n}\r\n\r\n.slider.round:before {\r\n    border-radius: 50%;\r\n}\r\n\r\n.tabulator-paginator {\r\n    margin-left: 40%;\r\n}\r\n\r\n.tabulator-row .tabulator-cell {\r\n    /* height: 2.5rem !important; */\r\n    line-height: 1rem !important;\r\n}\r\n\r\n\r\n/*----------------------------------franchise----------------------------------------*/\r\n.switch {\r\n    position: relative;\r\n    display: inline-block;\r\n    width: 40px;\r\n    height: 20px;\r\n}\r\n\r\n.switch input {\r\n    opacity: 0;\r\n    width: 0;\r\n    height: 0;\r\n}\r\n\r\n.slider {\r\n    position: absolute;\r\n    cursor: pointer;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: #ccc;\r\n    -webkit-transition: .4s;\r\n    transition: .4s;\r\n}\r\n\r\n.slider:before {\r\n    position: absolute;\r\n    content: \"\";\r\n    height: 18px;\r\n    width: 17px;\r\n    left: 2px;\r\n    bottom: 1px;\r\n    background-color: white;\r\n    -webkit-transition: .4s;\r\n    transition: .4s;\r\n}\r\n\r\ninput:checked+.slider {\r\n    background-color: #064E3B;\r\n}\r\n\r\ninput:focus+.slider {\r\n    box-shadow: 0 0 1px #2196F3;\r\n}\r\n\r\ninput:checked+.slider:before {\r\n    -webkit-transform: translateX(20px);\r\n    -ms-transform: translateX(20px);\r\n    transform: translateX(20px);\r\n}\r\n\r\n/* Rounded sliders */\r\n.slider.round {\r\n    border-radius: 34px;\r\n}\r\n\r\n.slider.round:before {\r\n    border-radius: 50%;\r\n}\r\n\r\n.tabulator-paginator {\r\n    margin-left: 40%;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n/* 내부 콘텐츠 */\r\n.invitation .btn-group {\r\n    width: auto;\r\n}\r\n\r\n.invitation .btn-send-msg {\r\n    text-align: center;\r\n    z-index: 99999;\r\n}\r\n\r\n.invitation .merchant-send-list-box {\r\n    cursor: pointer;\r\n    width: auto;\r\n    height: 2.375rem;\r\n}\r\n\r\n.invitation .dropdown-menu {\r\n    position: absolute;\r\n    display: block;\r\n    border-radius: .375rem;\r\n    border: solid 1px #e5e7eb;\r\n    background: #fff;\r\n    top: 2rem;\r\n    left: -.8125rem;\r\n    right: -2.0625rem;\r\n    height: 40vh;\r\n    padding-bottom: .75rem;\r\n    overflow: scroll;\r\n    -ms-overflow-style: none;\r\n    /* IE and Edge */\r\n    scrollbar-width: none;\r\n    /* Firefox */\r\n}\r\n\r\n.invitation .dropdown-menu::-webkit-scrollbar {\r\n    display: none;\r\n    /* Chrome, Safari, Opera*/\r\n}\r\n\r\n.invitation .dropdown-menu button {\r\n    display: block;\r\n    width: 100%;\r\n    padding: .375rem .75rem;\r\n}\r\n\r\n.invitation .dropdown-menu .multiselect-filter {\r\n    position: sticky;\r\n    top: 0;\r\n    margin-bottom: .75rem;\r\n    border-bottom: .0625rem solid #e5e7eb;\r\n}\r\n\r\n.invitation .dropdown-menu .multiselect-filter input {\r\n    padding: .625rem .875rem;\r\n    border: none;\r\n}\r\n\r\n.invitation .dropdown-menu .multiselect-filter input:focus {\r\n    box-shadow: none;\r\n}\r\n\r\n.invitation .form-check {\r\n    padding: 0 !important;\r\n    margin-right: 1rem;\r\n    width: max-content;\r\n}\r\n\r\n.invitation .multiselect-container .multiselect-option.active:not(.multiselect-active-item-fallback),\r\n.invitation .multiselect-container .multiselect-group.active:not(.multiselect-active-item-fallback),\r\n.invitation .multiselect-container .multiselect-all.active:not(.multiselect-active-item-fallback),\r\n.invitation .multiselect-container .multiselect-option:not(.multiselect-active-item-fallback):active,\r\n.invitation .multiselect-container .multiselect-group:not(.multiselect-active-item-fallback):active,\r\n.invitation .multiselect-container .multiselect-all:not(.multiselect-active-item-fallback):active {\r\n    background-color: #fff !important;\r\n}\r\n\r\n\r\n/*스위치 슬라이더*/\r\n.invitation .switch {\r\n    position: relative;\r\n    display: block;\r\n    width: 40px;\r\n    height: 20px;\r\n    margin-top: 8px;\r\n    text-align: center;\r\n    margin: 0 auto;\r\n}\r\n\r\n.invitation .switch input {\r\n    opacity: 0;\r\n    width: 0;\r\n    height: 0;\r\n}\r\n\r\n.invitation .slider {\r\n    position: absolute;\r\n    cursor: pointer;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: #ccc;\r\n    -webkit-transition: .4s;\r\n    transition: .4s;\r\n}\r\n\r\n.invitation .slider:before {\r\n    position: absolute;\r\n    content: \"\";\r\n    height: 18px;\r\n    width: 17px;\r\n    left: 2px;\r\n    bottom: 1px;\r\n    background-color: white;\r\n    -webkit-transition: .4s;\r\n    transition: .4s;\r\n}\r\n\r\n.invitation input:checked+.slider {\r\n    background-color: #064E3B;\r\n}\r\n\r\n.invitation input:focus+.slider {\r\n    box-shadow: 0 0 1px #2196F3;\r\n}\r\n\r\n.invitation input:checked+.slider:before {\r\n    -webkit-transform: translateX(20px);\r\n    -ms-transform: translateX(20px);\r\n    transform: translateX(20px);\r\n}\r\n\r\n.invitation .slider.round {\r\n    border-radius: 34px;\r\n}\r\n\r\n.invitation .slider.round:before {\r\n    border-radius: 50%;\r\n}\r\n\r\n/*데이트 피커*/\r\n.invitation .is-end-date {\r\n    background-color: #064E3B !important;\r\n}\r\n\r\n\r\n/*----------------------------------admin----------------------------------------*/\r\n/*타이틀*/\r\n.admin-title {\r\n    margin-top: 1.5rem;\r\n    margin-left: 1.5rem;\r\n}\r\n\r\n.admin-title-header {\r\n    font-weight: 800;\r\n    font-size: 1.5rem;\r\n    line-height: 1.75rem;\r\n}\r\n\r\n/*검색 영역*/\r\n.admin-search-box {\r\n    flex-wrap: wrap;\r\n    padding-bottom: 3rem;\r\n}\r\n\r\n.merchant-list-search {\r\n    height: 40px;\r\n}\r\n\r\n.multiple-select {\r\n    width: 72%;\r\n}\r\n\r\n\r\n/*리스트 영역*/\r\n.tabulator-paginator {\r\n    margin-left: 40%;\r\n}\r\n\r\n.merchant-search-list-box {\r\n    cursor: pointer;\r\n    width: auto;\r\n    height: 2.375rem;\r\n}\r\n\r\n.btn-group {\r\n    width: 7rem;\r\n    height: 17px;\r\n    overflow: hidden;\r\n}\r\n\r\n.merchant-search-list-box .dropdown-menu {\r\n    position: absolute;\r\n    display: block;\r\n    border-radius: .375rem;\r\n    border: solid 1px #e5e7eb;\r\n    background: #fff;\r\n    top: 2rem;\r\n    left: -.8125rem;\r\n    right: -2.0625rem;\r\n    height: 40vh;\r\n    padding-bottom: .75rem;\r\n    overflow: scroll;\r\n    -ms-overflow-style: none;\r\n    /* IE and Edge */\r\n    scrollbar-width: none;\r\n    /* Firefox */\r\n}\r\n\r\n.merchant-search-list-box .dropdown-menu::-webkit-scrollbar {\r\n    display: none;\r\n    /* Chrome, Safari, Opera*/\r\n}\r\n\r\n.merchant-search-list-box .dropdown-menu button {\r\n    display: block;\r\n    width: 100%;\r\n    padding: .375rem .75rem;\r\n}\r\n\r\n.merchant-search-list-box .dropdown-menu .multiselect-filter {\r\n    position: sticky;\r\n    top: 0;\r\n    margin-bottom: .75rem;\r\n    border-bottom: .0625rem solid #e5e7eb;\r\n}\r\n\r\n.merchant-search-list-box .dropdown-menu .multiselect-filter input {\r\n    padding: .625rem .75rem;\r\n    border: none;\r\n}\r\n\r\n.merchant-search-list-box .dropdown-menu .multiselect-filter input:focus {\r\n    box-shadow: none;\r\n}\r\n\r\n.merchant-list-box .dropdown-menu {\r\n    position: absolute;\r\n    display: block;\r\n    border-radius: .375rem;\r\n    border: solid 1px #e5e7eb;\r\n    background: #fff;\r\n    top: 2rem;\r\n    left: -.8125rem;\r\n    right: -2.0625rem;\r\n    height: 40vh;\r\n    padding-bottom: .75rem;\r\n    overflow: scroll;\r\n    -ms-overflow-style: none;\r\n    /* IE and Edge */\r\n    scrollbar-width: none;\r\n    /* Firefox */\r\n}\r\n\r\n.merchant-list-box .dropdown-menu::-webkit-scrollbar {\r\n    display: none;\r\n    /* Chrome, Safari, Opera*/\r\n}\r\n\r\n.merchant-list-box .dropdown-menu button {\r\n    display: block;\r\n    width: 100%;\r\n    padding: .375rem .75rem;\r\n}\r\n\r\n.merchant-list-box .dropdown-menu .multiselect-filter {\r\n    position: sticky;\r\n    top: 0;\r\n    margin-bottom: .75rem;\r\n    border-bottom: .0625rem solid #e5e7eb;\r\n}\r\n\r\n.merchant-list-box .dropdown-menu .multiselect-filter input {\r\n    padding: .625rem .75rem;\r\n    padding-left: 1.125rem;\r\n    border: none;\r\n}\r\n\r\n.merchant-list-box .dropdown-menu .multiselect-filter input:focus {\r\n    box-shadow: none;\r\n}\r\n\r\n.form-check {\r\n    padding: 0 !important;\r\n    margin-right: 1rem;\r\n    width: max-content;\r\n}\r\n\r\n\r\n\r\n.multiselect-container .multiselect-option.active:not(.multiselect-active-item-fallback),\r\n.multiselect-container .multiselect-group.active:not(.multiselect-active-item-fallback),\r\n.multiselect-container .multiselect-all.active:not(.multiselect-active-item-fallback),\r\n.multiselect-container .multiselect-option:not(.multiselect-active-item-fallback):active,\r\n.multiselect-container .multiselect-group:not(.multiselect-active-item-fallback):active,\r\n.multiselect-container .multiselect-all:not(.multiselect-active-item-fallback):active {\r\n    background-color: #fff !important;\r\n}\r\n\r\n.admin-modal-sty {\r\n    max-height: 80vh;\r\n    overflow: auto;\r\n}\r\n\r\n/*--------------------------------receipt----------------------------------------*/\r\nimg,\r\nfieldset,\r\niframe {\r\n    border: 0 none;\r\n    vertical-align: top;\r\n}\r\n\r\n#header {\r\n    position: relative;\r\n    border-bottom: 2px solid #696a6b;\r\n    padding-bottom: 10px;\r\n}\r\n\r\n#header h1 {\r\n    position: absolute;\r\n    top: -3px;\r\n    right: 0;\r\n}\r\n\r\n#header h2 {\r\n    color: #696a6b;\r\n    font-size: 18px;\r\n    font-family: '돋움';\r\n}\r\n\r\n.selectBox {\r\n    padding: 10px 0 24px 0;\r\n}\r\n\r\n.selectBox select {\r\n    font-size: 14px;\r\n    font-weight: bold;\r\n    height: 29px;\r\n    line-height: 29px;\r\n    padding: 0 0 0 6px;\r\n    border-radius: 3px;\r\n}\r\n\r\n.list-info-box h3 {\r\n    color: #fff;\r\n    font-size: 14px;\r\n    background: #898a8c;\r\n    border-radius: 5px 5px 0 0;\r\n    padding: 0 15px;\r\n    display: inline-block;\r\n    height: 27px;\r\n    line-height: 27px;\r\n    position: relative;\r\n    z-index: 2;\r\n    font-weight: normal;\r\n}\r\n\r\n.list-info-box .tt {\r\n    position: relative;\r\n    z-index: 1;\r\n}\r\n\r\n.list-info-box .tt:after {\r\n    content: '';\r\n    display: block;\r\n    clear: both;\r\n    background: #696a6b;\r\n    height: 1px;\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n}\r\n\r\n.list-info-box .gap:after {\r\n    content: '';\r\n    display: block;\r\n    clear: both;\r\n}\r\n\r\n.list-info-box .gap ul li {\r\n    border-bottom: 1px solid #e1e1e1;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.list-info-box .gap ul li .inner {\r\n    width: 50%;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n@media (max-width: 640px) {\r\n    .list-info-box .gap ul li.mobile {\r\n        display: block;\r\n        border-bottom: none;\r\n    }\r\n\r\n    .list-info-box .gap ul li.mobile .inner {\r\n        width: 100%;\r\n        border-bottom: 1px solid #e1e1e1;\r\n    }\r\n}\r\n\r\n.list-info-box .gap ul li .inner:nth-child(3) {\r\n    border-top: 1px solid #e1e1e1;\r\n}\r\n\r\n.list-info-box .gap ul li:after,\r\n.list-info-box .gap ul li .inner:after {\r\n    content: '';\r\n    display: block;\r\n    clear: both;\r\n}\r\n\r\n.list-info-box .gap ul li .left-text,\r\n.list-info-box .gap ul li .right-text {\r\n    /* float: left; */\r\n    color: #2d2e2f;\r\n    font-size: 14px;\r\n    padding: 7px 0;\r\n}\r\n\r\n.list-info-box .gap ul li .left-text {\r\n    width: 35%;\r\n    background: #f9f9f9;\r\n    padding: 5px 10px;\r\n    /* font-size: .7rem; */\r\n    font-size: 12px;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.list-info-box .gap ul li .txt-s {\r\n    font-size: 11px;\r\n}\r\n\r\n.list-info-box .gap ul li .right-text {\r\n    word-break: break-word;\r\n    width: 65%;\r\n    padding: 5px 10px;\r\n    /* font-size: .7rem; */\r\n    font-size: 12px;\r\n    color: #646464;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.list-info-box .box-gap {\r\n    margin-bottom: 16px;\r\n    clear: both;\r\n}\r\n\r\n.list-info-box .box-gap:last-child {\r\n    margin-bottom: 0;\r\n}\r\n\r\n.list-info-box .box-gap:after {\r\n    content: '';\r\n    display: block;\r\n}\r\n\r\n.list-info-box .box-gap.type-2 .gap {\r\n    width: 50%;\r\n    display: inline-block;\r\n}\r\n\r\n.list-info-box .box-gap.type-2 .gap:first-child {\r\n    width: calc(50% - 13px);\r\n}\r\n\r\n.list-info-box .box-gap.type-2 .gap:last-child {\r\n    width: calc(50% - 13px);\r\n    float: right;\r\n}\r\n\r\n.list-info-box .box-gap.type-2 .gap ul li .inner {\r\n    float: none;\r\n    width: auto;\r\n}\r\n\r\n\r\n\r\n.box-sales #header {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    margin-bottom: 1.25rem;\r\n    padding: 0;\r\n    border: none;\r\n}\r\n\r\n.box-sales #header h2 {\r\n    font-weight: bold;\r\n    color: #2d2e2f;\r\n}\r\n\r\n.box-sales #header h1 {\r\n    position: relative;\r\n    top: auto;\r\n}\r\n\r\n.box-sales #header h1 img {\r\n    height: 2rem;\r\n}\r\n\r\n.box-result {\r\n    position: fixed;\r\n    left: 60%;\r\n    top: 50%;\r\n    width: 100%;\r\n    transform: translate(-50%, -50%);\r\n    z-index: 1000;\r\n    text-align: center;\r\n}\r\n\r\n.infoFooter {\r\n    color: #2d2e2f;\r\n    font-size: 11px;\r\n    margin: 10px 0 0 0;\r\n    letter-spacing: -0.02em;\r\n}\r\n\r\n.infoFooter span {\r\n    color: #e40030;\r\n}\r\n\r\n.box-btn {\r\n    text-align: center;\r\n    margin: 22px 0 0 0;\r\n}\r\n\r\n.common-btn-1,\r\n.common-btn-2 {\r\n    display: inline-block;\r\n    color: #fff;\r\n    font-size: 18px;\r\n    text-align: center;\r\n    border: 2px solid #e1e1e1;\r\n    height: 40px;\r\n    line-height: 36px;\r\n    border-radius: 3px;\r\n    padding: 0 54px;\r\n    font-family: 'NotoSansCJKkr-Regular';\r\n}\r\n\r\n.common-btn-1 {\r\n    background: #04abc4;\r\n}\r\n\r\n.common-btn-2 {\r\n    background: #6e7074;\r\n}\r\n\r\n#popupHeader {\r\n    background: #e4e6e9;\r\n    position: relative;\r\n    padding: 13px 0 18px 26px;\r\n}\r\n\r\n#popupHeader h1 {}\r\n\r\n#popupHeader a {\r\n    position: absolute;\r\n    top: 13px;\r\n    right: 13px;\r\n}\r\n\r\n.eventContents {\r\n    padding: 13px 36px 45px 27px;\r\n}\r\n\r\n.eventContents .txt-1 {\r\n    text-align: right;\r\n    color: #121212;\r\n    position: relative;\r\n    right: -32px;\r\n}\r\n\r\n.eventContents h2 {\r\n    color: #121212;\r\n    font-size: 16px;\r\n    padding: 12px 0 18px 0;\r\n}\r\n\r\n.eventContents .box-table {\r\n    padding: 0 0 0 21px;\r\n    margin-bottom: 27px;\r\n}\r\n\r\n.common-table-1 {\r\n    width: 100%;\r\n    border-bottom: 1px solid #696a6b;\r\n}\r\n\r\n.common-table-1 thead th,\r\n.common-table-1 tbody td {\r\n    color: #2d2e2f;\r\n    font-size: 14px;\r\n    text-align: center;\r\n}\r\n\r\n.common-table-1 thead th {\r\n    border-top: 1px solid #696a6b;\r\n    background: #ebebeb;\r\n    padding: 7px 0;\r\n}\r\n\r\n.common-table-1 tbody td {\r\n    border-bottom: 1px solid #e1e1e1;\r\n    padding: 9px 0;\r\n}\r\n\r\n.common-table-1 tbody tr:last-child td {\r\n    border-bottom: none;\r\n}\r\n\r\n.list-type-1 {\r\n    padding: 12px 0 0 21px;\r\n}\r\n\r\n.list-type-1 li {\r\n    color: #2d2e2f;\r\n}\r\n\r\n.box-info-number {\r\n    display: flex;\r\n    display: -webkit-flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 55px 30px 0 27px;\r\n}\r\n\r\n.box-info-number .txt-1 {\r\n    color: #121212;\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n}\r\n\r\n.common-inputType-1 {\r\n    border: 1px solid #b7b7b7;\r\n    border-radius: 3px;\r\n    height: 36px;\r\n    line-height: 36px;\r\n    padding-left: 10px;\r\n    width: 100%;\r\n    margin: 0 11px;\r\n}\r\n\r\n.box-info-number .btn-1 {\r\n    height: 46px;\r\n    line-height: 46px;\r\n    display: inline-block;\r\n    padding: 0 28px;\r\n    color: #fff;\r\n    font-family: 'NotoSansCJKkr-Medium';\r\n    background: #4d7cfe;\r\n    border: 0;\r\n    font-size: 20px;\r\n}\r\n\r\n.box-info-number .common-inputType-1,\r\n::placeholder {\r\n    font-size: 14px;\r\n    font-family: 'NotoSansCJKkr-DemiLight';\r\n}\r\n\r\n::placeholder {\r\n    color: #a7aab4;\r\n}\r\n\r\n\r\n\r\n\r\n/*----------------------------------tree----------------------------------------*/\r\n#detail-popup-wrap {\r\n    opacity: 0;\r\n    position: fixed;\r\n    width: 0px;\r\n    height: 100vw;\r\n    right: 0;\r\n    background-color: white;\r\n    z-index: 60;\r\n    transition: 0.3s;\r\n    box-shadow: 0 1px 15px 0 rgb(87 87 87 / 15%);\r\n}\r\n\r\n#detail-popup-wrap .popup-header {\r\n    border-radius: 10px;\r\n    background-color: #064E3B;\r\n    width: 100%;\r\n    height: 200px;\r\n    padding-top: 10px;\r\n    position: relative;\r\n    box-shadow: 0 1px 15px 0 rgb(87 87 87 / 15%);\r\n}\r\n\r\n#detail-popup-wrap .popup-header p {\r\n    padding-top: 10px;\r\n    text-align: center;\r\n    position: relative;\r\n    color: white;\r\n    font-size: 19px;\r\n}\r\n\r\n#detail-popup-wrap .popup-header .popup-close-btn {\r\n    top: 15px;\r\n    width: 30px;\r\n    position: absolute;\r\n    right: 10px;\r\n}\r\n\r\n#detail-popup-wrap .popup-header .header-img-wrap {\r\n    background-color: white;\r\n    width: 100px;\r\n    height: 100px;\r\n    position: absolute;\r\n    left: calc(50% - 50px);\r\n    bottom: -50px;\r\n    border-radius: 50px;\r\n    box-shadow: 0 1px 15px 0 rgb(87 87 87 / 15%);\r\n}\r\n\r\n#detail-popup-wrap .popp-contents-wrap {\r\n    padding: 80px 20px;\r\n}\r\n\r\n#detail-popup-wrap .popp-contents-wrap input {\r\n    margin-bottom: 20px;\r\n    border: 1px solid;\r\n    border-radius: 0.375rem;\r\n    border: 1px solid #e8e8e8;\r\n}\r\n\r\n#tree-content-wrap {\r\n    margin-top: 20px\r\n}\r\n\r\n#tree-content-wrap .search-wrap {\r\n    position: absolute;\r\n    z-index: 4;\r\n    top: 30px;\r\n    left: 30px\r\n}\r\n\r\n#tree-content-wrap .btn-wrap {\r\n    margin-top: 10px;\r\n    border-bottom: 1px solid #E2E8F0;\r\n    padding-bottom: 20px;\r\n    margin-bottom: 20px\r\n}\r\n\r\n/* #tree-content-wrap #myDiagramDiv { overflow-styl#detail-popup-wrap .popup-header .popup-close-btne: unset; } */\r\n::-webkit-scrollbar {\r\n    width: 6px;\r\n    height: 6px;\r\n    background-color: transparent;\r\n}\r\n::-webkit-scrollbar-thumb {\r\n    background: rgba(0,0,0,0.15);\r\n    border-radius: 3px;\r\n}\r\n::-webkit-scrollbar-thumb:hover {\r\n    background: rgba(0,0,0,0.3);\r\n}\r\n::-webkit-scrollbar-track {\r\n    background: transparent;\r\n}\r\n\r\n/*reset.css*/\r\n.cf {\r\n    zoom: 1;\r\n    /* ie 6,7 */\r\n}\r\n\r\n.cf::before,\r\n.cf::after {\r\n    content: \"\";\r\n    clear: both;\r\n    display: table;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n/*-------------------- Header --------------------*/\r\n.mobile-menu {\r\n    top: 0;\r\n    left: 0;\r\n    margin: 0;\r\n}\r\n\r\n.mobile-menu:before {\r\n    background: none;\r\n    pointer-events: none;\r\n}\r\n\r\n.mobile-menu .main_logo {\r\n    width: auto;\r\n    overflow: hidden;\r\n}\r\n\r\n.mobile-menu .main_logo img {\r\n    width: auto;\r\n    max-width: none;\r\n    /* height: 1.625rem; */\r\n    height: 2rem;\r\n}\r\n\r\n.mobile-menu .header_gnb {\r\n    display: flex;\r\n    column-gap: 2vw;\r\n    margin-right: 4vw;\r\n    padding: 0;\r\n}\r\n\r\n.mobile-menu .header_gnb li {\r\n    border: none;\r\n}\r\n\r\n.mobile-menu .header_gnb li a {\r\n    display: block;\r\n    position: relative;\r\n    padding: 0 .5rem;\r\n    font-size: .9375rem;\r\n    font-weight: 500;\r\n    line-height: 2.5rem;\r\n    color: rgba(255, 255, 255, .7);\r\n}\r\n\r\n.mobile-menu .header_gnb li a::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: .25rem;\r\n    right: 0;\r\n    width: .3125rem;\r\n    height: .3125rem;\r\n    border-radius: 50%;\r\n    background: #cce568;\r\n    opacity: 0;\r\n}\r\n\r\n.mobile-menu .header_gnb li.active {}\r\n\r\n.mobile-menu .header_gnb li.active a {\r\n    font-weight: bold;\r\n    color: #cce568;\r\n}\r\n\r\n.mobile-menu .header_gnb li.active a::after {\r\n    opacity: 1;\r\n}\r\n\r\n\r\n.mobile-menu .mobile-menu-bar .mobile-menu-toggler {\r\n    position: relative;\r\n    width: 2.5rem;\r\n    height: 2.5rem;\r\n    z-index: 10;\r\n}\r\n\r\n.mobile-menu .mobile-menu-bar .mobile-menu-toggler:before,\r\n.mobile-menu .mobile-menu-bar .mobile-menu-toggler:after {\r\n    content: \"\";\r\n    display: block;\r\n    position: absolute;\r\n    right: .5625rem;\r\n    transition: .4s cubic-bezier(.5, .1, 0, 1.2);\r\n    height: .125rem;\r\n    margin-top: .625rem;\r\n    background: #fff;\r\n}\r\n\r\n.mobile-menu .mobile-menu-bar .mobile-menu-toggler:before {\r\n    top: 0;\r\n    width: 1.125rem;\r\n}\r\n\r\n.mobile-menu .mobile-menu-bar .mobile-menu-toggler:after {\r\n    top: 1.125rem;\r\n    width: 1.375rem;\r\n}\r\n\r\n.mobile-menu .mobile-menu-bar .mobile-menu-toggler svg {\r\n    position: absolute;\r\n    top: 50%;\r\n    right: .5625rem;\r\n    transition: .4s cubic-bezier(.5, .1, 0, 1.2);\r\n    transform: translateY(-50%);\r\n    width: .875rem;\r\n    height: .125rem;\r\n    background: #acd560;\r\n    overflow: hidden;\r\n    opacity: 1;\r\n    transform: translateY(-50%);\r\n}\r\n\r\n.mobile-menu .scrollable {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n    top: 52px;\r\n    transform: translateX(100%);\r\n    width: 100%;\r\n    height: calc(100% - 52px);\r\n    margin: 0;\r\n    background: #f1f5f9;\r\n    overflow-y: auto;\r\n}\r\n\r\n.mobile-menu ul {\r\n    padding: 0;\r\n}\r\n\r\n.mobile-menu ul li {\r\n    -webkit-tap-highlight-color: transparent;\r\n}\r\n\r\n.mobile-menu ul li+li {\r\n    border-top: .0625rem solid #d7d9da;\r\n}\r\n\r\n.mobile-menu .menu {\r\n    height: 4rem;\r\n    padding: 0;\r\n    color: #1e293b;\r\n}\r\n\r\n.mobile-menu .menu .menu__title {\r\n    display: flex;\r\n    align-items: center;\r\n    width: 100%;\r\n    margin-left: .75rem;\r\n    font-size: 1.0625rem;\r\n    font-weight: bold;\r\n}\r\n\r\n.mobile-menu .menu .menu__icon {\r\n    position: relative;\r\n    top: -.0625rem;\r\n}\r\n\r\n.mobile-menu .scrollable .scrollable__content>li:nth-child(1) .menu__title .menu__sub-icon {\r\n    /* display: none; */\r\n}\r\n\r\n.mobile-menu .menu .menu__title .menu__sub-icon {\r\n    transform: none;\r\n    position: relative;\r\n    width: 1.625rem;\r\n    height: 1.625rem;\r\n}\r\n\r\n.mobile-menu .menu .menu__title .menu__sub-icon::before,\r\n.mobile-menu .menu .menu__title .menu__sub-icon::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    background: #227862;\r\n}\r\n\r\n.mobile-menu .menu .menu__title .menu__sub-icon::before {\r\n    width: 1rem;\r\n    height: .125rem;\r\n}\r\n\r\n.mobile-menu .menu .menu__title .menu__sub-icon::after {\r\n    width: .125rem;\r\n    height: 1rem;\r\n}\r\n\r\n.mobile-menu .menu .menu__title .menu__sub-icon.rotate-180::after {\r\n    display: none;\r\n}\r\n\r\n\r\n.mobile-menu ul li ul {\r\n    margin: 0;\r\n    padding: 0 0 1rem 1.5rem;\r\n    background: none;\r\n}\r\n\r\n.mobile-menu ul li ul li {\r\n    border: none;\r\n}\r\n\r\n.mobile-menu ul li ul .menu {\r\n    height: 2.625rem;\r\n    padding: 0;\r\n}\r\n\r\n.mobile-menu ul li ul .menu .menu__title {\r\n    position: relative;\r\n    font-size: .9375rem;\r\n    letter-spacing: -.02rem;\r\n}\r\n\r\n.mobile-menu ul li ul .menu .menu__title::before {\r\n    content: \"\";\r\n    position: relative;\r\n    top: -.25rem;\r\n    width: .5rem;\r\n    height: .5rem;\r\n    margin-right: .625rem;\r\n    border-left: .0625rem solid #a7a9aa;\r\n    border-bottom: .0625rem solid #a7a9aa;\r\n}\r\n\r\n.mobile-menu .menu .menu__title .menu__sub-icon polyline {\r\n    display: none;\r\n}\r\n\r\n.mobile-menu--active .mobile-menu-bar .mobile-menu-toggler:before {\r\n    transform: translateX(.0625rem) translateY(.5625rem) rotate(-45deg);\r\n    width: 1.5rem;\r\n}\r\n\r\n.mobile-menu--active .mobile-menu-bar .mobile-menu-toggler:after {\r\n    transform: translateX(.0625rem) translateY(-.5625rem) rotate(45deg);\r\n    width: 1.5rem;\r\n}\r\n\r\n.mobile-menu--active .mobile-menu-bar .mobile-menu-toggler svg {\r\n    width: 0;\r\n    opacity: 0;\r\n}\r\n\r\n\r\n.mobile-menu.mobile-menu--active .scrollable {\r\n    transform: translateX(0);\r\n}\r\n\r\n.mobile-menu .logout-btn {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-top: .0625rem solid #d7d9da;\r\n    background: rgba(255, 255, 255, .5);\r\n}\r\n\r\n.mobile-menu .logout-btn a {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    height: 2.75rem;\r\n    padding: 0 1rem;\r\n    color: #64748b;\r\n}\r\n\r\n.mobile-menu .logout-btn svg {\r\n    position: relative;\r\n    top: -.125rem;\r\n    margin-right: .375rem;\r\n    width: 1.125rem;\r\n    height: 1.125rem;\r\n}\r\n\r\n\r\n.mobile-menu .menu_wrap {\r\n    padding: 2rem 1.25rem 1.5rem;\r\n}\r\n\r\n.mobile-menu .user_info_wrap {\r\n    margin-bottom: 1.75rem;\r\n}\r\n\r\n.mobile-menu .user_detail {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: .375rem;\r\n    margin-bottom: .5rem;\r\n}\r\n\r\n.mobile-menu .user_detail span {\r\n    display: inline-block;\r\n    padding: .0625rem .5rem 0;\r\n    border-radius: .125rem;\r\n    background: #a6bacb;\r\n    font-size: .75rem;\r\n    line-height: 1.3125rem;\r\n    letter-spacing: -.02rem;\r\n    color: #fff;\r\n}\r\n\r\n.mobile-menu .user_detail .user_authority {\r\n    background: #fc8f94;\r\n}\r\n\r\n.mobile-menu .user_detail .user_organization {\r\n    background: #9da2f4;\r\n}\r\n\r\n.mobile-menu .user_greeting {\r\n    display: flex;\r\n    align-items: flex-end;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.mobile-menu .user_greeting p {\r\n    font-size: 1.125rem;\r\n    line-height: 1.75rem;\r\n    letter-spacing: -.02rem;\r\n    color: #1e203b;\r\n}\r\n\r\n.mobile-menu .user_greeting .user_name {\r\n    font-size: 1.375rem;\r\n    font-weight: bold;\r\n}\r\n\r\n.mobile-menu .login_session_wrap {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 1rem 1.5rem;\r\n    border-radius: .5rem;\r\n    background: #dde4ed;\r\n}\r\n\r\n.mobile-menu .timer_wrap {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: .375rem;\r\n}\r\n\r\n.mobile-menu .timer_wrap svg {\r\n    position: relative;\r\n    width: 1.125rem;\r\n    height: 1.125rem;\r\n    color: #3c4756;\r\n}\r\n\r\n.mobile-menu .timer_wrap .timer {\r\n    padding: 0;\r\n    font-size: .9375rem;\r\n    font-weight: 500;\r\n    color: #3c4756;\r\n}\r\n\r\n.mobile-menu .login_session_wrap button {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: .375rem;\r\n    margin: 0;\r\n    padding: 0;\r\n    border-radius: 0;\r\n    background: none;\r\n    font-weight: bold;\r\n    color: #66758b;\r\n}\r\n\r\n.mobile-menu .login_session_wrap button svg {\r\n    position: relative;\r\n    top: -.0625rem;\r\n    width: 1rem;\r\n    height: 1rem;\r\n    color: #66758b;\r\n}\r\n\r\n.mobile-menu .separation_line {\r\n    height: .625rem;\r\n    margin: 1.5rem -1.25rem 1rem;\r\n    border-top: .0625rem solid #cdd4dd;\r\n    background: #dde4ed;\r\n}\r\n\r\n\r\n\r\n\r\n/*-------------------- Modal --------------------*/\r\n/* .scroll_lock { overflow:hidden; } */\r\n.modal {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    transition: visibility 0s ease 0.2s, opacity .2s 0s;\r\n    width: auto;\r\n    height: auto;\r\n    margin: 0;\r\n    background: rgb(0 0 0 / 65%);\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n    visibility: visible;\r\n    opacity: 1;\r\n    z-index: 100000;\r\n}\r\n\r\n\r\n.modal .modal-dialog,\r\n.modal#payment-modal .modal-dialog {\r\n    position: relative;\r\n\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    /* transform: none; */\r\n    transition: top .3s ease;\r\n\r\n    width: 95%;\r\n    max-width: 40rem;\r\n    max-height: none;\r\n    margin: auto;\r\n    padding: .5rem 1.5rem;\r\n    /* border-radius: 1rem; */\r\n    border-radius: 10px;\r\n    background: #fff;\r\n    overflow: hidden;\r\n}\r\n\r\n.board_modal .modal-dialog {\r\n    /* top: 6%; */\r\n    top: 50%;\r\n    max-width: 42rem;\r\n}\r\n\r\n.modal .modal-dialog .modal-content {\r\n    margin: 0;\r\n    max-height: none;\r\n    box-shadow: none;\r\n}\r\n\r\n.modal .modal-dialog .modal-header {\r\n    position: relative;\r\n    width: auto;\r\n    padding: 1rem 0;\r\n}\r\n\r\n.modal .modal-dialog .modal-header h2 {\r\n    display: block;\r\n    font-weight: bold;\r\n}\r\n\r\n.modal .modal-dialog .modal-header button {\r\n    float: none;\r\n    padding: 0;\r\n}\r\n\r\n.modal .modal-dialog .modal-header button span,\r\n.modal .modal-dialog .modal-header button svg {\r\n    width: 1.625rem;\r\n    height: 1.625rem;\r\n}\r\n\r\n.modal .modal-dialog .modal-header .close_btn_sty svg {\r\n    transform: rotate(.37turn);\r\n}\r\n\r\n.modal .modal-dialog .modal-body {\r\n    overflow: auto;\r\n    margin: 0;\r\n    padding: 1.5rem 0;\r\n}\r\n\r\n.modal .modal-dialog .modal-body label {\r\n    margin-bottom: .375rem;\r\n    font-size: .8125rem;\r\n    font-weight: bold;\r\n}\r\n\r\n.modal .modal-dialog .modal-body input:read-only,\r\n.modal .modal-dialog .modal-body textarea:read-only {\r\n    /* border: none; */\r\n    border: 1px solid #cdcdcd;\r\n    box-shadow: none;\r\n    color: #8292a3;\r\n}\r\n\r\n.modal .modal-dialog .modal-footer {\r\n    display: flex;\r\n    justify-content: center;\r\n    /* padding: 1.5rem 0; */\r\n    padding: 1rem 0 0.5rem;\r\n    text-align: center;\r\n}\r\n\r\n.modal .modal-dialog .modal-footer button {\r\n    width: 50%;\r\n    max-width: 8rem;\r\n}\r\n\r\n.modal .modal-dialog .modal-footer button+button {\r\n    margin-left: .75rem;\r\n}\r\n\r\n.show_modal {\r\n    visibility: visible;\r\n    opacity: 1;\r\n}\r\n\r\n.show_modal .modal-dialog,\r\n.show_modal#payment-modal .modal-dialog {\r\n    top: 0;\r\n}\r\n\r\n.alert_modal {\r\n    z-index: 100001 !important;\r\n}\r\n\r\n.alert_modal .modal-dialog {\r\n    z-index: 100002 !important;\r\n}\r\n\r\n.alert_modal .modal-footer {\r\n    border-top: 0;\r\n}\r\n\r\n\r\n/*------------------------ modal receipt style ------------------------*/\r\n\r\n.modal .modal-dialog .type-receipt {}\r\n\r\n.modal .modal-dialog .type-receipt .modal-header {\r\n    z-index: 2;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .modal-header::after,\r\n.modal .modal-dialog .type-receipt .modal-footer::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    left: -.4375rem;\r\n    width: .875rem;\r\n    height: .875rem;\r\n    border-radius: 50%;\r\n    box-shadow: 1rem 0 #fff, 2.5rem 0 #fff, 4rem 0 #fff, 5.5rem 0 #fff, 7rem 0 #fff, 8.5rem 0 #fff, 10rem 0 #fff, 11.5rem 0 #fff, 13rem 0 #fff, 14.5rem 0 #fff, 16rem 0 #fff, 17.5rem 0 #fff, 19rem 0 #fff, 20.5rem 0 #fff, 22rem 0 #fff, 23.5rem 0 #fff, 25rem 0 #fff, 26.5rem 0 #fff, 28rem 0 #fff, 29.5rem 0 #fff;\r\n    background: transparent;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .modal-header::after {\r\n    bottom: -.4375rem;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .modal-body {\r\n    position: relative;\r\n    padding: 0;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .modal-body::before {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    /* border-left: .0625rem solid rgba(0, 0, 0, .08); */\r\n    /* border-right: .0625rem solid rgba(0, 0, 0, .08); */\r\n    pointer-events: none;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales {\r\n    max-height: calc(100dvh - 17.5rem);\r\n    padding: 2rem 1rem;\r\n    /* background: #eee; */\r\n    overflow-y: auto;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales #header h1 {\r\n    /* filter: brightness(.75) grayscale(1); */\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales #header h2 {\r\n    font-size: 1.0625rem;\r\n    color: #424242;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales .list-info-box {}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales .box-gap {\r\n    margin: 0;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales .box-gap+.box-gap {\r\n    margin-top: 1rem;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales .gap {}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales .gap .tt {\r\n    /* margin-bottom: .25rem; */\r\n    /* background: #d7d7d7; */\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales .gap .tt::after {\r\n    /* position: absolute;\r\n    top: 0;\r\n    bottom: auto;\r\n    height: 0;\r\n    border-bottom: .0625rem dotted #424242;\r\n    background: none; */\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales .gap .tt h3 {\r\n    /* display: block;\r\n    height: auto;\r\n    padding: 0 .75rem;\r\n    border-radius: 0;\r\n    background: none;\r\n    font-weight: bold;\r\n    line-height: 2rem;\r\n    color: #424242; */\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales .gap li {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    /* column-gap: .875rem; */\r\n    border: none;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales .gap li+li {\r\n    border-top: .0625rem solid #ddd;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales .gap li::after {\r\n    display: none;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales .gap li .inner {\r\n    float: initial;\r\n    display: inline-flex;\r\n    flex-wrap: wrap;\r\n    flex-basis: calc(50% - .4375rem);\r\n    flex-grow: 1;\r\n    justify-content: space-between;\r\n    width: auto;\r\n    /* padding: .375rem 0; */\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales .gap li .inner::after {\r\n    display: none;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales .gap li .inner .left-text,\r\n.modal .modal-dialog .type-receipt .box-sales .gap li .inner .right-text {\r\n    float: initial;\r\n    width: auto;\r\n    padding: 0;\r\n    font-size: .7rem;\r\n    color: #424242;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales .gap li .inner .left-text {\r\n    width: 32%;\r\n    background: #f9f9f9;\r\n    padding: 5px 12px;\r\n    font-size: .7rem;\r\n    display: flex;\r\n    align-items: center;\r\n    font-weight: bold;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales .gap li .inner .right-text {\r\n    word-break: break-word;\r\n    width: 68%;\r\n    padding: 5px 12px;\r\n    color: #646464;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales .type-2 {\r\n    display: flex;\r\n    column-gap: 1.25rem;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales .type-2 .gap {\r\n    width: auto;\r\n    flex-basis: calc(50% - .625rem);\r\n    flex-grow: 1;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales .list-info-box {}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales .infoFooter {\r\n    margin: 1.25rem 0 0;\r\n    font-size: .6875rem;\r\n    line-height: 1.5;\r\n    color: #424242;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales .box-btn {\r\n    margin: 1.25rem 0 0;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .box-sales .box-btn button {\r\n    height: 2.375rem;\r\n    margin: 0 0 0 -.1875rem;\r\n    border: none;\r\n    background: #424242;\r\n    font-family: inherit;\r\n    font-size: .9375rem;\r\n    font-weight: bold;\r\n    line-height: 2.375rem;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .modal-footer {\r\n    position: relative;\r\n    z-index: 1;\r\n}\r\n\r\n.modal .modal-dialog .type-receipt .modal-footer::after {\r\n    top: -.4375rem;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n/*-------------------- Tabulator --------------------*/\r\n.tabulator {\r\n    /* height: 41.25rem; */\r\n    /* height: calc(100dvh - 280px); */\r\n    /* padding-bottom: 5px; */\r\n}\r\n\r\n.tabulator-row {}\r\n\r\n.tabulator-cell {\r\n    height: 49px;\r\n}\r\n\r\n.tabulator-page-size {\r\n    padding-bottom: 0 !important;\r\n    padding-top: 0 !important;\r\n    margin-bottom: 10px !important;\r\n}\r\n\r\n.tabulator-paginator>label {\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.tabulator .tabulator-tableHolder {\r\n    height: auto !important;\r\n    min-height: auto !important;\r\n    max-height: calc(100% - 3rem);\r\n    overflow: scroll auto;\r\n    -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n.tabulator .tabulator-tableHolder .tabulator-table {\r\n    /*height: 100%;*/\r\n    /*padding-bottom: 0px !important;*/\r\n    /*box-sizing: border-box;*/\r\n}\r\n\r\n.tabulator .tabulator-tableHolder::-webkit-scrollbar {\r\n    -webkit-appearance: none;\r\n}\r\n\r\n.tabulator .tabulator-tableHolder::-webkit-scrollbar:vertical {\r\n    display: block;\r\n    width: 1.125rem;\r\n}\r\n\r\n.tabulator .tabulator-tableHolder::-webkit-scrollbar:horizontal {\r\n    display: block;\r\n    height: 1.125rem;\r\n}\r\n\r\n.tabulator .tabulator-tableHolder::-webkit-scrollbar-thumb {\r\n    height: 15%;\r\n    border: .375rem solid transparent;\r\n    background-clip: content-box;\r\n    background-color: rgba(0, 0, 0, .25);\r\n    border-radius: 1.125rem;\r\n}\r\n\r\n.tabulator .tabulator-tableHolder::-webkit-scrollbar-track {\r\n    background-color: rgba(0, 0, 0, 0);\r\n}\r\n\r\n.tabulator .tabulator-footer {\r\n    /*margin-top:0rem;*/\r\n}\r\n\r\n.tabulator .tabulator-footer .tabulator-paginator {\r\n    justify-content: center;\r\n    margin: 0;\r\n    text-align: center;\r\n}\r\n\r\n.tabulator .tabulator-footer .tabulator-paginator .tabulator-page {}\r\n\r\n.tabulator .tabulator-footer .tabulator-paginator .tabulator-pages {}\r\n\r\n.tabulator .tabulator-footer .tabulator-paginator .tabulator-pages .tabulator-page {\r\n    /*display:none;*/\r\n}\r\n\r\n.tabulator .tabulator-footer .tabulator-paginator .tabulator-pages .tabulator-page.active {\r\n    display: inline-flex;\r\n}\r\n\r\n.react_select_padding {\r\n    padding: 0;\r\n    height: 30px;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.form_filter {\r\n    margin-top: .5rem;\r\n    /* padding: 1rem 1.25rem 1.25rem; */\r\n    padding: 0.5rem 1rem;\r\n    border-radius: .75rem;\r\n    background: #fff;\r\n    z-index: 10;\r\n}\r\n\r\n.form_filter::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    border-radius: inherit;\r\n    /* border: .125rem solid #064e3b; */\r\n    border: 1px solid #064e3b;\r\n    pointer-events: none;\r\n}\r\n\r\n.form_filter form {\r\n    display: flex;\r\n    align-items: flex-start;\r\n    flex-wrap: wrap;\r\n    gap: .25rem 1.25rem;\r\n}\r\n\r\n.form_filter .input_row {\r\n    position: relative;\r\n}\r\n\r\n.form_filter .input_row+.input_row {\r\n    margin-top: .5rem;\r\n}\r\n\r\n.form_filter .input_row label {\r\n    display: block;\r\n    margin-bottom: .125rem;\r\n    font-size: .8125rem;\r\n    font-weight: bold;\r\n}\r\n\r\n.form_filter .input_wrap {\r\n    flex-grow: 1;\r\n}\r\n\r\n.form_filter .input_item {}\r\n\r\n.form_filter .input_item input {\r\n    margin: 0;\r\n}\r\n\r\n.form_filter .input_item select {\r\n    cursor: pointer;\r\n}\r\n\r\n.form_filter .input_item .sorting {\r\n    display: flex;\r\n    margin-top: .375rem;\r\n}\r\n\r\n.form_filter .input_item .sorting.d_none {\r\n    display: none;\r\n}\r\n\r\n.form_filter .input_item .sorting button {\r\n    flex-grow: 1;\r\n    height: 1.875rem;\r\n    /* padding: 0; */\r\n    padding: 0 9px;\r\n    border-radius: 0;\r\n    font-size: .7rem;\r\n    letter-spacing: -.02rem;\r\n    white-space: nowrap;\r\n}\r\n\r\n.form_filter .input_item .sorting button+button {\r\n    margin-left: -.0625rem;\r\n}\r\n\r\n.form_filter .input_item .sorting button:first-child {\r\n    border-top-left-radius: .375rem;\r\n    border-bottom-left-radius: .375rem;\r\n}\r\n\r\n.form_filter .input_item .sorting button:last-child {\r\n    border-top-right-radius: .375rem;\r\n    border-bottom-right-radius: .375rem;\r\n}\r\n\r\n.form_filter .input_item .sorting button:focus {\r\n    --tw-ring-shadow: inset var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);\r\n}\r\n\r\n.form_filter .input_row.flex {\r\n    align-items: flex-start;\r\n    position: relative;\r\n}\r\n\r\n.form_filter .input_row.flex label {\r\n    flex-basis: 30%;\r\n    margin: 0;\r\n    line-height: 2.375rem;\r\n}\r\n\r\n.form_filter .input_row.flex .input_wrap {}\r\n\r\n.form_filter .input_item.flex {\r\n    column-gap: .5rem;\r\n}\r\n\r\n.form_filter .input_item.flex select {\r\n    flex-basis: 6.5rem;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.form_filter .input_item.flex input {}\r\n\r\n.form_filter .input_item.flex input+button {\r\n    flex-basis: 24%;\r\n    flex-shrink: 0;\r\n    white-space: nowrap;\r\n}\r\n\r\n.form_filter .button_wrap {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-end;\r\n    gap: .875rem;\r\n    margin-top: 1rem;\r\n}\r\n\r\n.form_filter .button_wrap.separate {\r\n    justify-content: flex-end;\r\n}\r\n\r\n.form_filter .button_wrap button {\r\n    /* flex-grow: 1; */\r\n    white-space: nowrap;\r\n}\r\n\r\n.form_filter .button_wrap button svg {\r\n    width: 1.0625rem;\r\n    height: 1.0625rem;\r\n    /* margin-right: .375rem; */\r\n}\r\n\r\n.form_filter .button_wrap .btn-small {\r\n    flex: 1 0 0;\r\n}\r\n\r\n.form_filter .merchant-search-list-box {\r\n    height: auto;\r\n}\r\n\r\n.form_filter .multiselect__container {\r\n    border: none;\r\n    box-shadow: none;\r\n    width: auto;\r\n    min-height: auto;\r\n    padding: 0;\r\n    font-family: inherit;\r\n}\r\n\r\n.form_filter .multiselect__wrapper {\r\n    font-size: inherit;\r\n    color: inherit;\r\n}\r\n\r\n.form_filter .multiselect__input {\r\n    flex-basis: auto;\r\n    transition: .2s cubic-bezier(.4, 0, .2, 1);\r\n    width: 100%;\r\n    height: 2.375rem;\r\n    padding: .5rem .75rem;\r\n    border-radius: .375rem;\r\n    border: .0625rem solid #e2e8f0;\r\n    font-size: .875rem;\r\n    line-height: 1.25rem;\r\n}\r\n\r\n.form_filter .multiselect__input:focus {\r\n    border-color: rgba(6, 78, 59, .4);\r\n    box-shadow: 0 0 0 .25rem rgba(6, 78, 59, .2);\r\n}\r\n\r\n.form_filter .multiselect__input::placeholder {\r\n    color: #9eacbf;\r\n}\r\n\r\n.form_filter .multiselect__input:-ms-input-placeholder {\r\n    color: #9eacbf;\r\n}\r\n\r\n.form_filter .multiselect__input::-ms-input-placeholder {\r\n    color: #9eacbf;\r\n}\r\n\r\n.form_filter .more_wrap {\r\n    position: relative;\r\n    bottom: -1.25rem;\r\n    transform: translateY(50%);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin-top: -1.5rem;\r\n    z-index: 1;\r\n}\r\n\r\n.form_filter .more_wrap button {\r\n    display: flex;\r\n    position: relative;\r\n    justify-content: center;\r\n    column-gap: .25rem;\r\n    padding: .25rem 1rem;\r\n    border-radius: 1.75rem;\r\n    box-shadow: 0 .0625rem .25rem rgba(0, 0, 0, .2);\r\n    background: #fff;\r\n    outline: none;\r\n    color: #074f3c;\r\n}\r\n\r\n.form_filter .more_wrap svg {\r\n    position: relative;\r\n    top: .1rem;\r\n    width: 1rem;\r\n    height: 1rem;\r\n}\r\n\r\n.form_filter .more_wrap span {\r\n    font-size: .75rem;\r\n    font-weight: 500;\r\n}\r\n\r\n.form_filter .more_wrap.short svg {\r\n    transform: rotate(180deg);\r\n}\r\n\r\n.form_filter .d_none,\r\n.on-pc {\r\n    display: none;\r\n}\r\n\r\n.form_filter+.box {\r\n    /* margin-top: 1.75rem; */\r\n    margin-top: .5rem;\r\n    height: calc(100% - 65px);\r\n    overflow: scroll;\r\n    /* height: auto; */\r\n}\r\n\r\n.tabulator_sorting_wrap {\r\n    display: flex;\r\n    align-items: flex-end;\r\n    justify-content: space-between;\r\n    /* height: 36px; */\r\n}\r\n\r\n.tabulator_sorting_wrap .excel_download {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    gap: .375rem .625rem;\r\n}\r\n\r\n.tabulator_sorting_wrap .excel_download button {\r\n    border: none;\r\n    background: #434242;\r\n    font-size: .8125rem;\r\n    color: #fff;\r\n}\r\n\r\n.tabulator_sorting_wrap .excel_download button:hover {\r\n    background: #434242;\r\n}\r\n\r\n.tabulator_sorting_wrap .excel_download button svg {\r\n    width: 1.0625rem;\r\n    height: 1.0625rem;\r\n    margin-right: .375rem;\r\n}\r\n\r\n.tabulator_sorting_wrap .excel_download .btn-warning {\r\n    background: #f59e0b;\r\n}\r\n\r\n.tabulator_sorting_wrap .excel_download .btn-warning:hover {\r\n    background: #f58c0b;\r\n}\r\n\r\n.tabulator_sorting_wrap .rows_per_page {\r\n    flex-shrink: 0;\r\n}\r\n\r\n.tabulator_sorting_wrap .rows_per_page select {\r\n    height: 2.25rem;\r\n    font-size: .8125rem;\r\n    cursor: pointer;\r\n}\r\n\r\n.tabulator_summary_wrap {\r\n    position: relative;\r\n    margin: 1rem 0;\r\n    /* height: 36px; */\r\n    /*padding:.5rem;*/\r\n    border-radius: .375rem;\r\n    /*background:#f1f5f9;*/\r\n}\r\n\r\n.tabulator_summary_wrap .input_wrap {\r\n    display: flex;\r\n    background: #f1f5f9;\r\n    align-items: center;\r\n    padding: 0 .75rem;\r\n    border-radius: .375rem;\r\n}\r\n\r\n.tabulator_summary_wrap .input_wrap+.input_wrap {\r\n    margin-top: .375rem;\r\n}\r\n\r\n.tabulator_summary_wrap .input_wrap label {\r\n    flex-shrink: 0;\r\n    font-size: .8125rem;\r\n}\r\n\r\n.tabulator_summary_wrap .input_wrap input {\r\n    padding: .5rem 0;\r\n    border-radius: 0;\r\n    border: none;\r\n    background: none;\r\n    box-shadow: none;\r\n    font-weight: bold;\r\n    text-align: right;\r\n    cursor: text;\r\n}\r\n\r\n.tabulator_total_cnt_wrap {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin: .5rem 0;\r\n}\r\n\r\n.tabulator_total_cnt_wrap input {\r\n    width: 100%;\r\n    border-radius: .375rem;\r\n    border: none;\r\n    background: #dce6ef;\r\n    font-size: .875rem;\r\n    font-weight: bold;\r\n    text-align: center;\r\n}\r\n\r\n.tabulator_total_cnt_wrap input:focus {\r\n    box-shadow: none;\r\n    border: none;\r\n    outline: none;\r\n}\r\n\r\n.tabulator_sorting_wrap .excel_download .tabulator_total_cnt_wrap {\r\n    justify-content: flex-start;\r\n    position: relative;\r\n    right: auto;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n.tabulator_sorting_wrap .excel_download .tabulator_total_cnt_wrap input {\r\n    width: auto;\r\n    padding: 0;\r\n    border-radius: 0;\r\n    background: none;\r\n    line-height: 2.25rem;\r\n    text-align: left;\r\n}\r\n\r\n.tabulator_summary_wrap .btn_more {\r\n    margin-left: .25rem;\r\n    outline: none;\r\n}\r\n\r\n.tabulator_summary_wrap .btn_more svg {\r\n    width: 1.25rem;\r\n    height: 1.25rem;\r\n    margin: .125rem;\r\n}\r\n\r\n.tabulator_summary_wrap .btn_more.active {}\r\n\r\n.tabulator_summary_wrap .btn_more.active svg {\r\n    transform: rotate(180deg);\r\n}\r\n\r\n.tabulator_summary_wrap .d_none {\r\n    display: none;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n/*-------------------- Dashboard page --------------------*/\r\n.dashboard.inner-wrap {\r\n    display: flex;\r\n    flex-direction: column;\r\n    /* justify-content: center; */\r\n    align-items: center;\r\n}\r\n\r\n.dashboard .content-container {\r\n    width: 100%;\r\n    /* max-width: 38.75rem; */\r\n    /* max-width: 100%; */\r\n}\r\n\r\n.dashboard .main-title-wrap {\r\n    /*padding-top: .75rem;*/\r\n    border-bottom: .0625rem solid #d1d5d9;\r\n}\r\n\r\n.dashboard .main-title-wrap .title {\r\n    display: inline-block;\r\n    position: relative;\r\n    padding: 0 1rem;\r\n    font-size: .9rem;\r\n    font-weight: bold;\r\n    line-height: 2.5rem;\r\n}\r\n\r\n.dashboard .main-title-wrap .title:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: -.0625rem;\r\n    height: .1875rem;\r\n    background: #064e3b;\r\n    border-top-left-radius: .1875rem;\r\n    border-top-right-radius: .1875rem;\r\n}\r\n\r\n.dashboard .main-title-wrap .btn-wrap {\r\n    position: absolute;\r\n    top: 50%;\r\n    right: 0;\r\n    transform: translateY(-50%);\r\n    padding-top: .75rem;\r\n}\r\n\r\n.dashboard .main-title-wrap .btn-wrap button {\r\n    width: 2.25rem;\r\n    height: 2.25rem;\r\n}\r\n\r\n.dashboard .main-title-wrap .btn-wrap button+button {\r\n    margin-left: .25rem;\r\n}\r\n\r\n.dashboard .main-title-wrap .btn-wrap button svg {\r\n    width: auto;\r\n    height: 1.75rem;\r\n    margin: 0 auto;\r\n}\r\n\r\n.dashboard .panel {\r\n    margin: .5rem 0;\r\n}\r\n\r\n.dashboard .sales .panel {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.dashboard .sales .panel ul {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n    background: rgb(255, 255, 255);\r\n    box-shadow: rgba(0, 0, 0, 0.04) 0px 0.25rem 0.5rem;\r\n    border-radius: 10px;\r\n}\r\n\r\n/* .dashboard .sales .panel ul + ul { margin-top:.875rem; } */\r\n.dashboard .sales .panel ul li {\r\n    display: flex;\r\n    flex-direction: row;\r\n    width: 100%;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    position: relative;\r\n    /* padding: .75rem .75rem; */\r\n    padding: 1rem;\r\n    /* box-shadow: 0 .25rem .5rem rgba(0, 0, 0, .04); */\r\n    background: #fff;\r\n}\r\n\r\n.dashboard .sales .panel ul li:first-child {\r\n    border-top-left-radius: .5rem;\r\n    border-top-right-radius: .5rem;\r\n    border-bottom: .0625rem solid rgba(0, 0, 0, .08);\r\n}\r\n\r\n.dashboard .sales .panel ul li:last-child {\r\n    border-bottom-left-radius: .5rem;\r\n    border-bottom-right-radius: .5rem;\r\n}\r\n\r\n.dashboard .sales .panel ul li .calc-title {\r\n    display: block;\r\n    position: relative;\r\n    margin-bottom: 0;\r\n    color: #64748b;\r\n}\r\n\r\n.dashboard .sales .panel ul li .calc-item {\r\n    text-align: right;\r\n    white-space: nowrap;\r\n}\r\n\r\n.dashboard .sales .panel ul li .calc-item money {\r\n    /* font-size: 1.375rem; */\r\n    font-size: 1.1rem;\r\n    font-weight: bold;\r\n}\r\n\r\n.dashboard .sales .panel ul li .cancelation {\r\n    color: #d52424;\r\n}\r\n\r\n.dashboard .sales .panel .em li:first-child {\r\n    background: linear-gradient(135deg, #434242, #000000);\r\n}\r\n\r\n.dashboard .sales .panel .em li:first-child .calc-title {\r\n    color: #fff;\r\n}\r\n\r\n.dashboard .sales .panel .em li:first-child .calc-item money {\r\n    color: #fff;\r\n}\r\n\r\n.dashboard .sales .panel .em li:first-child .calc-item span {\r\n    color: rgba(255, 255, 255, .75);\r\n}\r\n\r\n.dashboard .sales .panel ul li+li {\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n\r\n.dashboard .sales .panel li+li .calc-title {\r\n    margin: 0;\r\n}\r\n\r\n.dashboard .sales .panel li+li .calc-item money {\r\n    font-size: 0.95rem;\r\n    font-weight: 500;\r\n}\r\n\r\n.dashboard .sales .panel li+li .calc-item span {}\r\n\r\n.dashboard .sales .panel li+li~li {\r\n    margin-top: -1rem;\r\n}\r\n\r\n.dashboard .sales .panel {\r\n    flex-direction: column;\r\n    gap: 1rem;\r\n    /* align-items: center; */\r\n}\r\n\r\n.dashboard .calc-table li {\r\n    position: relative;\r\n    padding: 1rem 1.25rem;\r\n    border-radius: .5rem;\r\n    box-shadow: 0 .25rem .5rem rgb(0 0 0 /4%);\r\n    background: #fff;\r\n    overflow: hidden;\r\n}\r\n\r\n.dashboard .calc-table li+li {\r\n    margin-top: .875rem;\r\n}\r\n\r\n.dashboard .calc-table li:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    border-radius: inherit;\r\n    border: .0625rem solid rgb(0 0 0 / 8%);\r\n    pointer-events: none;\r\n}\r\n\r\n.dashboard .calc-table li .calc-title {\r\n    display: block;\r\n    margin-bottom: .5rem;\r\n    font-size: .8125rem;\r\n    line-height: 2;\r\n}\r\n\r\n.dashboard .calc-table li:nth-child(1) .calc-title {\r\n    color: #0d9488;\r\n}\r\n\r\n.dashboard .calc-table li:nth-child(2) .calc-title {\r\n    color: #ff9f89;\r\n}\r\n\r\n.dashboard .calc-table li:nth-child(3) .calc-title {\r\n    color: #064e3b;\r\n}\r\n\r\n.dashboard .calc-table li:nth-child(4) .calc-title {\r\n    color: #0e9488;\r\n}\r\n\r\n.dashboard .calc-table li .calc-item {\r\n    display: inline-block;\r\n    font-size: 1.375rem;\r\n    font-weight: bold;\r\n}\r\n\r\n.dashboard .calc-table li .calc-cnt {\r\n    display: inline-block;\r\n    margin-left: .25rem;\r\n    font-size: .8125rem;\r\n    font-weight: 500;\r\n    color: #919599;\r\n}\r\n\r\n.dashboard .calc-table li progress {\r\n    display: block;\r\n    width: 100%;\r\n    height: .3125rem;\r\n    margin: .75rem 0 .5rem;\r\n    border-radius: .3125rem;\r\n    overflow: hidden;\r\n}\r\n\r\n.dashboard .dailyStatsChart,\r\n.dashboard .monthlyStatsChart {\r\n    height: 16rem;\r\n    border-radius: .5rem;\r\n    box-shadow: 0 .25rem .5rem rgb(0 0 0 / 4%);\r\n    background: #fff;\r\n    padding: 1rem 1rem;\r\n}\r\n\r\n.dashboard .dailyStatsChart canvas,\r\n.dashboard .monthlyStatsChart canvas {\r\n    width: 100% !important;\r\n    height: 100% !important;\r\n}\r\n\r\n.dashboard .branchList {\r\n    margin: 1.5rem 0;\r\n}\r\n\r\n.dashboard .branchList>div+div {\r\n    margin-top: .875rem;\r\n}\r\n\r\n.dashboard .branchList .box {\r\n    position: relative;\r\n    min-height: 4.5rem;\r\n    margin: 0;\r\n    padding: 1rem 1.25rem;\r\n    border-radius: .5rem;\r\n    box-shadow: 0 .25rem .5rem rgb(0 0 0 / 4%);\r\n    background: #fff;\r\n    overflow: hidden;\r\n}\r\n\r\n.dashboard .branchList .box:after {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    border-radius: inherit;\r\n    border: .0625rem solid rgb(0 0 0 / 8%);\r\n    pointer-events: none;\r\n}\r\n\r\n.dashboard .branchList .box>div:nth-child(1) {\r\n    margin-left: 0;\r\n    padding-right: .75rem;\r\n}\r\n\r\n.dashboard .branchList .box>div:nth-child(2) {\r\n    flex-shrink: 0;\r\n    padding: .3125rem .625rem;\r\n    font-size: .8125rem;\r\n}\r\n\r\n.dashboard .branchList .box>div span {\r\n    flex-shrink: 0;\r\n    display: inline-block;\r\n    position: relative;\r\n    top: -.25rem;\r\n    left: 0;\r\n    width: 2.25rem;\r\n    height: 2.25rem;\r\n    margin-right: .625rem;\r\n    border-radius: 50%;\r\n    border-width: .25rem;\r\n    border-style: solid;\r\n    line-height: 1.8125rem;\r\n    text-align: center;\r\n    color: #fff;\r\n}\r\n\r\n.dashboard .branchList .box>div span:after {\r\n    content: \"\";\r\n    display: block;\r\n    position: absolute;\r\n    top: 1.5rem;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    width: 0;\r\n    height: 1.125rem;\r\n    border-width: .375rem .625rem;\r\n    border-style: solid;\r\n    border-color: #fc402d #fc402d transparent #fc402d;\r\n    z-index: -1;\r\n    pointer-events: none;\r\n}\r\n\r\n.dashboard .branchList .box>div:nth-child(1) div {\r\n    display: flex;\r\n    align-items: center;\r\n    font-size: .875rem;\r\n    font-weight: bold;\r\n}\r\n\r\n/* medal index color */\r\n.dashboard .branchList>div:nth-child(1) .box>div:nth-child(1) span {\r\n    border-color: #fadd40;\r\n    box-shadow: inset 0 0 0 #b67d05, .125rem .125rem 0 rgb(0 0 0 / 8%);\r\n    background: linear-gradient(to bottom right, #f9ad0e 50%, #e89f06 50%);\r\n    text-shadow: 0 0 .25rem #9d6c04;\r\n}\r\n\r\n.dashboard .branchList>div:nth-child(2) .box>div:nth-child(1) span {\r\n    border-color: #edeff1;\r\n    box-shadow: inset 0 0 0 #a7b2b8, .125rem .125rem 0 rgb(0 0 0 / 8%);\r\n    background: linear-gradient(to bottom right, #d1d7da 50%, #c3cbcf 50%);\r\n    text-shadow: 0 0 .25rem #98a6ad;\r\n}\r\n\r\n.dashboard .branchList>div:nth-child(3) .box>div:nth-child(1) span {\r\n    border-color: #f7bb23;\r\n    box-shadow: inset 0 0 0 #955405, .125rem .125rem 0 rgb(0 0 0 / 8%);\r\n    background: linear-gradient(to bottom right, #df7e08 50%, #c67007 50%);\r\n    text-shadow: 0 0 .25rem #7d4604;\r\n}\r\n\r\n.dashboard .branchList>div:nth-child(n + 4) .box>div:nth-child(1) span {\r\n    top: 0;\r\n    box-shadow: none;\r\n    border-color: #e0e1f3;\r\n    background: linear-gradient(to bottom right, #c3c7d3 50%, #b3b6bd 50%);\r\n    text-shadow: 0 0 .25rem #858ea1;\r\n}\r\n\r\n.dashboard .branchList>div:nth-child(n + 4) .box>div:nth-child(1) span:after {\r\n    display: none;\r\n}\r\n\r\n.dashboard .notice-wrap>div {\r\n    position: relative;\r\n    min-height: 9.25rem;\r\n    padding: 1.25rem;\r\n    border-radius: .5rem;\r\n    box-shadow: 0 .25rem .5rem rgb(0 0 0 / 4%);\r\n    background: #fff;\r\n    overflow: hidden;\r\n}\r\n\r\n.dashboard .notice-wrap>div:after {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    border-radius: inherit;\r\n    border: .0625rem solid rgb(0 0 0 / 8%);\r\n    pointer-events: none;\r\n}\r\n\r\n.dashboard .notice-wrap>div+div {\r\n    margin-top: .875rem;\r\n}\r\n\r\n.dashboard .notice-wrap .text-base {\r\n    margin-bottom: .5rem;\r\n    font-size: .9375rem;\r\n    font-weight: bold;\r\n}\r\n\r\n.dashboard .notice-wrap .text-slate-400 {\r\n    /*position: absolute;*/\r\n    /*left: 1.25rem;*/\r\n    /*bottom: 1.25rem;*/\r\n    float: right;\r\n    line-height: 1.4;\r\n}\r\n\r\n.dashboard .notice-wrap .text-slate-500 {\r\n    margin: 0;\r\n}\r\n\r\n.dashboard .notice-wrap .text-slate-500+div,\r\n.dashboard .notice-wrap .text-slate-500+div button {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    margin: 0;\r\n    padding: 0;\r\n    opacity: 0;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n/*-------------------- Payment page --------------------*/\r\n.payment {\r\n    min-height: auto;\r\n    padding: 0 0 1rem;\r\n    border-radius: 1rem;\r\n}\r\n\r\n.payment .inner-wrap {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.payment .tab-wrap {\r\n    position: relative;\r\n    width: 100%;\r\n    max-width: 33.75rem;\r\n    padding-top: .75rem;\r\n    border-bottom: .0625rem solid #d1d5d9;\r\n}\r\n\r\n.payment .tab-wrap li {\r\n    display: inline-block;\r\n    position: relative;\r\n}\r\n\r\n.payment .tab-wrap li:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: -.0625rem;\r\n    height: .1875rem;\r\n    background: #064e3b;\r\n    border-top-left-radius: .1875rem;\r\n    border-top-right-radius: .1875rem;\r\n    opacity: 0;\r\n}\r\n\r\n.payment .tab-wrap li a {\r\n    display: block;\r\n    padding: 0 1rem;\r\n    font-size: .875rem;\r\n    font-weight: bold;\r\n    line-height: 3.25rem;\r\n    cursor: pointer;\r\n}\r\n\r\n.payment .tab-wrap li.current:before {\r\n    opacity: 1;\r\n}\r\n\r\n.payment .content-wrap {\r\n    width: 100%;\r\n    max-width: 33.75rem;\r\n    margin: 0 auto;\r\n    padding: 2rem 0 1rem;\r\n}\r\n\r\n.payment .intro-y {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    width: calc(100% + 1rem);\r\n    margin-left: -.5rem;\r\n    background: #f0f4f8;\r\n    box-shadow: none;\r\n}\r\n\r\n/* Payment - payForm */\r\n.payment .content-wrap .payForm {\r\n    display: none;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n.payment .content-wrap .payForm.active {\r\n    display: block;\r\n}\r\n\r\n.payment .payForm .form-label {\r\n    margin-bottom: .375rem;\r\n    font-size: .8125rem;\r\n    font-weight: bold;\r\n}\r\n\r\n.payment .payForm .input {\r\n    width: 100%;\r\n    margin: 0 .5rem 1rem;\r\n}\r\n\r\n.payment .payForm .input input {}\r\n\r\n.payment .payForm .input input::placeholder {\r\n    font-size: .875rem;\r\n}\r\n\r\n.payment .payForm .input.w33 {\r\n    width: calc(33.33% - 1rem);\r\n}\r\n\r\n.payment .payForm .input.w50 {\r\n    width: calc(50% - 1rem);\r\n}\r\n\r\n.payment .payForm .input.w66 {\r\n    width: calc(66.66% - 1rem);\r\n}\r\n\r\n.payment .payForm .input .multiple {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.payment .payForm .input .multiple span {\r\n    padding: 0 .375rem;\r\n}\r\n\r\n.payment .payForm .mt-2,\r\n.payment .payForm .mt-3 {\r\n    margin: 0;\r\n}\r\n\r\n.payment .payForm .pos_aps_r {\r\n    margin: .25rem 0 -1.25rem;\r\n}\r\n\r\n.payment .payForm .payBt {\r\n    width: 100%;\r\n    margin: 1.5rem 0 1rem;\r\n    text-align: center;\r\n}\r\n\r\n.payment .payForm .payBt .btn {\r\n    width: 40%;\r\n    max-width: 12.5rem;\r\n}\r\n\r\n.payment .payForm .payBt .btn+.btn {\r\n    margin-left: .5rem;\r\n}\r\n\r\n/* Payment - cardInfo */\r\n.payment .content-wrap .cardInfo {\r\n    display: none;\r\n    width: 100%;\r\n    max-width: 33.75rem;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n.payment .content-wrap .cardInfo.active {\r\n    display: block;\r\n}\r\n\r\n.payment .cardInfo .tabulator {\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n.payment .cardInfo .tabulator-header {\r\n    border-width: 0;\r\n}\r\n\r\n.payment .cardInfo .tabulator-headers {\r\n    text-align: right;\r\n}\r\n\r\n.payment .cardInfo .tabulator-headers>div:nth-child(1) {\r\n    display: none;\r\n}\r\n\r\n.payment .cardInfo .tabulator-tableHolder {\r\n    margin-top: .5rem;\r\n    overflow: hidden;\r\n}\r\n\r\n.payment .cardInfo .tabulator-tableHolder .tabulator-table {\r\n    width: 100%;\r\n    background: none;\r\n}\r\n\r\n.payment .cardInfo .tabulator-row,\r\n.payment .cardInfo .tabulator-row.tabulator-row-even {\r\n    margin-bottom: 1.25rem;\r\n    background: #fff;\r\n    border-radius: .75rem;\r\n    border-bottom-width: 0;\r\n}\r\n\r\n.payment .cardInfo .tabulator-row .tabulator-cell {\r\n    font-weight: bold;\r\n}\r\n\r\n.payment .cardInfo .tabulator-row .tabulator-responsive-collapse table {\r\n    width: 100%;\r\n}\r\n\r\n.payment .cardInfo .tabulator-row .tabulator-responsive-collapse td {\r\n    padding-top: .1875rem;\r\n    padding-bottom: .1875rem;\r\n    font-size: .8125rem;\r\n}\r\n\r\n.payment .cardInfo .tabulator-row .tabulator-responsive-collapse td:nth-child(2) {\r\n    font-weight: bold;\r\n    text-align: right;\r\n}\r\n\r\n.payment .cardInfo .tabulator-row .tabulator-responsive-collapse td strong {\r\n    color: #a1a5a9;\r\n}\r\n\r\n.payment .cardInfo .tabulator-footer .tabulator-paginator {\r\n    justify-content: center;\r\n    margin: 0;\r\n    text-align: center;\r\n}\r\n\r\n.payment .cardInfo .tabulator-footer .tabulator-page.active {\r\n    background: #064e3b;\r\n    color: #fff;\r\n}\r\n\r\n/* Payment - modal */\r\n.payment .modal .modal-body .col-span-12 {\r\n    grid-column: span 12 / span 12;\r\n}\r\n\r\n.payment .modal .modal-body .sm\\:col-span-6 {\r\n    grid-column: span 6 / span 6;\r\n}\r\n\r\n/*-------------------- eastpayReq page --------------------*/\r\n.east-pay {\r\n    height: 97%;\r\n}\r\n\r\n.east-pay .content-wrap {\r\n    max-width: 30rem;\r\n    height: 100%;\r\n\r\n}\r\n\r\n.east-pay .inner-wrap {\r\n    padding-top: 1.25rem;\r\n}\r\n\r\n.east-pay .payForm .input_container .input_list {\r\n    display: flex;\r\n    gap: 0 1.5rem;\r\n}\r\n\r\n.east-pay .payForm .input_container:nth-child(2) {\r\n    padding-bottom: 2.5rem;\r\n}\r\n\r\n.east-pay .payForm .input_container:last-child {\r\n    padding-top: 2.5rem;\r\n    border-top: 0.0625rem solid #d7d9da;\r\n}\r\n\r\n.east-pay .content-wrap .payForm {\r\n    display: none;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n.east-pay .content-wrap .payForm.active {\r\n    display: block;\r\n}\r\n\r\n.east-pay .payForm .form-label {\r\n    margin-bottom: .375rem;\r\n    font-size: .8125rem;\r\n    font-weight: bold;\r\n}\r\n\r\n.east-pay .payForm .input {\r\n    width: 100%;\r\n    /* margin: 0 .5rem 1rem; */\r\n    margin: 0 0 1rem;\r\n}\r\n\r\n.east-pay .payForm .input input {}\r\n\r\n.east-pay .payForm .input input::placeholder {\r\n    font-size: .875rem;\r\n}\r\n\r\n.east-pay .payForm .input.w33 {\r\n    width: calc(33.33% - 1rem);\r\n}\r\n\r\n.east-pay .payForm .input.w50 {\r\n    width: calc(50% - 1rem);\r\n}\r\n\r\n.east-pay .payForm .input.w66 {\r\n    width: calc(66.66% - 1rem);\r\n}\r\n\r\n.east-pay .payForm .input .multiple {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.east-pay .payForm .input .multiple span {\r\n    padding: 0 .375rem;\r\n}\r\n\r\n.east-pay .payForm .mt-2,\r\n.east-pay .payForm .mt-3 {\r\n    margin: 0;\r\n}\r\n\r\n.east-pay .payForm .pos_aps_r {\r\n    margin: .25rem 0 -1.25rem;\r\n}\r\n\r\n.east-pay .payForm .payBt {\r\n    width: 100%;\r\n    margin: 1.5rem 0 1rem;\r\n    text-align: center;\r\n}\r\n\r\n.east-pay .payForm .payBt .btn {\r\n    width: 40%;\r\n    max-width: 12.5rem;\r\n}\r\n\r\n.east-pay .payForm .payBt .btn+.btn {\r\n    margin-left: .5rem;\r\n}\r\n\r\n.east-pay .input textarea {\r\n    height: 10rem;\r\n    resize: none;\r\n}\r\n\r\n.east-pay .box {\r\n    background: none;\r\n    box-shadow: none;\r\n}\r\n\r\n\r\n\r\n.east-pay .main-title-wrap {\r\n    width: 100%;\r\n    max-width: 33.75rem;\r\n    padding-top: 0.75rem;\r\n    margin-bottom: 2rem;\r\n    border-bottom: 0.0625rem solid #d1d5d9;\r\n}\r\n\r\n.east-pay .title {\r\n    padding-bottom: 1rem;\r\n    font-size: 1.0625rem;\r\n    font-weight: bold;\r\n    line-height: 3.25rem;\r\n    ;\r\n}\r\n\r\n.east-pay .main-title-wrap .title:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: -0.0625rem;\r\n    height: 0.1875rem;\r\n    background: #064e3b;\r\n    border-top-left-radius: 0.1875rem;\r\n    border-top-right-radius: 0.1875rem;\r\n}\r\n\r\n.east-pay .btn-wrap button {\r\n    max-width: 18rem;\r\n    flex-grow: 1;\r\n}\r\n\r\n\r\n@media (min-width: 1280px) {\r\n\r\n    /* .east-pay .main-title-wrap {\r\n        display: none;\r\n        max-width: none;\r\n        border: none;\r\n    } */\r\n    .east-pay .content-wrap {\r\n        padding: 1.5rem 2rem 1rem;\r\n        background-color: #fff;\r\n    }\r\n\r\n    .pay_status {\r\n        width: 4rem;\r\n    }\r\n\r\n    .amt_range {\r\n        width: 12rem;\r\n    }\r\n\r\n    .pg_gubun {\r\n        width: 5rem;\r\n    }\r\n}\r\n\r\n@media (max-width: 766px) {\r\n    .east-pay .content-wrap {\r\n        max-width: 33.75rem;\r\n        margin: 0 auto;\r\n    }\r\n\r\n    .east-pay .inner-wrap {\r\n        padding-top: 0;\r\n    }\r\n\r\n}\r\n\r\n@media (max-width: 640px) {\r\n    .east-pay .payForm .input_container .input_list {\r\n        gap: 0 .75rem;\r\n    }\r\n\r\n    .east-pay .payForm .input.w50 {\r\n        width: calc((100% - 0.75rem)/2);\r\n    }\r\n\r\n    .east-pay .payForm .input_container:nth-child(2) {\r\n        padding-bottom: 1rem;\r\n    }\r\n\r\n    .east-pay .payForm .input_container:last-child {\r\n        padding-top: 1.5rem;\r\n    }\r\n\r\n    .east-pay .btn-wrap button {\r\n        max-width: 100%;\r\n    }\r\n}\r\n\r\n/* Payment - cardInfo */\r\n.east-pay .content-wrap .cardInfo {\r\n    display: none;\r\n    width: 100%;\r\n    max-width: 33.75rem;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n.east-pay .content-wrap .cardInfo.active {\r\n    display: block;\r\n}\r\n\r\n/*-------------------- Calender page --------------------*/\r\n.calendar {\r\n    min-height: auto;\r\n    padding: 0 0 1rem;\r\n    border-radius: 1rem;\r\n}\r\n\r\n.calendar .inner-wrap {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.calendar .main-title-wrap {\r\n    width: 100%;\r\n    max-width: 33.75rem;\r\n    padding-top: .75rem;\r\n    border-bottom: .0625rem solid #d1d5d9;\r\n}\r\n\r\n.calendar .main-title-wrap .title {\r\n    display: inline-block;\r\n    position: relative;\r\n    padding: 0 1rem;\r\n    font-size: .875rem;\r\n    font-weight: bold;\r\n    line-height: 3.25rem;\r\n}\r\n\r\n.calendar .main-title-wrap .title:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: -.0625rem;\r\n    height: .1875rem;\r\n    background: #064e3b;\r\n    border-top-left-radius: .1875rem;\r\n    border-top-right-radius: .1875rem;\r\n}\r\n\r\n.calendar .content-wrap {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.calendar .content-wrap .content-col {\r\n    width: 100%;\r\n    max-width: 33.75rem;\r\n    margin: 0 auto;\r\n    padding: 2rem 0 1rem;\r\n}\r\n\r\n.calendar .content-wrap .content-col.left {\r\n    order: 2;\r\n}\r\n\r\n.calendar .content-wrap .content-col.right {\r\n    order: 1;\r\n}\r\n\r\n.calendar .content-wrap .title-wrap .title {\r\n    font-size: .9375rem;\r\n    font-weight: bold;\r\n}\r\n\r\n/* calendar - chat box */\r\n.calendar .chat__box {\r\n    margin-top: 3rem;\r\n}\r\n\r\n.calendar .chat__box .cal-chat-wrap {\r\n    position: relative;\r\n    border-radius: .5rem;\r\n    box-shadow: 0 .25rem .5rem rgb(0 0 0 / 4%);\r\n    background: #fff;\r\n    overflow: hidden;\r\n}\r\n\r\n.calendar .chat__box .cal-chat-wrap:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    border-radius: inherit;\r\n    border: .0625rem solid #ddd;\r\n    z-index: 1;\r\n    pointer-events: none;\r\n}\r\n\r\n.calendar .chat__box .title-wrap {\r\n    display: flex;\r\n    align-items: center;\r\n    position: relative;\r\n    padding: 1.25rem 1rem .75rem;\r\n    border-bottom: .0625rem solid #ddd;\r\n}\r\n\r\n.calendar .chat__box .title-wrap .thumb {\r\n    position: relative;\r\n    width: 1.75rem;\r\n    height: 1.75rem;\r\n    border-radius: 50%;\r\n    overflow: hidden;\r\n}\r\n\r\n.calendar .chat__box .title-wrap .thumb:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    border-radius: inherit;\r\n    border: .0625rem solid rgb(0 0 0 / 4%);\r\n    z-index: 1;\r\n    pointer-events: none;\r\n}\r\n\r\n.calendar .chat__box .title-wrap .thumb img {\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    width: auto;\r\n    height: 100%;\r\n}\r\n\r\n.calendar .chat__box .title-wrap .name {\r\n    margin-left: .375rem;\r\n}\r\n\r\n.calendar .chat__box .title-wrap .name h3 {\r\n    font-weight: bold;\r\n}\r\n\r\n.calendar .chat__box .title-wrap .btn-notice {\r\n    position: absolute;\r\n    right: 1.25rem;\r\n    text-align: right;\r\n}\r\n\r\n.calendar .chat__box .title-wrap .btn-notice button {\r\n    height: 1.625rem;\r\n    padding: 0 .75rem;\r\n    border-radius: .25rem;\r\n    background: #94a3b8;\r\n    font-size: .75rem;\r\n    font-weight: 500;\r\n    line-height: 1.625rem;\r\n    color: #fff;\r\n}\r\n\r\n.calendar .chat__box .notice-wrap {\r\n    display: flex;\r\n    align-items: center;\r\n    min-height: 3rem;\r\n    padding: .5rem 1rem;\r\n    border-bottom: .0625rem solid #ddd;\r\n    background: #fff;\r\n}\r\n\r\n.calendar .chat__box .notice-wrap.d-none {\r\n    display: none;\r\n}\r\n\r\n.calendar .chat__box .chat-container {\r\n    min-height: 14rem;\r\n    max-height: calc(100dvh - 18.5rem);\r\n    padding: 1rem 1rem 0;\r\n    background: #afc0d7;\r\n    overflow-y: auto;\r\n}\r\n\r\n.calendar .chat__box .chat-container::-webkit-scrollbar {\r\n    display: block;\r\n    width: 1.125rem;\r\n}\r\n\r\n.calendar .chat__box .chat-container::-webkit-scrollbar-thumb {\r\n    height: 15%;\r\n    border: .375rem solid transparent;\r\n    background-clip: content-box;\r\n    background-color: rgba(0, 0, 0, .25);\r\n    border-radius: 1.125rem;\r\n}\r\n\r\n.calendar .chat__box .chat-container::-webkit-scrollbar-track {\r\n    background-color: rgba(0, 0, 0, 0);\r\n}\r\n\r\n.calendar .chat__box .chat-container .chat-wrap {\r\n    display: block;\r\n    position: relative;\r\n    margin: 0 0 1.25rem;\r\n}\r\n\r\n.calendar .chat__box .chat-container .chat-wrap div.d-none {\r\n    display: none;\r\n}\r\n\r\n.calendar .chat__box .chat-container .chat-wrap div:nth-child(1) {\r\n    display: block;\r\n    height: auto;\r\n    margin: 0 0 .5rem;\r\n    font-size: .75rem;\r\n    font-weight: bold;\r\n    line-height: 1;\r\n}\r\n\r\n.calendar .chat__box .chat-container .chat-wrap div:nth-child(2) {\r\n    display: flex;\r\n    align-items: flex-end;\r\n    position: relative;\r\n    padding: 0;\r\n    background: none;\r\n}\r\n\r\n.calendar .chat__box .chat-container .chat-wrap div:nth-child(2) span {\r\n    display: inline-block;\r\n    position: relative;\r\n    margin: .25rem 0 0;\r\n    padding: .375rem .75rem;\r\n    border-radius: .5rem;\r\n    background: #f1f5f9;\r\n}\r\n\r\n.calendar .chat__box .chat-container .chat-wrap div:nth-child(2) span:after {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: -.4375rem;\r\n    left: .75rem;\r\n    border-top: 0 solid transparent;\r\n    border-left: .5rem solid transparent;\r\n    border-right: .5rem solid transparent;\r\n    border-bottom: .5rem solid #f1f5f9;\r\n}\r\n\r\n.calendar .chat__box .chat-container .chat-wrap div:nth-child(2) div {\r\n    flex-shrink: 0;\r\n    display: inline-block;\r\n    margin: 0 0 0 .375rem;\r\n    font-size: .7rem;\r\n    font-weight: 500;\r\n    letter-spacing: -.0125rem;\r\n    white-space: nowrap;\r\n}\r\n\r\n.calendar .chat__box .chat-container .chat-wrap div:nth-child(3) {\r\n    margin: .375rem 0 0;\r\n}\r\n\r\n.calendar .chat__box .chat-container .chat-wrap div:nth-child(3) button {\r\n    font-weight: bold;\r\n}\r\n\r\n.calendar .chat__box .message-wrap {\r\n    position: relative;\r\n}\r\n\r\n.calendar .chat__box .message-wrap input {\r\n    width: calc(100% - 3.25rem);\r\n    height: 3.25rem;\r\n    padding-left: 1rem;\r\n    padding-right: 1rem;\r\n    border-radius: 0;\r\n    box-shadow: none;\r\n    font-size: .9375rem;\r\n}\r\n\r\n.calendar .chat__box .message-wrap input::placeholder {\r\n    font-size: 1rem;\r\n}\r\n\r\n.calendar .chat__box .message-wrap a {\r\n    position: absolute;\r\n    top: 50%;\r\n    right: 0;\r\n    transform: translateY(-50%);\r\n    width: 3.25rem;\r\n    height: 3.25rem;\r\n    margin: 0;\r\n    border-radius: 0;\r\n}\r\n\r\n.calendar .chat__box .message-wrap a svg {\r\n    width: 1.25rem;\r\n    height: 1.25rem;\r\n}\r\n\r\n/* calendar - calendar */\r\n.calendar .calendar-category-wrap {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    margin-bottom: .75rem;\r\n    margin-top: .75rem;\r\n}\r\n\r\n.calendar .calendar-category-wrap li {\r\n    margin: 0 .625rem;\r\n}\r\n\r\n.calendar .calendar-category-wrap span {\r\n    display: inline-block;\r\n    width: .625rem;\r\n    height: .625rem;\r\n    border-radius: .1875rem;\r\n}\r\n\r\n.calendar .calendar-category-wrap p {\r\n    display: inline-block;\r\n    margin-left: .125rem;\r\n    font-size: .75rem;\r\n    font-weight: 500;\r\n}\r\n\r\n.calendar .full-calendar .fc-header-toolbar {\r\n    position: relative;\r\n    height: 2.25rem;\r\n    margin-bottom: 1rem;\r\n}\r\n\r\n.calendar .full-calendar .fc-header-toolbar .fc-left {\r\n    display: inline-block;\r\n    position: relative;\r\n    left: 2.25rem;\r\n    width: 6.75rem;\r\n    text-align: center;\r\n    z-index: 1;\r\n}\r\n\r\n.calendar .full-calendar .fc-header-toolbar .fc-left h2 {\r\n    float: none;\r\n    font-size: 1rem;\r\n    font-weight: bold;\r\n    line-height: 2.25rem;\r\n}\r\n\r\n.calendar .full-calendar .fc-header-toolbar .fc-right {\r\n    float: none;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n}\r\n\r\n.calendar .full-calendar .fc-header-toolbar .fc-right .fc-today-button {\r\n    position: absolute;\r\n    top: .1875rem;\r\n    right: 0;\r\n    height: 1.875rem;\r\n    padding: 0 .75rem;\r\n    border: none;\r\n    box-shadow: none;\r\n    background: #94a3b8;\r\n    font-weight: 500;\r\n    line-height: 1.875rem;\r\n    text-shadow: none;\r\n    color: #fff;\r\n    opacity: 1;\r\n}\r\n\r\n.calendar .full-calendar .fc-header-toolbar .fc-right .fc-today-button.fc-state-disabled {\r\n    background: #e1e5e9;\r\n    color: #1e293b;\r\n    cursor: default;\r\n}\r\n\r\n.calendar .full-calendar .fc-header-toolbar .fc-right .fc-button-group {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    position: absolute;\r\n    left: 0;\r\n    width: 11.25rem;\r\n    margin: 0;\r\n}\r\n\r\n.calendar .full-calendar .fc-header-toolbar .fc-right .fc-button-group button {\r\n    float: none;\r\n    width: 2.25rem;\r\n    height: 2.25rem;\r\n    margin: 0;\r\n    border: none;\r\n    box-shadow: none;\r\n    background: none;\r\n}\r\n\r\n.calendar .full-calendar .fc-view-container .fc-view .fc-head-container {\r\n    border: none;\r\n}\r\n\r\n.calendar .full-calendar .fc-view-container .fc-view .fc-head .fc-row {\r\n    margin: 0 !important;\r\n    border: none !important;\r\n}\r\n\r\n.calendar .full-calendar .fc-view-container .fc-view .fc-head .fc-row th {\r\n    border: none;\r\n}\r\n\r\n.calendar .full-calendar .fc-view-container .fc-view .fc-head .fc-row th.fc-sun {\r\n    color: #c90000;\r\n}\r\n\r\n.calendar .full-calendar .fc-view-container .fc-view .fc-head .fc-row th span {\r\n    font-size: .75rem;\r\n    line-height: 1.625rem;\r\n}\r\n\r\n.calendar .full-calendar .fc-view-container .fc-view .fc-body td {\r\n    position: relative;\r\n    border: none;\r\n}\r\n\r\n.calendar .full-calendar .fc-view-container .fc-view .fc-body .fc-day-grid-container {\r\n    height: auto !important;\r\n    overflow: hidden !important;\r\n}\r\n\r\n.calendar .full-calendar .fc-view-container .fc-view .fc-body .fc-day-grid {\r\n    border-bottom: .0625rem solid #ddd;\r\n}\r\n\r\n.calendar .full-calendar .fc-view-container .fc-view .fc-body .fc-row {\r\n    height: auto !important;\r\n    min-height: 5.25rem;\r\n    border-top: .0625rem solid #ddd;\r\n}\r\n\r\n.calendar .full-calendar .fc-view-container .fc-view .fc-body .fc-bg td.fc-today {\r\n    border-radius: .25rem;\r\n    background: none;\r\n}\r\n\r\n.calendar .full-calendar .fc-view-container .fc-view .fc-body .fc-bg td.fc-today:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    border-radius: inherit;\r\n    border: .125rem solid #94a3b8;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.calendar .full-calendar .fc-view-container .fc-view .fc-body .fc-content-skeleton thead td {\r\n    text-align: center;\r\n}\r\n\r\n.calendar .full-calendar .fc-view-container .fc-view .fc-body .fc-content-skeleton thead td.fc-sun {\r\n    color: #c90000;\r\n}\r\n\r\n.calendar .full-calendar .fc-view-container .fc-view .fc-body .fc-content-skeleton thead td span {\r\n    float: none;\r\n    font-size: .75rem;\r\n    font-weight: bold;\r\n}\r\n\r\n.calendar .full-calendar .fc-view-container .fc-view .fc-body .fc-content-skeleton thead td.fc-other-month span {\r\n    font-weight: normal;\r\n}\r\n\r\n.calendar .full-calendar .fc-view-container .fc-view .fc-body .fc-content-skeleton tbody td .fc-day-grid-event {\r\n    padding: 0 .125rem;\r\n    border-radius: .25rem;\r\n    line-height: 1.2;\r\n    cursor: pointer;\r\n}\r\n\r\n.calendar .full-calendar .fc-view-container .fc-view .fc-body .fc-content-skeleton tbody td .fc-day-grid-event .fc-content span {\r\n    font-size: .7rem;\r\n}\r\n\r\n/* calendar - modal */\r\n.scroll_lock {\r\n    overflow: hidden;\r\n}\r\n\r\n.calendar .modal {\r\n    right: 0;\r\n    bottom: 0;\r\n    width: auto;\r\n    height: auto;\r\n    margin: 0;\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n    z-index: 100000;\r\n}\r\n\r\n.calendar .modal .modal-dialog {\r\n    position: relative;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    transition: .3s;\r\n    width: 92%;\r\n    max-width: 26.25rem;\r\n    margin: 0 auto;\r\n    padding: .5rem 1.5rem;\r\n    border-radius: 1rem;\r\n    background: #fff;\r\n    overflow: hidden;\r\n}\r\n\r\n.calendar .modal .modal-dialog .modal-content {\r\n    margin: 0;\r\n    max-height: none;\r\n    box-shadow: none;\r\n    display: block;\r\n    overflow-x: hidden;\r\n}\r\n\r\n.calendar .modal .modal-header {\r\n    position: relative;\r\n    width: auto;\r\n    padding: 1rem 0.5rem;\r\n}\r\n\r\n.calendar .modal .modal-header h2 {\r\n    font-weight: bold;\r\n}\r\n\r\n.calendar .modal .modal-header button {\r\n    padding: 0;\r\n}\r\n\r\n.calendar .modal .modal-header button span,\r\n.modal .modal-header button svg {\r\n    width: 1.625rem;\r\n    height: 1.625rem;\r\n}\r\n\r\n.calendar .modal .modal-header button svg {\r\n    transform: rotate(45deg);\r\n}\r\n\r\n.calendar .modal .modal-body {\r\n    margin: 0;\r\n    padding: 1.5rem 0;\r\n}\r\n\r\n.calendar .modal .modal-body .tbl-grid {\r\n    width: 100%;\r\n}\r\n\r\n.calendar .modal .modal-body .tbl-grid th {\r\n    width: 45%;\r\n    padding: .125rem 1rem;\r\n    font-size: .8125rem;\r\n    font-weight: 500;\r\n    text-align: left;\r\n    color: #919599;\r\n}\r\n\r\n.calendar .modal .modal-body .tbl-grid td {\r\n    width: 55%;\r\n    padding: .125rem 1rem;\r\n    font-size: .875rem;\r\n    font-weight: 500;\r\n    text-align: right;\r\n}\r\n\r\n.calendar .modal .modal-body .tbl-grid tr.border-btm {\r\n    border-bottom: .0625rem dashed #ddd;\r\n}\r\n\r\n.calendar .modal .modal-body .tbl-grid tr.border-btm th,\r\n.calendar .modal .modal-body .tbl-grid tr.border-btm td {\r\n    padding-bottom: .75rem;\r\n}\r\n\r\n.calendar .modal .modal-body .tbl-grid tr.border-btm td {\r\n    font-weight: bold;\r\n}\r\n\r\n.calendar .modal .modal-body .tbl-grid tr.border-btm+tr th,\r\n.calendar .modal .modal-body .tbl-grid tr.border-btm+tr td {\r\n    padding-top: .75rem;\r\n}\r\n\r\n.calendar .modal .modal-body .tbl-grid tr:last-child th,\r\n.calendar .modal .modal-body .tbl-grid tr:last-child td {\r\n    font-size: .9375rem;\r\n    font-weight: bold;\r\n    color: #1e293b;\r\n}\r\n\r\n.calendar .modal .modal-footer {\r\n    padding: 1.5rem 0;\r\n    text-align: center;\r\n}\r\n\r\n.calendar .modal .modal-footer button {\r\n    width: 60%;\r\n    max-width: 10rem;\r\n}\r\n\r\n.calendar .show_modal {\r\n    opacity: 1;\r\n    visibility: visible;\r\n}\r\n\r\n.calendar .show_modal .modal-dialog {\r\n    top: 0;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n/*-------------------- Invitation page --------------------*/\r\n/* invitation - reset */\r\n.invitation .w-12 {\r\n    width: auto;\r\n}\r\n\r\n.invitation .mr-2,\r\n.invitation .mt-2,\r\n.invitation .mt-3,\r\n.invitation .mt-4,\r\n.invitation .mt-5 {\r\n    margin: 0;\r\n}\r\n\r\n.invitation .p-5 {\r\n    padding: 0;\r\n}\r\n\r\n.invitation .items-center {\r\n    align-items: stretch;\r\n}\r\n\r\n.invitation {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n    min-height: auto;\r\n    padding: 0 0 1rem;\r\n    border-radius: 1rem;\r\n}\r\n\r\n.invitation .content:before {\r\n    display: none;\r\n}\r\n\r\n.invitation .inner-wrap {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.invitation .tab-wrap {\r\n    position: relative;\r\n    width: 100%;\r\n    max-width: 33.75rem;\r\n    padding-top: .75rem;\r\n    border-bottom: .0625rem solid #d1d5d9;\r\n}\r\n\r\n.invitation .tab-wrap li {\r\n    display: inline-block;\r\n    position: relative;\r\n}\r\n\r\n.invitation .tab-wrap li:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: -.0625rem;\r\n    height: .1875rem;\r\n    background: #064e3b;\r\n    border-top-left-radius: .1875rem;\r\n    border-top-right-radius: .1875rem;\r\n    opacity: 0;\r\n}\r\n\r\n.invitation .tab-wrap li a {\r\n    display: block;\r\n    padding: 0 1rem;\r\n    font-size: .875rem;\r\n    font-weight: bold;\r\n    line-height: 3.25rem;\r\n    cursor: pointer;\r\n}\r\n\r\n.invitation .tab-wrap li.current:before {\r\n    opacity: 1;\r\n}\r\n\r\n.invitation .content-wrap {\r\n    width: 100%;\r\n    max-width: 33.75rem;\r\n    margin: 0 auto;\r\n    padding: 2rem 0 1rem;\r\n}\r\n\r\n.invitation .intro-y {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    width: calc(100% + 1rem);\r\n    margin-left: -.5rem;\r\n    background: #f0f4f8;\r\n    box-shadow: none;\r\n}\r\n\r\n.invitation .input {\r\n    width: 100%;\r\n    margin: 0 0 1rem;\r\n}\r\n\r\n.invitation .input>label {\r\n    display: inline-block;\r\n    margin-bottom: .375rem;\r\n    font-size: .8125rem;\r\n    font-weight: bold;\r\n}\r\n\r\n.invitation .input textarea {\r\n    height: 11.25rem;\r\n    resize: none;\r\n}\r\n\r\n.invitation .btn-wrap {\r\n    margin: 1.5rem 0 1rem;\r\n    text-align: center;\r\n}\r\n\r\n.invitation .btn-wrap button {\r\n    width: 60%;\r\n    max-width: 12.5rem;\r\n}\r\n\r\n/* invitation - invitationForm */\r\n.invitation .content-wrap .invitationForm {\r\n    display: none;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n.invitation .content-wrap .invitationForm.active {\r\n    display: block;\r\n}\r\n\r\n/* invitation - userInfo */\r\n.invitation .content-wrap .userInfo {\r\n    display: none;\r\n    width: 100%;\r\n    max-width: 33.75rem;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n.invitation .content-wrap .userInfo.active {\r\n    display: block;\r\n}\r\n\r\n.invitation .userInfo .admin-search-form {\r\n    position: relative;\r\n    padding: 1rem 1.25rem;\r\n    border-radius: .5rem;\r\n    box-shadow: 0 .25rem 1.25rem rgb(0 0 0 / 4%);\r\n    background: #fff;\r\n}\r\n\r\n.invitation .userInfo .admin-search-form:after {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    border-radius: inherit;\r\n    border: .0625rem solid #064e3b;\r\n    pointer-events: none;\r\n}\r\n\r\n.invitation .userInfo .search-wrap {\r\n    padding: 0;\r\n}\r\n\r\n.invitation .userInfo .search-wrap .input:nth-child(2) {\r\n    width: calc(100% - 6.25rem);\r\n}\r\n\r\n.invitation .userInfo .search-wrap .input:nth-child(2)+.btn-wrap {\r\n    position: absolute;\r\n    right: 1.25rem;\r\n    bottom: 1rem;\r\n    width: 5.5rem;\r\n    white-space: nowrap;\r\n}\r\n\r\n.invitation .userInfo .search-wrap .input:nth-child(2)+.btn-wrap .btn {\r\n    width: 100%;\r\n}\r\n\r\n.invitation .userInfo .merchant-send-list-box,\r\n.userInfo .merchant-search-list-box {\r\n    height: 2.375rem;\r\n}\r\n\r\n.invitation .userInfo .user-list {\r\n    margin-top: 2.25rem;\r\n}\r\n\r\n.invitation .userInfo .tabulator .tabulator-header {\r\n    border-width: 0;\r\n}\r\n\r\n.invitation .userInfo .tabulator .tabulator-tableHolder .tabulator-table {\r\n    width: 100%;\r\n    background: none;\r\n}\r\n\r\n.invitation .userInfo .tabulator .tabulator-row {\r\n    margin-bottom: 1.25rem;\r\n    border-radius: 0.75rem;\r\n    border-bottom-width: 0;\r\n    background: #fff;\r\n}\r\n\r\n.invitation .userInfo .tabulator .tabulator-row:hover {\r\n    background: #e2e8f0;\r\n}\r\n\r\n.invitation .userInfo .tabulator .tabulator-row .tabulator-cell {\r\n    height: auto;\r\n    font-weight: bold;\r\n}\r\n\r\n.invitation .userInfo .tabulator .tabulator-row .tabulator-responsive-collapse table {\r\n    width: 100%;\r\n}\r\n\r\n.invitation .userInfo .tabulator .tabulator-row .tabulator-responsive-collapse table tr td {\r\n    padding-top: .1875rem;\r\n    padding-bottom: .1875rem;\r\n    font-size: .8125rem;\r\n}\r\n\r\n.invitation .userInfo .tabulator .tabulator-row .tabulator-responsive-collapse table tr td:nth-child(1) {\r\n    font-weight: 500;\r\n    color: #a1a5a9;\r\n}\r\n\r\n.invitation .userInfo .tabulator .tabulator-row .tabulator-responsive-collapse table tr td:nth-child(2) {\r\n    font-weight: bold;\r\n    text-align: right;\r\n}\r\n\r\n.invitation .userInfo .tabulator .tabulator-footer .tabulator-paginator {\r\n    justify-content: center;\r\n    margin: 0;\r\n    text-align: center;\r\n}\r\n\r\n.invitation .userInfo .tabulator .tabulator-footer .tabulator-page.active {\r\n    background: #064e3b;\r\n    color: #fff;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n/*-------------------- Admin page --------------------*/\r\n/* Admin - modal */\r\n#admin-modal #merchant-list-wrap {}\r\n\r\n#admin-modal #merchant-list-wrap label {\r\n    margin-bottom: 0;\r\n}\r\n\r\n#admin-modal #merchant-list-wrap .merchant-list-box {\r\n    width: auto;\r\n    height: 2.375rem;\r\n    cursor: pointer\r\n}\r\n\r\n#admin-modal #merchant-list-wrap .merchant-list-box #merchant-list {\r\n    height: 100%;\r\n}\r\n\r\n#admin-modal #merchant-list-wrap .btn-group>button {\r\n    height: auto;\r\n    line-height: 1.375rem;\r\n}\r\n\r\n/*-------------------- MultiSelect Custom 2022.11.29--------------------*/\r\n\r\n.multiselect__wrapper {}\r\n\r\n.multiselect__wrapper>span {\r\n    display: inline-flex;\r\n    -webkit-box-align: center;\r\n    -webkit-box-pack: center;\r\n    align-items: center;\r\n    justify-content: center;\r\n    column-gap: .25rem;\r\n    position: relative;\r\n    height: 1.875rem;\r\n    margin: .3125rem .3125rem 0 0;\r\n    padding: 0 .625rem;\r\n    border-radius: 1.875rem;\r\n    font-size: .8125rem;\r\n    letter-spacing: -.02rem;\r\n}\r\n\r\n.multiselect__wrapper>span::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    border-radius: inherit;\r\n    border: .0625rem solid transparent;\r\n    pointer-events: none;\r\n}\r\n\r\n.multiselect__wrapper .multiselect__input {}\r\n\r\n.multiselect__wrapper .multiselect__clear-btn {\r\n    border-radius: .375rem;\r\n    background: #e7e7e7;\r\n    color: #424242;\r\n}\r\n\r\n.multiselect__wrapper .multiselect__clear-btn::before {\r\n    content: \"전체삭제\";\r\n}\r\n\r\n.multiselect__wrapper .multiselect__clear-btn svg {\r\n    width: 1rem;\r\n    height: 1rem;\r\n    color: #1b293b;\r\n}\r\n\r\n.multiselect__wrapper .multiselect__selected {\r\n    background: rgba(7, 79, 60, .08);\r\n    color: #074f3c;\r\n}\r\n\r\n.multiselect__wrapper .multiselect__selected::after {\r\n    border-color: rgba(7, 79, 60, .7);\r\n}\r\n\r\n.multiselect__wrapper .multiselect__remove-btn {\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 1.125rem;\r\n    height: 1.125rem;\r\n    margin: 0 -.125rem 0 0;\r\n    border-radius: 50%;\r\n    background: rgba(7, 79, 60, .4);\r\n}\r\n\r\n.multiselect__wrapper .multiselect__remove-btn svg {\r\n    width: .75rem;\r\n    height: .75rem;\r\n    color: #fff;\r\n}\r\n\r\n\r\n/*-------------------- Login alert box --------------------*/\r\n.login_alert_box {\r\n    display: none;\r\n    position: fixed;\r\n    left: 50%;\r\n    bottom: 3.125rem;\r\n    transform: translateX(-50%);\r\n    width: 80%;\r\n    max-width: 20rem;\r\n    margin: 0;\r\n    padding: 0 1.75rem;\r\n    border-radius: 3.25rem;\r\n    background: rgba(0, 0, 0, .8);\r\n    z-index: 9999;\r\n    cursor: pointer;\r\n    animation: scrolldown 0.7s ease-in infinite alternate;\r\n}\r\n\r\n.login_alert_box span {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    height: 3.25rem;\r\n    font-size: .9375rem;\r\n    font-weight: 500;\r\n    line-height: 3.25rem;\r\n    color: #fff;\r\n}\r\n\r\n.login_alert_box span::after {\r\n    content: \"연장\";\r\n    font-weight: bold;\r\n    color: #cce568;\r\n}\r\n\r\n.login_alert_box.after span::after {\r\n    content: \"확인\";\r\n}\r\n\r\n@keyframes scrolldown {\r\n    0% {\r\n        margin: 0;\r\n    }\r\n\r\n    100% {\r\n        margin: 0 0 .1875rem;\r\n    }\r\n}\r\n\r\n.agent_panel {\r\n    display: block;\r\n}\r\n\r\n.agent_panel-1 {\r\n    width: 100%;\r\n}\r\n\r\n.agent_panel-2 {\r\n    width: 100%;\r\n    flex-direction: row !important;\r\n}\r\n\r\n\r\n\r\n\r\n/**========================= [[ 640px 이상 ]] =========================**/\r\n@media(min-width:640px) {\r\n\r\n    .top-bar-boxed {\r\n        display: block;\r\n    }\r\n\r\n    .content {\r\n        margin-top: 0rem;\r\n    }\r\n\r\n    /*리스트 영역*/\r\n    .merchant-search-list-box .dropdown-menu {\r\n        width: 24rem;\r\n    }\r\n\r\n\r\n    /*-------------------- Header --------------------*/\r\n    .mobile-menu .main_logo {\r\n        width: auto;\r\n    }\r\n\r\n    .header_wrap {\r\n        justify-content: space-between;\r\n    }\r\n\r\n    .header_wrap .header_left,\r\n    .header_wrap .header_right {\r\n        display: flex;\r\n        align-items: center;\r\n    }\r\n\r\n    .header_wrap .header_left {}\r\n\r\n    .header_wrap .header_right {\r\n        gap: 1.25rem;\r\n    }\r\n\r\n    .header_wrap .logo {\r\n        width: 2.5rem;\r\n        left: .75rem;\r\n        margin-right: .125rem;\r\n        overflow: hidden;\r\n    }\r\n\r\n    .header_wrap .logo img {\r\n        width: auto;\r\n        max-width: none;\r\n        height: 1.625rem;\r\n    }\r\n\r\n    .header_wrap .user_info_wrap {\r\n        display: flex;\r\n        flex-direction: column;\r\n    }\r\n\r\n    .header_wrap .user_name {\r\n        display: flex;\r\n        align-items: center;\r\n        gap: .375rem;\r\n        margin-bottom: -.0625rem;\r\n    }\r\n\r\n    .header_wrap .user_name p {\r\n        font-weight: 500;\r\n        color: #fff;\r\n    }\r\n\r\n    .header_wrap .user_name p::after {\r\n        content: \"님\";\r\n        opacity: rgba(255, 255, 255, .8);\r\n    }\r\n\r\n    .header_wrap .user_name span {\r\n        position: relative;\r\n        top: -.0625rem;\r\n        padding: .125rem .375rem 0 .375rem;\r\n        border-radius: 1.125rem;\r\n        background: #434242;\r\n        font-size: .6875rem;\r\n        line-height: 1.125rem;\r\n        color: #fff;\r\n    }\r\n\r\n    .header_wrap .user_organization {\r\n        font-size: .75rem;\r\n        color: rgba(255, 255, 255, .8);\r\n    }\r\n\r\n    .header_wrap .login_session_box {\r\n        display: flex;\r\n        align-items: center;\r\n        gap: .75rem;\r\n    }\r\n\r\n    .header_wrap .login_session_box .timer_wrap {\r\n        display: flex;\r\n        align-items: center;\r\n        gap: .375rem;\r\n    }\r\n\r\n    .header_wrap .login_session_box .timer_wrap i {}\r\n\r\n    .header_wrap .login_session_box .timer_wrap svg {\r\n        position: relative;\r\n        top: -.0625rem;\r\n        width: 1rem;\r\n        height: 1rem;\r\n        color: #fff;\r\n    }\r\n\r\n    .header_wrap .login_session_box .timer_wrap .timer {\r\n        color: #fff;\r\n    }\r\n\r\n    .header_wrap .login_session_box .button_wrap {\r\n        display: flex;\r\n        border-radius: .25rem;\r\n        border: .0625rem solid rgba(255, 255, 255, .6);\r\n    }\r\n\r\n    .header_wrap .login_session_box .button_wrap button {\r\n        margin: 0;\r\n        padding: 0 .625rem;\r\n        border-radius: 0;\r\n        background: rgba(255, 255, 255, .2);\r\n        font-size: .75rem;\r\n        line-height: 1.625rem;\r\n        color: #fff;\r\n    }\r\n\r\n    .header_wrap .login_session_box .button_wrap button+button {\r\n        border-left: .0625rem solid rgba(255, 255, 255, .6);\r\n        background: none;\r\n    }\n\n    .top-bar-boxed[data-light-tenant-header=\"true\"] {\n        background: #d9dee3 !important;\n        border-bottom: 1px solid #c3cbd3 !important;\n    }\n\n    .top-bar-boxed[data-light-tenant-header=\"true\"] .header_wrap .logo {\n        width: 5.25rem;\n        height: 100%;\n        left: 0;\n        overflow: visible;\n        display: flex;\n        align-items: center;\n    }\n\n    .top-bar-boxed[data-light-tenant-header=\"true\"] .header_wrap .logo img {\n        width: auto;\n        max-width: 5.25rem;\n        height: 2.25rem;\n        object-fit: contain;\n    }\n\n    .top-bar-boxed[data-light-tenant-header=\"true\"] .header_wrap .user_name p {\n        color: #334155;\n    }\n\n    .top-bar-boxed[data-light-tenant-header=\"true\"] .header_wrap .user_name span {\n        background: #dbe1e8;\n        color: #334155;\n    }\n\n    .top-bar-boxed[data-light-tenant-header=\"true\"] .header_wrap .login_session_box .button_wrap {\n        border-color: #cbd5e1;\n    }\n\n    .top-bar-boxed[data-light-tenant-header=\"true\"] .header_wrap .login_session_box .button_wrap button {\n        background: #fff;\n        color: #475569;\n    }\n\n    .top-bar-boxed[data-light-tenant-header=\"true\"] .header_wrap .login_session_box .button_wrap button+button {\n        border-left-color: #cbd5e1;\n        background: #f8fafc;\n    }\r\n\r\n\r\n\r\n\r\n    /*-------------------- Dashboard page --------------------*/\r\n\r\n    .dashboard .sales .panel ul {\r\n        flex-grow: 1;\r\n        flex-basis: 50%;\r\n    }\r\n\r\n    .dashboard .sales .panel ul+ul {\r\n        margin: 0;\r\n    }\r\n\r\n    .dashboard .sales .panel li+li .calc-title {\r\n        /* padding-left: .5rem; */\r\n    }\r\n\r\n    .dashboard .sales .panel li+li .calc-title::before {\r\n        /* content: \"\";\r\n        position: absolute;\r\n        top: 50%;\r\n        left: 0;\r\n        transform: translateY(-50%);\r\n        width: .1875rem;\r\n        height: .1875rem;\r\n        border-radius: 50%;\r\n        background: #64748b; */\r\n    }\r\n\r\n\r\n\r\n\r\n\r\n    /*-------------------- Payment page --------------------*/\r\n    .payment {\r\n        padding: 0 1rem;\r\n    }\r\n\r\n\r\n\r\n\r\n\r\n    /*-------------------- Calendar page --------------------*/\r\n    .calendar {\r\n        padding: 1rem;\r\n    }\r\n\r\n    .calendar .main-title-wrap .title {\r\n        font-size: 1rem;\r\n    }\r\n\r\n    .calendar .content-wrap .content-col {\r\n        padding: 2rem 0;\r\n    }\r\n\r\n    .calendar .content-wrap .title-wrap .title {\r\n        font-size: 1rem;\r\n    }\r\n\r\n    /* calendar - chat box */\r\n    .calendar .chat__box .title-wrap {\r\n        padding: 1.25rem 1.75rem 1rem;\r\n    }\r\n\r\n    .calendar .chat__box .title-wrap .thumb {\r\n        width: 2rem;\r\n        height: 2rem;\r\n    }\r\n\r\n    .calendar .chat__box .title-wrap .name {\r\n        margin-left: .625rem;\r\n    }\r\n\r\n    .calendar .chat__box .title-wrap .name h3 {\r\n        font-size: .9375rem;\r\n    }\r\n\r\n    .calendar .chat__box .title-wrap .btn-notice {\r\n        right: 1.75rem;\r\n    }\r\n\r\n    .calendar .chat__box .title-wrap .btn-notice button {\r\n        height: 2rem;\r\n        padding: 0 .875rem;\r\n    }\r\n\r\n    .calendar .chat__box .notice-wrap {\r\n        padding: .75rem 1.75rem;\r\n    }\r\n\r\n    .calendar .chat__box .notice-wrap span {\r\n        font-size: .9375rem;\r\n    }\r\n\r\n    .calendar .chat__box .chat-container {\r\n        max-height: 37.5rem;\r\n        padding: 1.25rem 1.75rem 0;\r\n    }\r\n\r\n    .calendar .chat__box .message-wrap input {\r\n        height: 3.5rem;\r\n        padding-left: 1.75rem;\r\n        padding-right: 1.75rem;\r\n    }\r\n\r\n    .calendar .chat__box .message-wrap a {\r\n        width: 3.5rem;\r\n        height: 3.5rem;\r\n    }\r\n\r\n    .calendar .chat__box .message-wrap a svg {\r\n        width: 1.375rem;\r\n        height: 1.375rem;\r\n        margin-left: -.125rem;\r\n    }\r\n\r\n    /* calendar - calendar */\r\n    .calendar .calendar-category-wrap {\r\n        position: absolute;\r\n        top: 27px;\r\n        right: 1.5rem;\r\n        margin: 0;\r\n        z-index: 1;\r\n    }\r\n\r\n    .calendar .calendar-category-wrap span {\r\n        width: .75rem;\r\n        height: .75rem;\r\n        vertical-align: -.0625rem;\r\n    }\r\n\r\n    .calendar .calendar-category-wrap p {\r\n        margin-left: .25rem;\r\n        font-size: .8125rem;\r\n    }\r\n\r\n    .calendar .full-calendar .fc-header-toolbar {\r\n        margin-bottom: 1.75rem;\r\n    }\r\n\r\n    .calendar .full-calendar .fc-header-toolbar .fc-left {\r\n        width: 8rem;\r\n    }\r\n\r\n    .calendar .full-calendar .fc-header-toolbar .fc-left h2 {\r\n        font-size: 1.0625rem;\r\n    }\r\n\r\n    .calendar .full-calendar .fc-header-toolbar .fc-right .fc-today-button {\r\n        height: 2rem;\r\n        padding: 0 1rem;\r\n        line-height: 2rem;\r\n    }\r\n\r\n    .calendar .full-calendar .fc-header-toolbar .fc-right .fc-button-group {\r\n        width: 12.5rem;\r\n    }\r\n\r\n    .calendar .full-calendar .fc-header-toolbar .fc-right .fc-button-group button span {\r\n        font-size: 1rem;\r\n    }\r\n\r\n    .calendar .full-calendar .fc-view-container .fc-view .fc-body .fc-content-skeleton thead td.fc-today span {\r\n        padding: .125rem .375rem;\r\n        border-bottom-left-radius: .25rem;\r\n        border-bottom-right-radius: .25rem;\r\n        background: #94a3b8;\r\n        color: #fff;\r\n    }\r\n\r\n\r\n\r\n\r\n\r\n    /*-------------------- Invitation page --------------------*/\r\n    /* invitation - reset */\r\n    .invitation .input {\r\n        flex-direction: column;\r\n    }\r\n\r\n    /* invitation - userInfo */\r\n    .invitation .userInfo .search-wrap {\r\n        width: calc(100% + 1rem);\r\n        margin-left: -.5rem;\r\n    }\r\n\r\n    .invitation .userInfo .search-wrap .input {\r\n        margin: 0 .5rem 1rem;\r\n    }\r\n\r\n    .invitation .userInfo .search-wrap .input:nth-child(2),\r\n    .userInfo .search-wrap .input:nth-child(2) input {\r\n        width: 100%;\r\n    }\r\n\r\n    .invitation .userInfo .search-wrap .input:nth-child(2)+.btn-wrap {\r\n        position: relative;\r\n        right: auto;\r\n        bottom: auto;\r\n        margin: 0 .5rem 1rem;\r\n    }\r\n\r\n    .invitation .userInfo .search-wrap .input:nth-child(2)+.btn-wrap .btn {\r\n        padding-left: 1.25rem;\r\n        padding-right: 1.25rem;\r\n    }\r\n\r\n\r\n\r\n\r\n    /*-------------------- Tabulator --------------------*/\r\n    .tabulator-row .tabulator-cell {\r\n        /* height: 2.75rem !important; */\r\n    }\r\n\r\n    .form_filter {\r\n        /* padding: 1.25rem 1.5rem 1.5rem; */\r\n        padding: 0.5rem 1rem;\r\n    }\r\n\r\n    .form_filter::after {}\r\n\r\n    .form_filter form {\r\n        display: flex;\r\n        align-items: flex-start;\r\n        flex-wrap: wrap;\r\n        gap: 1rem 1.25rem;\r\n    }\r\n\r\n    .form_filter .input_row {\r\n        /* flex-grow: 1; */\r\n    }\r\n\r\n    .form_filter .input_row+.input_row {\r\n        margin: 0;\r\n    }\r\n\r\n    .form_filter .input_row label {\r\n        margin-bottom: .25rem;\r\n    }\r\n\r\n    .form_filter .input_wrap {}\r\n\r\n    .form_filter .input_item {}\r\n\r\n    .form_filter .input_item input {}\r\n\r\n    .form_filter .input_item select {}\r\n\r\n    .form_filter .input_item .sorting {\r\n        position: absolute;\r\n        top: 0;\r\n        right: 0;\r\n        margin-top: -.25rem;\r\n    }\r\n\r\n    .form_filter .input_item .sorting.d_none {\r\n        display: flex;\r\n    }\r\n\r\n    .form_filter .input_item .sorting button {\r\n        height: 1.5rem;\r\n        padding: 0 .625rem;\r\n        font-size: .75rem;\r\n    }\r\n\r\n    .form_filter .input_item .sorting button+button {}\r\n\r\n    .form_filter .input_item .sorting button:first-child {}\r\n\r\n    .form_filter .input_item .sorting button:last-child {}\r\n\r\n    .form_filter .input_item .sorting button:focus {}\r\n\r\n    .form_filter .input_item .datepicker {\r\n        width: 100%;\r\n        min-width: 12.5rem;\r\n    }\r\n\r\n    .form_filter .input_row.flex {\r\n        display: block;\r\n    }\r\n\r\n    .form_filter .input_row.flex label {\r\n        margin-bottom: .25rem;\r\n        line-height: inherit;\r\n    }\r\n\r\n    .form_filter .input_row.flex .input_wrap {}\r\n\r\n    .form_filter .input_item.flex {}\r\n\r\n    .form_filter .input_item.flex select {}\r\n\r\n    .form_filter .input_item.flex input {}\r\n\r\n    .form_filter .button_wrap {\r\n        flex-grow: 1;\r\n        margin-top: 1.5rem;\r\n        margin-left: auto;\r\n        margin-right: auto;\r\n    }\r\n\r\n    .form_filter .button_wrap button {\r\n        max-width: 15rem;\r\n    }\r\n\r\n    .form_filter .more_wrap {\r\n        display: none;\r\n    }\r\n\r\n    .form_filter .more_wrap button {}\r\n\r\n    .form_filter .more_wrap svg {}\r\n\r\n    .form_filter .more_wrap span {}\r\n\r\n    .form_filter .more_wrap.short svg {}\r\n\r\n    .form_filter .d_none {\r\n        display: block;\r\n    }\r\n\r\n    .tabulator_summary_wrap {\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n        column-gap: .875rem;\r\n    }\r\n\r\n    .tabulator_summary_wrap .input_wrap {\r\n        /* flex-direction: column; */\r\n        flex-basis: 30%;\r\n        flex-grow: 1;\r\n        padding: .5rem;\r\n        /* padding: .5rem 0; */\r\n    }\r\n\r\n    .tabulator_summary_wrap .input_wrap+.input_wrap {\r\n        margin: 0;\r\n    }\r\n\r\n    .tabulator_summary_wrap .input_wrap input {\r\n        padding: .125rem 0 0;\r\n        font-size: .9375rem;\r\n        text-align: center;\r\n    }\r\n\r\n    .tabulator_summary_wrap .input_wrap.d_none {\r\n        display: flex;\r\n    }\r\n\r\n    .tabulator_summary_wrap .btn_more {\r\n        display: none;\r\n    }\r\n\r\n    .tabulator_summary_wrap .btn_more svg {}\r\n\r\n    .tabulator_summary_wrap .btn_more.active {}\r\n\r\n    .tabulator_summary_wrap .btn_more.active svg {}\r\n\r\n    .tabulator_summary_wrap .tabulator_total_cnt_wrap {\r\n        width: 100%;\r\n    }\r\n\r\n    .tabulator_summary_wrap .d_none {}\r\n\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n/**========================= [[ 768px 이상 ]] =========================**/\r\n@media(min-width:768px) {\r\n\r\n    .content {\r\n        height: 100dvh;\r\n        margin-top: 0;\r\n        padding-top: 3.625rem !important;\r\n        padding-bottom: 40px;\r\n        overflow-y: auto;\r\n    }\r\n\r\n\r\n    /*-------------------- Header --------------------*/\r\n    .top-bar-boxed {\r\n        position: fixed;\r\n        top: 0;\r\n        left: 0;\r\n        right: 0;\r\n        height: auto;\r\n        padding: .375rem 1.25rem;\r\n        /* padding: .375rem 1.375rem; */\r\n        background: #000000;\r\n    }\r\n\r\n    .top-bar-boxed::before,\r\n    .top-bar-boxed::after {\r\n        display: none;\r\n    }\r\n\r\n    .top-bar-boxed .logo {\r\n        width: 61px;\r\n        /* width: auto; */\r\n        /* height: 30px; */\r\n        left: 0;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        /* width: 2.5rem; */\r\n        /* left: .75rem; */\r\n        /* margin-right: .125rem; */\r\n        overflow: hidden;\r\n    }\r\n\r\n    .top-bar-boxed .logo img {\r\n        width: auto;\r\n        max-width: none;\r\n        height: 2rem;\r\n    }\r\n\r\n\r\n\r\n    /*-------------------- Login alert box --------------------*/\r\n    .login_alert_box {\r\n        left: auto;\r\n        right: 1.375rem;\r\n        transform: none;\r\n    }\r\n\r\n\r\n\r\n    /*-------------------- Side nav --------------------*/\r\n    .side-nav {\r\n        width: 13rem;\r\n        height: 100dvh;\r\n        padding: 5rem .75rem 4rem;\r\n        overflow-y: auto;\r\n    }\r\n\r\n    .side-nav .side-menu .side-menu__title {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        position: relative;\r\n        transform: none;\r\n        left: 0;\r\n        width: 100%;\r\n        padding-left: .5rem;\r\n        box-shadow: none;\r\n        border-radius: 0;\r\n        background: none;\r\n        opacity: 1;\r\n        visibility: visible;\r\n    }\r\n\r\n    .side-nav .side-menu .side-menu__title::before {\r\n        display: none;\r\n    }\r\n\r\n    .side-nav .side-menu .side-menu__icon svg {\r\n        width: 1.25rem;\r\n        height: 1.25rem;\r\n    }\r\n\r\n    .side-nav>ul>li>.side-menu {\r\n        padding-left: 0.75rem;\r\n    }\r\n\r\n    .side-nav ul li .depth-2 {\r\n        margin-left: 0;\r\n        margin-bottom: .25rem;\r\n        padding: .125rem 0;\r\n    }\r\n\r\n    .side-nav ul li .depth-2 li+li {\r\n        margin-top: .125rem;\r\n    }\r\n\r\n    .side-nav ul li .depth-2 li a {\r\n        height: 2.5rem;\r\n        margin: 0;\r\n        padding-left: 0.75rem;\r\n    }\r\n\r\n    .side-nav ul li .depth-2 .side-menu__icon svg {\r\n        width: 1.125rem;\r\n        height: 1.125rem;\r\n    }\r\n\r\n    .side-nav ul li .depth-2 .side-menu__title {\r\n        min-width: 0;\r\n        white-space: nowrap;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n    }\r\n\r\n    .side-nav ul li .depth-2 .side-menu__title>span {\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n    }\r\n\r\n    .side-nav ul li .depth-2 .side-menu__title::before {\r\n        content: \"\";\r\n    }\r\n\r\n    .side-nav ul li .depth-2 li.depth-2-divider {\r\n        height: 1px;\r\n        margin: 0.5rem 0.75rem;\r\n        background-color: rgba(0, 0, 0, 0.1);\r\n        border: none;\r\n        list-style: none;\r\n        padding: 0;\r\n    }\r\n\r\n\r\n    /*-------------------- Modal --------------------*/\r\n    .modal .modal-dialog {\r\n        transform: translateY(-50%);\r\n        margin: auto;\r\n        padding: 1rem 2rem;\r\n    }\r\n\r\n    .show_modal .modal-dialog {\r\n        top: 50%;\r\n    }\r\n\r\n\r\n\r\n\r\n\r\n    /*-------------------- Payment page --------------------*/\r\n    .payment {\r\n        padding-top: 1.5rem;\r\n    }\r\n\r\n    .payment .tab-wrap {\r\n        padding-top: 1.5rem;\r\n    }\r\n\r\n    .payment .tab-wrap li a {\r\n        font-size: .9375rem;\r\n    }\r\n\r\n\r\n\r\n\r\n\r\n    /*-------------------- Calendar page --------------------*/\r\n    .calendar {\r\n        padding-top: 1.5rem;\r\n    }\r\n\r\n    /* calendar - calendar */\r\n    .calendar .full-calendar .fc-view-container .fc-view .fc-body .fc-row {\r\n        min-height: 6rem;\r\n    }\r\n\r\n    .calendar .full-calendar .fc-view-container .fc-view .fc-head .fc-row th span {\r\n        font-size: .8125rem;\r\n        line-height: 2rem;\r\n    }\r\n\r\n    .calendar .full-calendar .fc-view-container .fc-view .fc-body .fc-content-skeleton thead td span {\r\n        display: inline-block;\r\n        font-size: .8125rem;\r\n    }\r\n\r\n    .calendar .full-calendar .fc-view-container .fc-view .fc-body .fc-content-skeleton tbody td .fc-day-grid-event {\r\n        margin-top: .1875rem;\r\n    }\r\n\r\n    .calendar .full-calendar .fc-view-container .fc-view .fc-body .fc-content-skeleton tbody td .fc-day-grid-event .fc-content span {\r\n        font-size: .75rem;\r\n    }\r\n\r\n    /* calendar - modal */\r\n    .calendar .modal .modal-dialog {\r\n        transform: translateY(-50%);\r\n        margin: auto;\r\n        padding: 1rem 2rem;\r\n    }\r\n\r\n    .calendar .show_modal .modal-dialog {\r\n        top: 50%;\r\n    }\r\n\r\n    /* calendar - calendar */\r\n    .calendar .calendar-category-wrap {\r\n        top: 25px;\r\n    }\r\n\r\n\r\n\r\n    /*-------------------- Invitation page --------------------*/\r\n    /* invitation - reset */\r\n    .invitation {\r\n        padding-top: 1.5rem;\r\n    }\r\n\r\n    .invitation .tab-wrap {\r\n        /*padding-top: 1.5rem;*/\r\n    }\r\n\r\n    .invitation .tab-wrap li a {\r\n        font-size: .9375rem;\r\n    }\r\n\r\n\r\n\r\n\r\n\r\n    /*-------------------- Dashboard page --------------------*/\r\n    .dashboard.inner-wrap {\r\n        /* padding-top: 1rem; */\r\n    }\r\n\r\n    .dashboard .main-title-wrap .title,\r\n    .dashboard .branchList .box>div:nth-child(1) div {\r\n        font-size: .9375rem;\r\n    }\r\n\r\n    .dashboard .panel {\r\n        margin: 1rem 0;\r\n        flex-direction: row !important;\r\n    }\r\n\r\n    .dashboard .calc-table {\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n        width: calc(100% + 1rem);\r\n        margin-left: -.5rem;\r\n    }\r\n\r\n    .dashboard .calc-table li {\r\n        width: calc(50% - 1rem);\r\n        margin: 0 .5rem 1rem;\r\n        padding: 1.25rem 1.5rem;\r\n    }\r\n\r\n    .dashboard .calc-table li+li {\r\n        margin-top: 0;\r\n    }\r\n\r\n    .dashboard .calc-table li .calc-title,\r\n    .dashboard .calc-table li .calc-cnt {\r\n        font-size: .875rem;\r\n    }\r\n\r\n    .dashboard .calc-table li progress {\r\n        margin-bottom: 0;\r\n    }\r\n\r\n    .dashboard .dailyStatsChart,\r\n    .dashboard .monthlyStatsChart {\r\n        position: relative;\r\n        height: 22rem;\r\n        padding: 1rem 1rem;\r\n        border-radius: .5rem;\r\n        box-shadow: 0 .25rem .5rem rgb(0 0 0 / 4%);\r\n        background: #fff;\r\n        overflow: hidden;\r\n    }\r\n\r\n    .dashboard .dailyStatsChart:before,\r\n    .dashboard .monthlyStatsChart:before {\r\n        content: \"\";\r\n        position: absolute;\r\n        top: 0;\r\n        left: 0;\r\n        right: 0;\r\n        bottom: 0;\r\n        border-radius: inherit;\r\n        border: .0625rem solid rgb(0 0 0 / 8%);\r\n        pointer-events: none;\r\n    }\r\n\r\n    .dashboard .branchList>div+div,\r\n    .dashboard .notice-wrap>div+div {\r\n        margin-top: 1rem;\r\n    }\r\n\r\n    .dashboard .branchList .box {\r\n        min-height: 5rem;\r\n        padding: 1.25rem 1.5rem;\r\n    }\r\n\r\n    .dashboard .branchList .box>div:nth-child(2) {\r\n        padding: .5rem 1rem;\r\n        font-size: .875rem;\r\n    }\r\n\r\n    .dashboard .branchList .box>div span {\r\n        margin-right: .875rem;\r\n    }\r\n\r\n    .dashboard .notice-wrap>div {\r\n        padding: 1.5rem;\r\n    }\r\n\r\n    .dashboard .notice-wrap .text-base {\r\n        margin-bottom: .75rem;\r\n    }\r\n\r\n    .dashboard .notice-wrap .text-slate-500 {\r\n        line-height: 1.6;\r\n    }\r\n\r\n\r\n\r\n\r\n    /*-------------------- Tabulator --------------------*/\r\n    .form_filter {}\r\n\r\n    .form_filter::after {}\r\n\r\n    .form_filter form {}\r\n\r\n    .form_filter .input_row {}\r\n\r\n    .form_filter .input_row+.input_row {}\r\n\r\n    .form_filter .input_row label {}\r\n\r\n    .form_filter .input_wrap {}\r\n\r\n    .form_filter .input_item {}\r\n\r\n    .form_filter .input_item input {}\r\n\r\n    .form_filter .input_item select {}\r\n\r\n    .form_filter .input_item .datepicker {}\r\n\r\n    .form_filter .input_row.flex {}\r\n\r\n    .form_filter .input_row.flex label {}\r\n\r\n    .form_filter .input_row.flex .input_wrap {}\r\n\r\n    .form_filter .input_item.flex {}\r\n\r\n    .form_filter .input_item.flex select {}\r\n\r\n    .form_filter .input_item.flex input {}\r\n\r\n    .form_filter .button_wrap {}\r\n\r\n    .form_filter .button_wrap button {}\r\n\r\n    .tabulator_sorting_wrap {}\r\n\r\n    .tabulator_sorting_wrap .excel_download {}\r\n\r\n    .tabulator_sorting_wrap .excel_download button {}\r\n\r\n    .tabulator_sorting_wrap .excel_download button:hover {}\r\n\r\n    .tabulator_sorting_wrap .excel_download button svg {}\r\n\r\n    .tabulator_sorting_wrap .rows_per_page {}\r\n\r\n    .tabulator_sorting_wrap .rows_per_page select {}\r\n\r\n    .tabulator_summary_wrap {}\r\n\r\n    .tabulator_summary_wrap .input_wrap {}\r\n\r\n    .tabulator_summary_wrap .input_wrap label {}\r\n\r\n    .tabulator_summary_wrap .input_wrap input {\r\n        padding-top: .25rem;\r\n        font-size: 1rem;\r\n        text-align: center;\r\n    }\r\n\r\n    .tabulator_total_cnt_wrap {\r\n        margin: .1875rem 0 0;\r\n        padding-left: 2rem;\r\n    }\r\n\r\n    .tabulator_total_cnt_wrap input {\r\n        font-size: .9375rem\r\n    }\r\n\r\n    .tabulator_total_cnt_wrap input:focus {}\r\n\r\n    .tabulator_summary_wrap .tabulator_total_cnt_wrap {\r\n        margin-top: .5rem;\r\n        padding: 0;\r\n    }\r\n\r\n    .form_filter.outer {\r\n        padding: 1rem 0 0;\r\n        background: none;\r\n    }\r\n\r\n    .form_filter.outer .input_row {\r\n        max-width: 21.875rem;\r\n    }\r\n\r\n    .form_filter.outer .input_row label {\r\n        display: none;\r\n    }\r\n\r\n    .form_filter.outer .button_wrap {\r\n        margin-top: 0;\r\n    }\r\n\r\n    .form_filter.outer::after {\r\n        display: none;\r\n    }\r\n\r\n    .form_filter+.box {\r\n        /* margin-top: 1.25rem; */\r\n        margin-top: .5rem;\r\n    }\r\n\r\n    .dashboard .sales .panel ul li {\r\n        display: flex;\r\n        /* flex-direction: column; */\r\n        position: relative;\r\n        padding: 1rem .75rem;\r\n        /* box-shadow: 0 .25rem .5rem rgba(0, 0, 0, .04); */\r\n        background: #fff;\r\n        align-items: stretch;\r\n        justify-content: space-between;\r\n    }\r\n\r\n    .dashboard .sales .panel ul li .calc-title {\r\n        display: block;\r\n        position: relative;\r\n        /* margin-bottom: .375rem; */\r\n        color: #64748b;\r\n        /* width: 100%; */\r\n    }\r\n\r\n    .agent_panel {\r\n        display: flex;\r\n        gap: 1rem;\r\n    }\r\n\r\n    .agent_panel-1 {\r\n        width: 50%;\r\n    }\r\n\r\n    .agent_panel-2 {\r\n        width: 50%;\r\n    }\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n/**========================= [[ 1280px 이상 ]] =========================**/\r\n@media(min-width:1280px) {\r\n    body {\r\n        /* overflow-y: hidden; */\r\n    }\r\n\r\n\r\n\r\n    /*-------------------- Header --------------------*/\r\n    .top-bar-boxed {\r\n        padding: .375rem 0.75rem;\r\n    }\r\n\r\n    .top-bar-boxed .logo {\r\n        left: 0;\r\n        width: 165px;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        /* width: auto; */\r\n        /* margin-right: .375rem; */\r\n    }\r\n\r\n    .top-bar-boxed .logo img {\r\n        height: 2.5rem;\r\n    }\r\n\r\n    .header_wrap {}\r\n\r\n    .header_wrap .header_left,\r\n    .header_wrap .header_right {}\r\n\r\n    .header_wrap .header_left {}\r\n\r\n    .header_wrap .header_right {}\r\n\r\n    .header_wrap .logo {}\r\n\r\n    .header_wrap .logo img {}\r\n\r\n    .header_wrap .user_info_wrap {\r\n        flex-direction: row;\r\n        gap: 1rem;\r\n    }\r\n\r\n    .header_wrap .user_info_wrap::after {\r\n        content: \"\";\r\n        margin-left: .5rem;\r\n        border-left: .0625rem solid rgba(255, 255, 255, .4);\r\n    }\r\n\r\n    .header_wrap .user_name {\r\n        margin: 0;\r\n    }\r\n\r\n    .header_wrap .user_name p {}\r\n\r\n    .header_wrap .user_name p::after {}\r\n\r\n    .header_wrap .user_name span {}\r\n\r\n    .header_wrap .user_organization {\r\n        font-size: .8125rem;\r\n    }\r\n\r\n    .header_wrap .login_session_box {}\r\n\r\n    .header_wrap .login_session_box .timer_wrap {}\r\n\r\n    .header_wrap .login_session_box .timer_wrap i {}\r\n\r\n    .header_wrap .login_session_box .timer_wrap svg {}\r\n\r\n    .header_wrap .login_session_box .timer_wrap .timer {}\r\n\r\n    .header_wrap .login_session_box .button_wrap {}\r\n\r\n    .header_wrap .login_session_box .button_wrap button {}\r\n\r\n    .header_wrap .login_session_box .button_wrap button+button {}\r\n\r\n\r\n    /*-------------------- Dashboard page --------------------*/\r\n    .dashboard .sales {}\r\n\r\n    .dashboard .sales .content-wrap {\r\n        flex-direction: column;\r\n    }\r\n\r\n    .dashboard .sales .content-item {\r\n        width: auto !important;\r\n    }\r\n\r\n    .dashboard .sales .content-item+.content-item {\r\n        margin-top: 1rem;\r\n        /* margin-top: 1.375rem; */\r\n    }\r\n\r\n    .dashboard .sales .panel {\r\n        height: auto !important;\r\n        min-height: auto !important;\r\n        column-gap: 1rem;\r\n    }\r\n\r\n    .dashboard .sales .panel ul {}\r\n\r\n    .dashboard .sales .panel ul+ul {}\r\n\r\n    .dashboard .sales .panel ul li {\r\n        /* padding: 1.25rem 1.5rem; */\r\n        padding: 1rem 1rem;\r\n    }\r\n\r\n    .dashboard .sales .panel ul li:first-child {}\r\n\r\n    .dashboard .sales .panel ul li:last-child {}\r\n\r\n    .dashboard .sales .panel ul li .calc-title {\r\n        font-size: 1rem;\r\n    }\r\n\r\n    .dashboard .sales .panel ul li .calc-item {}\r\n\r\n    .dashboard .sales .panel ul li .calc-item money {\r\n        font-size: 1rem;\r\n        /* font-size: 1.3rem; */\r\n    }\r\n\r\n    .dashboard .sales .panel ul li .cancelation {}\r\n\r\n    .dashboard .sales .panel .em li:first-child {}\r\n\r\n    .dashboard .sales .panel .em li:first-child .calc-title {}\r\n\r\n    .dashboard .sales .panel .em li:first-child .calc-item money {}\r\n\r\n    .dashboard .sales .panel .em li:first-child .calc-item span {}\r\n\r\n    .dashboard .sales .panel ul li+li {}\r\n\r\n    .dashboard .sales .panel li+li .calc-title {\r\n        font-size: .8rem;\r\n        /* font-size: .875rem; */\r\n    }\r\n\r\n    .dashboard .sales .panel li+li .calc-item money {\r\n        font-size: .95rem;\r\n        /* font-size: 1rem; */\r\n        /* font-size: 1.25rem; */\r\n    }\r\n\r\n    .dashboard .sales .panel li+li .calc-item span {}\r\n\r\n    .dashboard .sales .panel li+li~li {}\r\n\r\n\r\n\r\n\r\n    /*-------------------- Tabulator --------------------*/\r\n    .tabulator {\r\n        /* height: calc(100dvh - 11rem); */\r\n        /* height: calc(100dvh - 14rem); */\r\n        /* height: 580px; */\r\n    }\r\n\r\n    .tabulator-row .tabulator-cell {\r\n        /* height: 2rem !important; */\r\n        line-height: 1.2rem !important;\r\n        padding-top: .59375rem;\r\n        padding-bottom: .59375rem;\r\n    }\r\n\r\n\r\n\r\n    .tabulator .tabulator-footer {}\r\n\r\n    .form_filter {}\r\n\r\n    .form_filter::after {}\r\n\r\n    .form_filter form {\r\n        column-gap: 1.75rem\r\n    }\r\n\r\n    .form_filter .input_row {}\r\n\r\n    .form_filter .input_row+.input_row {}\r\n\r\n    .form_filter .input_row label {}\r\n\r\n    .form_filter .input_wrap {}\r\n\r\n    .form_filter .input_item {}\r\n\r\n    .form_filter .input_item input {}\r\n\r\n    .form_filter .input_item select {}\r\n\r\n    .form_filter .input_item .datepicker {}\r\n\r\n    .form_filter .input_row.flex {}\r\n\r\n    .form_filter .input_row.flex label {}\r\n\r\n    .form_filter .input_row.flex .input_wrap {}\r\n\r\n    .form_filter .input_item.flex {}\r\n\r\n    .form_filter .input_item.flex select {}\r\n\r\n    .form_filter .input_item.flex input {}\r\n\r\n    .form_filter .button_wrap {}\r\n\r\n    .form_filter .button_wrap button {}\r\n\r\n    .form_filter .button_wrap.separate {\r\n        /* margin-left: 30%; */\r\n    }\r\n\r\n    .form_filter .button_wrap button.on-pc {\r\n        display: inline-flex;\r\n    }\r\n\r\n    .tabulator_sorting_wrap {}\r\n\r\n    .tabulator_sorting_wrap .excel_download {}\r\n\r\n    .tabulator_sorting_wrap .excel_download button {}\r\n\r\n    .tabulator_sorting_wrap .excel_download button:hover {}\r\n\r\n    .tabulator_sorting_wrap .excel_download button svg {}\r\n\r\n    .tabulator_sorting_wrap .rows_per_page {}\r\n\r\n    .tabulator_sorting_wrap .rows_per_page select {}\r\n\r\n    .tabulator_sorting_wrap {}\r\n\r\n    .tabulator_sorting_wrap .excel_download {}\r\n\r\n    .tabulator_sorting_wrap .excel_download button {}\r\n\r\n    .tabulator_sorting_wrap .excel_download button:hover {}\r\n\r\n    .tabulator_sorting_wrap .excel_download button svg {}\r\n\r\n    .tabulator_sorting_wrap .rows_per_page {}\r\n\r\n    .tabulator_sorting_wrap .rows_per_page select {}\r\n\r\n    .tabulator_sorting_wrap .rows_per_page.on-pc {\r\n        display: block;\r\n    }\r\n\r\n    .tabulator_summary_wrap {\r\n        margin-bottom: .5rem;\r\n        height: 36px;\r\n    }\r\n\r\n    .tabulator_summary_wrap .input_wrap {\r\n        flex-direction: row;\r\n        flex-basis: 13.75rem;\r\n        flex-grow: 0;\r\n        column-gap: 0.5rem;\r\n        padding: .5rem 1rem;\r\n    }\r\n\r\n    .tabulator_summary_wrap .input_wrap label {}\r\n\r\n    .tabulator_summary_wrap .input_wrap input {\r\n        padding: 0;\r\n        text-align: right;\r\n    }\r\n\r\n    .tabulator_total_cnt_wrap {\r\n        position: absolute;\r\n        right: 1.5rem;\r\n        margin: 0;\r\n        padding: 0;\r\n    }\r\n\r\n    .tabulator_total_cnt_wrap input {\r\n        padding: 0;\r\n        border-radius: 0;\r\n        background: none;\r\n        font-size: 1rem;\r\n        text-align: right;\r\n    }\r\n\r\n    .tabulator_total_cnt_wrap input:focus {}\r\n\r\n    .tabulator_summary_wrap .tabulator_total_cnt_wrap {\r\n        right: 0;\r\n        width: auto;\r\n    }\r\n\r\n    .tabulator_sorting_wrap .excel_download .tabulator_total_cnt_wrap {}\r\n\r\n    .tabulator_sorting_wrap .excel_download .tabulator_total_cnt_wrap input {}\r\n\r\n\r\n\r\n\r\n    /*-------------------- Admin page --------------------*/\r\n\r\n    /*-------------------- MultiSelect Custom 2022.11.29--------------------*/\r\n\r\n    .admin-wrap .form_filter #merchant-search-list-wrap {\r\n        max-width: 25rem;\r\n    }\r\n\r\n    .admin-wrap .form_filter #merchant-search-list-wrap+.input_row {}\r\n\r\n    .admin-wrap .form_filter .button_wrap {\r\n        max-width: 12rem;\r\n    }\r\n\r\n    .admin-wrap .form_filter .button_wrap+.button_wrap {\r\n        max-width: 20rem;\r\n    }\r\n\r\n    .multiselect__wrapper {}\r\n\r\n    .multiselect__wrapper>span {}\r\n\r\n    .multiselect__wrapper>span::after {}\r\n\r\n    .multiselect__wrapper .multiselect__input {}\r\n\r\n    .multiselect__wrapper .multiselect__clear-btn {}\r\n\r\n    .multiselect__wrapper .multiselect__clear-btn::before {}\r\n\r\n    .multiselect__wrapper .multiselect__clear-btn svg {}\r\n\r\n    .multiselect__wrapper .multiselect__selected {}\r\n\r\n    .multiselect__wrapper .multiselect__selected::after {}\r\n\r\n    .multiselect__wrapper .multiselect__remove-btn {}\r\n\r\n    .multiselect__wrapper .multiselect__remove-btn svg {}\r\n\r\n\r\n\r\n\r\n\r\n    /*-------------------- Payment page --------------------*/\r\n    .payment .inner-wrap {\r\n        display: block;\r\n    }\r\n\r\n    .payment .tab-wrap {\r\n        max-width: none;\r\n        border: none;\r\n    }\r\n\r\n    .payment .tab-wrap li:nth-child(1) {\r\n        width: 33rem;\r\n    }\r\n\r\n    .payment .tab-wrap li a {\r\n        padding: 0;\r\n        font-size: 1.0625rem;\r\n        cursor: auto;\r\n    }\r\n\r\n    .payment .tab-wrap li.current:before {\r\n        opacity: 0;\r\n    }\r\n\r\n    .payment .content-wrap {\r\n        display: flex;\r\n        max-width: none;\r\n        padding: .5rem 0 0 !important;\r\n    }\r\n\r\n    .payment .intro-y {\r\n        width: 100%;\r\n        height: calc(100dvh - 14rem);\r\n        margin-left: 0;\r\n        padding: 2rem 1rem 1rem;\r\n        background: #fff;\r\n        overflow-y: auto;\r\n    }\r\n\r\n    /* Payment - payForm */\r\n    .payment .content-wrap .payForm {\r\n        display: block;\r\n        width: 30rem;\r\n        flex-shrink: 0;\r\n        box-shadow: 0 .25rem 1.25rem rgba(0, 0, 0, .04);\r\n        overflow-y: hidden;\r\n    }\r\n\r\n    .payment .intro-y {\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n        top: 0;\r\n    }\r\n\r\n    .payment .payForm .input {\r\n        margin: 0 .75rem 1.375rem;\r\n    }\r\n\r\n    .payment .payForm .input:nth-child(1) {\r\n        width: calc(60% - 1.5rem);\r\n    }\r\n\r\n    .payment .payForm .input:nth-child(2) {\r\n        width: calc(40% - 1.5rem);\r\n    }\r\n\r\n    .payment .payForm .input:nth-child(3) {\r\n        width: calc(60% - 1.5rem);\r\n    }\r\n\r\n    .payment .payForm .input:nth-child(4) {\r\n        width: calc(40% - 1.5rem);\r\n    }\r\n\r\n    .payment .payForm .input:nth-child(5) {\r\n        width: calc(60% - 1.5rem);\r\n    }\r\n\r\n    .payment .payForm .input:nth-child(6) {\r\n        width: calc(40% - 1.5rem);\r\n    }\r\n\r\n    .payment .payForm .input:nth-child(7) {\r\n        width: calc(50% - 1.5rem);\r\n    }\r\n\r\n    .payment .payForm .input:nth-child(8) {\r\n        width: calc(50% - 1.5rem);\r\n    }\r\n\r\n    .payment .payForm .input:nth-child(9) {\r\n        width: calc(70% - 1.5rem);\r\n    }\r\n\r\n    .payment .payForm .input:nth-child(10) {\r\n        width: calc(30% - 1.5rem);\r\n    }\r\n\r\n    .payment .payForm .input:nth-child(11) {\r\n        width: calc(40% - 1.5rem);\r\n    }\r\n\r\n    .payment .payForm .input:nth-child(12) {\r\n        width: calc(30% - 1.5rem);\r\n    }\r\n\r\n    .payment .payForm .input:nth-child(13) {\r\n        width: calc(30% - 1.5rem);\r\n    }\r\n\r\n    /* Payment - cardInfo */\r\n    .payment .content-wrap .cardInfo {\r\n        display: block;\r\n        width: calc(100% - 33rem);\r\n        max-width: none;\r\n        margin-left: 3rem;\r\n        padding: 2rem 1.75rem 1rem;\r\n        box-shadow: 0 .25rem 1.25rem rgba(0, 0, 0, .04);\r\n    }\r\n\r\n    .payment .cardInfo .tabulator-header {\r\n        border-top-width: .0625rem;\r\n        border-bottom-width: .0625rem;\r\n    }\r\n\r\n    .payment .cardInfo .tabulator-headers>div:nth-child(1) {\r\n        display: inline-block;\r\n    }\r\n\r\n    .payment .cardInfo .tabulator-headers>div:nth-child(2) .tabulator-col-content {\r\n        margin: 0;\r\n        text-align: left;\r\n    }\r\n\r\n    .payment .cardInfo .tabulator-headers>div:nth-child(2) .tabulator-col-sorter {\r\n        margin: 0;\r\n    }\r\n\r\n    .payment .cardInfo .tabulator-headers>div:nth-child(2) .tabulator-col-title {\r\n        font-size: .875rem;\r\n        font-weight: normal;\r\n    }\r\n\r\n    .payment .cardInfo .tabulator-tableHolder {\r\n        margin: 0;\r\n    }\r\n\r\n    .payment .cardInfo .tabulator-tableHolder .tabulator-table {\r\n        width: auto;\r\n        background: #fff;\r\n    }\r\n\r\n    .payment .cardInfo .tabulator-row,\r\n    .payment .cardInfo .tabulator-row.tabulator-row-even {\r\n        margin: 0;\r\n        background: none;\r\n        border-radius: 0;\r\n        border-bottom-width: .0625rem;\r\n    }\r\n\r\n    .payment .cardInfo .tabulator-row:nth-child(even) {\r\n        background: #f1f5f9;\r\n    }\r\n\r\n    .payment .cardInfo .tabulator-row .tabulator-cell {\r\n        height: 3.125rem !important;\r\n        font-weight: normal;\r\n    }\r\n\r\n\r\n\r\n\r\n\r\n    /*-------------------- Calendar page --------------------*/\r\n    .calendar {\r\n        padding: 1.5rem 2rem 1rem;\r\n    }\r\n\r\n    .calendar .main-title-wrap {\r\n        max-width: none;\r\n        border: none;\r\n    }\r\n\r\n    .calendar .main-title-wrap .title {\r\n        padding: 0;\r\n        font-size: 1.0625rem;\r\n    }\r\n\r\n    .calendar .main-title-wrap .title:before {\r\n        opacity: 0;\r\n    }\r\n\r\n    .calendar .content-wrap {\r\n        flex-direction: row;\r\n        padding: .5rem 0 2rem;\r\n    }\r\n\r\n    .calendar .content-wrap .content-col {\r\n        max-width: none;\r\n    }\r\n\r\n    .calendar .content-wrap .content-col.left {\r\n        width: 26rem;\r\n        padding: 0;\r\n        order: 1;\r\n    }\r\n\r\n    .calendar .content-wrap .content-col.right {\r\n        margin-left: 0px;\r\n        width: calc(100% - 29rem);\r\n        height: calc(100dvh - 14rem);\r\n        padding: 1.5rem 2rem 2rem;\r\n        border-radius: .375rem;\r\n        box-shadow: 0 .25rem 1.25rem rgb(0 0 0 / 4%);\r\n        background: #fff;\r\n        overflow-y: auto;\r\n    }\r\n\r\n    .calendar .content-wrap .content-col.right::-webkit-scrollbar {\r\n        display: block;\r\n        width: 1.125rem;\r\n    }\r\n\r\n    .calendar .content-wrap .content-col.right::-webkit-scrollbar-thumb {\r\n        height: 15%;\r\n        border: .375rem solid transparent;\r\n        background-clip: content-box;\r\n        background-color: rgba(0, 0, 0, .25);\r\n        border-radius: 1.125rem;\r\n    }\r\n\r\n    .calendar .content-wrap .content-col.right::-webkit-scrollbar-track {\r\n        background-color: rgba(0, 0, 0, 0);\r\n    }\r\n\r\n    .calendar .content-wrap .content-item {\r\n        margin: 0;\r\n    }\r\n\r\n    /* calendar - chat box */\r\n    .calendar .chat__box {\r\n        margin-top: 1.5rem;\r\n    }\r\n\r\n    .calendar .chat__box .cal-chat-wrap:before {\r\n        display: none;\r\n    }\r\n\r\n    .calendar .chat__box .title-wrap {\r\n        border: none;\r\n        box-shadow: 0 .25rem .5rem rgb(0 0 0 / 12%);\r\n    }\r\n\r\n    .calendar .chat__box .title-wrap .btn-notice button {\r\n        font-size: .875rem;\r\n    }\r\n\r\n    .calendar .chat__box .notice-wrap {\r\n        position: absolute;\r\n        top: 4.25rem;\r\n        left: 0;\r\n        right: 0;\r\n        border-top: .0625rem solid #ddd;\r\n        border-bottom: 0;\r\n        box-shadow: 0 .25rem .5rem rgb(0 0 0 / 12%);\r\n        z-index: 1;\r\n    }\r\n\r\n    .calendar .chat__box .chat-container {\r\n        height: calc(100dvh - 21.8125rem);\r\n        max-height: none;\r\n        min-height: auto;\r\n    }\r\n\r\n    /* calendar - calendar */\r\n    .calendar .calendar-category-wrap {\r\n        right: 2rem;\r\n    }\r\n\r\n    .calendar .calendar-category-wrap li {\r\n        margin: 0 .875rem;\r\n    }\r\n\r\n    .calendar .full-calendar .fc-header-toolbar .fc-left {\r\n        width: 10rem;\r\n    }\r\n\r\n    .calendar .full-calendar .fc-header-toolbar .fc-left h2 {\r\n        font-size: 1.125rem;\r\n    }\r\n\r\n    .calendar .full-calendar .fc-header-toolbar .fc-right .fc-button-group {\r\n        width: 14.5rem;\r\n    }\r\n\r\n    .calendar .full-calendar .fc-view-container .fc-view .fc-body .fc-row {\r\n        min-height: 7rem;\r\n    }\r\n\r\n    .calendar .full-calendar .fc-view-container .fc-view .fc-body .fc-content-skeleton tbody td .fc-day-grid-event {\r\n        padding: .0625rem .375rem;\r\n    }\r\n\r\n    .calendar .full-calendar .fc-view-container .fc-view .fc-body .fc-content-skeleton tbody td .fc-day-grid-event .fc-content span {\r\n        font-size: .8125rem;\r\n    }\r\n\r\n\r\n\r\n\r\n\r\n    /*-------------------- Invitation page --------------------*/\r\n    /* invitation - reset */\r\n    .invitation {\r\n        /*height: calc(100dvh - 9rem);*/\r\n        padding: 1.5rem 1rem 0;\r\n    }\r\n\r\n    .invitation .inner-wrap {\r\n        display: block;\r\n    }\r\n\r\n    .invitation .tab-wrap {\r\n        max-width: none;\r\n        border: none;\r\n    }\r\n\r\n    .invitation .tab-wrap li:nth-child(1) {\r\n        width: 23rem;\r\n    }\r\n\r\n    .invitation .tab-wrap li a {\r\n        padding: 0;\r\n        font-size: 1.0625rem;\r\n        cursor: auto;\r\n    }\r\n\r\n    .invitation .tab-wrap li.current:before {\r\n        opacity: 0;\r\n    }\r\n\r\n    .invitation .content-wrap {\r\n        display: flex;\r\n        max-width: none;\r\n        padding: .5rem 0 2rem;\r\n    }\r\n\r\n    /* invitation - invitationForm */\r\n    .invitation .content-wrap .invitationForm {\r\n        display: block;\r\n        flex-shrink: 0;\r\n        position: relative;\r\n        width: 20rem;\r\n        padding: 1.2rem 1.2rem 3.5rem;\r\n        border-radius: 1.625rem;\r\n        background: #454545;\r\n    }\r\n\r\n    .invitation .content-wrap .invitationForm:before,\r\n    .content-wrap .invitationForm:after {\r\n        content: \"\";\r\n        position: absolute;\r\n        top: 0;\r\n        left: 0;\r\n        right: 0;\r\n        bottom: 0;\r\n        box-sizing: border-box;\r\n        border-radius: inherit;\r\n        pointer-events: none;\r\n    }\r\n\r\n    .invitation .content-wrap .invitationForm:before {\r\n        box-shadow: inset 0 0 .6rem rgba(0, 0, 0, .5);\r\n        z-index: 1;\r\n    }\r\n\r\n    .invitation .content-wrap .invitationForm:after {\r\n        border: 1.2rem solid #454545;\r\n        border-bottom-width: 3.5rem;\r\n    }\r\n\r\n    .invitation .content-wrap .mobile-button-shape1:before,\r\n    .content-wrap .mobile-button-shape1:after,\r\n    .content-wrap .mobile-button-shape2:before,\r\n    .content-wrap .mobile-button-shape2:after {\r\n        content: \"\";\r\n        position: absolute;\r\n        box-sizing: border-box;\r\n        pointer-events: none;\r\n    }\r\n\r\n    .invitation .content-wrap .mobile-button-shape1:before,\r\n    .content-wrap .mobile-button-shape2:before,\r\n    .content-wrap .mobile-button-shape2:after {\r\n        width: .375rem;\r\n        height: 3rem;\r\n        top: 30%;\r\n        left: -.1875rem;\r\n        background: #454545;\r\n        border-radius: .1875rem;\r\n    }\r\n\r\n    .invitation .content-wrap .mobile-button-shape1:after {\r\n        left: 50%;\r\n        bottom: .6875rem;\r\n        transform: translateX(-50%);\r\n        width: 2.125rem;\r\n        height: 2.125rem;\r\n        border-radius: 50%;\r\n        background: #767676;\r\n        z-index: 1;\r\n    }\r\n\r\n    .invitation .content-wrap .mobile-button-shape2:before {\r\n        height: 2.25rem;\r\n        margin-top: -4rem;\r\n    }\r\n\r\n    .invitation .content-wrap .mobile-button-shape2:after {\r\n        height: 2.25rem;\r\n        margin-top: -7rem;\r\n    }\r\n\r\n    .invitation .content-wrap .invitation-search-form {\r\n        height: 100%;\r\n        min-height: 32.5rem;\r\n        padding: 1rem;\r\n        border-radius: .5rem;\r\n        background: #fff;\r\n        overflow: hidden;\r\n    }\r\n\r\n    /* invitation - userInfo */\r\n    .invitation .content-wrap .userInfo {\r\n        display: block;\r\n        width: calc(100% - 23rem);\r\n        max-width: none;\r\n        margin-left: 3rem;\r\n        padding: 2rem;\r\n        box-shadow: 0 .25rem 1.25rem rgb(0 0 0 / 4%);\r\n        background: #fff;\r\n        overflow-y: auto;\r\n    }\r\n\r\n    .invitation .userInfo .admin-search-form {\r\n        padding: 0;\r\n        border-radius: 0;\r\n        box-shadow: none;\r\n        background: none;\r\n    }\r\n\r\n    .invitation .userInfo .admin-search-form:after {\r\n        display: none;\r\n    }\r\n\r\n    .invitation .userInfo .search-wrap .input {\r\n        flex-direction: row;\r\n        align-items: center;\r\n        width: auto;\r\n    }\r\n\r\n    .invitation .userInfo .search-wrap .input>label {\r\n        margin: 0 .75rem 0 0;\r\n        text-align: right;\r\n        white-space: nowrap;\r\n    }\r\n\r\n    .invitation .userInfo .search-wrap .input:nth-child(2),\r\n    .userInfo .search-wrap .input:nth-child(2) input {\r\n        width: auto;\r\n    }\r\n\r\n    .invitation .userInfo .merchant-send-list-box,\r\n    .userInfo .merchant-search-list-box {\r\n        width: auto;\r\n    }\r\n\r\n    .invitation .userInfo .user-list {\r\n        margin-top: 1rem;\r\n    }\r\n\r\n    .invitation .userInfo .tabulator .tabulator-header {\r\n        border-top-width: .0625rem;\r\n        border-bottom-width: .0625rem;\r\n    }\r\n\r\n    .invitation .userInfo .tabulator .tabulator-tableHolder .tabulator-table {\r\n        background: #fff;\r\n    }\r\n\r\n    .invitation .userInfo .tabulator .tabulator-row {\r\n        margin: 0;\r\n        border-radius: 0;\r\n        border-bottom-width: .0625rem;\r\n        background: none;\r\n    }\r\n\r\n    .invitation .userInfo .tabulator .tabulator-row:nth-child(even) {\r\n        background: #f1f5f9;\r\n    }\r\n\r\n    .invitation .userInfo .tabulator .tabulator-row:hover {\r\n        background-color: rgb(var(--color-slate-200) / var(--tw-bg-opacity));\r\n    }\r\n\r\n    .invitation .userInfo .tabulator .tabulator-row .tabulator-cell {\r\n        font-weight: normal;\r\n    }\r\n\r\n\r\n\r\n\r\n\r\n    /*-------------------- Dashboard page --------------------*/\r\n    .dashboard.inner-wrap {\r\n        flex-direction: row;\r\n        align-items: flex-start;\r\n        padding-top: .5rem;\r\n    }\r\n\r\n    .dashboard .content-container {\r\n        max-width: none;\r\n        height: calc(100dvh - 9rem);\r\n        padding: .5rem 0 0;\r\n    }\r\n\r\n    .dashboard .content-container.c-left {\r\n        width: 100%;\r\n        max-width: 1400px;\r\n        /* padding-right: 2rem; */\r\n    }\r\n\r\n    .dashboard .content-wrap {\r\n        display: flex;\r\n    }\r\n\r\n    .dashboard .content-wrap .content-item {\r\n        width: 100%;\r\n    }\r\n\r\n    .dashboard .content-container.c-left .content-wrap:nth-child(1) {\r\n        margin-bottom: 1rem;\r\n    }\r\n\r\n    .dashboard .content-container.c-left+.content-container {\r\n        width: 30%;\r\n    }\r\n\r\n    .dashboard .content-container.c-left .content-wrap:nth-child(1) .content-item {\r\n        width: 50%;\r\n        /* margin-right: 2rem; */\r\n    }\r\n\r\n    .dashboard .content-container.c-left .content-wrap:nth-child(2) .content-item:nth-child(1) {\r\n        width: 60%;\r\n        margin-right: 2rem;\r\n    }\r\n\r\n    .dashboard .content-container.c-left .content-wrap:nth-child(2) .content-item:nth-child(2) {\r\n        width: 40%;\r\n        margin-right: 2rem;\r\n    }\r\n\r\n    .dashboard .main-title-wrap {\r\n        border: none;\r\n    }\r\n\r\n    .dashboard .main-title-wrap .title {\r\n        padding: 0;\r\n        font-size: 1.0625rem;\r\n    }\r\n\r\n    .dashboard .main-title-wrap .title:before {\r\n        opacity: 0;\r\n    }\r\n\r\n    .dashboard .panel {\r\n        margin: .25rem 0 0;\r\n    }\r\n\r\n    .dashboard .content-container.c-left .content-wrap:nth-child(1) .panel {\r\n        height: calc(50vh - 13rem);\r\n        min-height: 12rem;\r\n    }\r\n\r\n    .dashboard .content-container.c-left .content-wrap:nth-child(2) .panel {\r\n        height: calc(50vh - 6rem);\r\n        min-height: 19rem;\r\n    }\r\n\r\n    .dashboard .calc-table {\r\n        height: 100%;\r\n    }\r\n\r\n    .dashboard .calc-table li {\r\n        /*height: calc(50% - .5rem);*/\r\n        margin: 0 .5rem;\r\n        padding: 1rem 1.25rem;\r\n    }\r\n\r\n    .dashboard .calc-table li:nth-child(n + 3) {\r\n        margin-top: 1rem;\r\n    }\r\n\r\n    .dashboard .calc-table li .calc-title {\r\n        font-size: .8125rem;\r\n    }\r\n\r\n    .dashboard .dailyStatsChart {\r\n        /*height: 100%*/\r\n    }\r\n\r\n    .dashboard .monthlyStatsChart {\r\n        height: 100%;\r\n        padding: 2rem 2rem 1.5rem 1.5rem;\r\n    }\r\n\r\n    .dashboard .branchList {\r\n        height: calc(50vh - 6rem);\r\n        min-height: 19rem;\r\n        margin: .25rem 0 0;\r\n    }\r\n\r\n    .dashboard .branchList>div {\r\n        height: 20%;\r\n    }\r\n\r\n    .dashboard .branchList>div+div {\r\n        margin-top: .125rem;\r\n    }\r\n\r\n    .dashboard .branchList .box {\r\n        height: calc(100% - .5rem);\r\n        min-height: auto;\r\n        padding: 0 1.375rem;\r\n    }\r\n\r\n    .dashboard .branchList .box>div span {\r\n        top: -.1875rem;\r\n        width: 2rem;\r\n        height: 2rem;\r\n        margin-right: .75rem;\r\n        line-height: 1.5625rem;\r\n    }\r\n\r\n    .dashboard .branchList .box>div span:after {\r\n        top: 1.25rem;\r\n    }\r\n\r\n    .dashboard .content-container.c-left+.content-container .content-wrap .panel {\r\n        height: calc(100dvh - 13.75rem);\r\n        min-height: 36.25rem;\r\n    }\r\n\r\n    .dashboard .notice-wrap {\r\n        height: 100%;\r\n    }\r\n\r\n    .dashboard .notice-wrap>div {\r\n        height: 62.5rem;\r\n        /* height: calc(50% - .75rem); */\r\n        min-height: auto;\r\n        padding: 1.25rem;\r\n    }\r\n\r\n    .dashboard .notice-wrap .text-slate-500 {\r\n        line-height: 1.4;\r\n    }\r\n}\r\n\r\n@media (max-width: 640px) {\r\n    .dashboard .sales .panel {\r\n        gap: 0.5rem;\r\n    }\r\n\r\n    .dashboard .sales .panel ul {\r\n        width: 100%;\r\n        /* width: calc((100% - 1rem) / 2); */\r\n    }\r\n\r\n    .dashboard .sales .panel ul li+li {\r\n        /* flex-direction: column; */\r\n        align-items: unset;\r\n    }\r\n}\r\n\r\n@media (max-width: 450px) {\r\n    .dashboard .sales .panel ul li .calc-item money {\r\n        font-size: 1rem;\r\n    }\r\n\r\n    .dashboard .sales .panel li+li .calc-item money {\r\n        font-size: 1rem;\r\n    }\r\n\r\n    .list-info-box .gap ul li .left-text {\r\n        padding: 6px 0px 6px 6px !important;\r\n        font-weight: bold;\r\n    }\r\n\r\n    .list-info-box .gap ul li .right-text {\r\n        padding: 6px 0px 6px 6px !important;\r\n    }\r\n\r\n    .infoFooter {\r\n        font-size: 10px !important;\r\n    }\r\n\r\n    .font9 {\r\n        font-size: 9.5px !important;\r\n    }\r\n}\r\n\r\n.tabulator-tableHolder {\r\n    /* height: auto !important; */\r\n}\r\n\r\n/* loading 시작 */\r\n.pay_loading_wrap {\r\n    /* display: none; */\r\n    width: 100%;\r\n    height: 100%;\r\n    min-width: 100vw;\r\n    min-height: 100dvh;\r\n\r\n    background: rgb(0 0 0 / 65%);\r\n\r\n    position: fixed;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    z-index: 60;\r\n}\r\n\r\n.pay_loading_wrap .pay_loading {\r\n    /* border-radius: 110px; */\r\n    overflow: hidden;\r\n\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n}\r\n\r\n/* loading 끝 */\r\n\r\n/* alert modal, confirm modal START */\r\n.modal .modal-footer .btn_ok {\r\n    color: #fff;\r\n    background-color: #434242;\r\n}\r\n\r\n/* alert modal, confirm modal END */\r\n\r\n.backgroud_trans_form {\r\n    animation: transBGColor 0.7s ease-in infinite alternate;\r\n}\r\n\r\n.BG_trans_white {\r\n    background: white;\r\n    color: rgb(var(--color-slate-500) / var(--tw-text-opacity));\r\n}\r\n\r\n.BG_trans_green {\r\n    background: #434242;\r\n    color: white;\r\n}\r\n\r\n.BG_trans_green:hover {\r\n    background: #222222 !important;\r\n    color: white !important;\r\n}\r\n\r\n/* 지갑잔액현황 헤더 필터 placeholder */\r\n.wallet-header-filter::placeholder {\r\n    color: rgba(255, 255, 255, 0.7);\r\n    opacity: 1;\r\n}\r\n\r\n/* PG 헤더 툴팁 */\r\n.pg-header-wrap .pg-help-icon:hover + .pg-tooltip,\r\n.pg-header-wrap .pg-tooltip:hover {\n    display: block !important;\n}\n\n/* Header-only visual scaling compensates for transparent padding in tenant logos. */\n.top-bar-boxed[data-tenant-brand=\"베리타스온\"] .header_wrap .logo,\n.top-bar-boxed[data-tenant-brand=\"제이엠솔루션\"] .header_wrap .logo,\n.top-bar-boxed[data-tenant-brand=\"바로몰\"] .header_wrap .logo,\n.mobile-menu[data-tenant-brand=\"베리타스온\"] .main_logo,\n.mobile-menu[data-tenant-brand=\"제이엠솔루션\"] .main_logo,\n.mobile-menu[data-tenant-brand=\"바로몰\"] .main_logo {\n    overflow: visible;\n}\n\n.top-bar-boxed[data-tenant-brand=\"베리타스온\"] .header_wrap .logo img,\n.top-bar-boxed[data-tenant-brand=\"제이엠솔루션\"] .header_wrap .logo img,\n.top-bar-boxed[data-tenant-brand=\"바로몰\"] .header_wrap .logo img,\n.mobile-menu[data-tenant-brand=\"베리타스온\"] .main_logo img,\n.mobile-menu[data-tenant-brand=\"제이엠솔루션\"] .main_logo img,\n.mobile-menu[data-tenant-brand=\"바로몰\"] .main_logo img {\n    position: static;\n    transform-origin: center;\n    pointer-events: none;\n}\n\n.top-bar-boxed[data-tenant-brand=\"베리타스온\"] .header_wrap .logo img {\n    transform: scale(1.65);\n}\n\n.top-bar-boxed[data-tenant-brand=\"제이엠솔루션\"] .header_wrap .logo img {\n    transform: scale(2.6);\n}\n\n.top-bar-boxed[data-tenant-brand=\"바로몰\"] .header_wrap .logo img {\n    transform: scale(3.7);\n}\n\n.mobile-menu[data-tenant-brand=\"베리타스온\"] .main_logo img {\n    transform: scale(2.3);\n}\n\n.mobile-menu[data-tenant-brand=\"제이엠솔루션\"] .main_logo img {\n    transform: scale(3.7);\n}\n\n.mobile-menu[data-tenant-brand=\"바로몰\"] .main_logo img {\n    transform: scale(5.3);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
